// @generated by protobuf-ts 2.6.0
// @generated from protobuf file "VPU.proto" (package "VpuGrpc", syntax proto3)
// tslint:disable
import { CHUProgressUpdate } from "./Common";
import { CommonStatus } from "./Common";
import { Empty } from "./Common";
import { VPUStatus } from "./Common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { DataChunkMessage } from "./Common";
import { VenueCalibrationData } from "./Common";
import { RtspLinkInfo } from "./Common";
import { CameraStatus } from "./Common";
import { AdapterStatus } from "./Common";
/**
 * @generated from protobuf message VpuGrpc.FeedSourceLockRequest
 */
export interface FeedSourceLockRequest {
    /**
     * @generated from protobuf field: VpuGrpc.PipFeedSource source = 1;
     */
    source: PipFeedSource;
}
/**
 * @generated from protobuf message VpuGrpc.ChuOcrFrameResponse
 */
export interface ChuOcrFrameResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string frame = 2;
     */
    frame: string; // base64-encoded JPEG of the warped scoreboard crop
    /**
     * @generated from protobuf field: VpuGrpc.OcrDataMessage scoreboardData = 3;
     */
    scoreboardData?: OcrDataMessage;
}
/**
 * @generated from protobuf message VpuGrpc.CoordinatesType
 */
export interface CoordinatesType {
    /**
     * @generated from protobuf field: VpuGrpc.CoordinatesType.CoorType type = 1;
     */
    type: CoordinatesType_CoorType;
}
/**
 * @generated from protobuf enum VpuGrpc.CoordinatesType.CoorType
 */
export enum CoordinatesType_CoorType {
    /**
     * @generated from protobuf enum value: FULL_SB = 0;
     */
    FULL_SB = 0,
    /**
     * @generated from protobuf enum value: INNER_FIELDS = 1;
     */
    INNER_FIELDS = 1,
    /**
     * @generated from protobuf enum value: ALL = 2;
     */
    ALL = 2
}
/**
 * @generated from protobuf message VpuGrpc.ServiceName
 */
export interface ServiceName {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
}
/**
 * @generated from protobuf message VpuGrpc.PipMarkAndSaveOcrCalibrationResponse
 */
export interface PipMarkAndSaveOcrCalibrationResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
}
/**
 * @generated from protobuf message VpuGrpc.OcrAiCalibrateRequest
 */
export interface OcrAiCalibrateRequest {
    /**
     * @generated from protobuf field: string sportType = 1;
     */
    sportType: string;
}
/**
 * @generated from protobuf message VpuGrpc.OcrAiCalibrateResponse
 */
export interface OcrAiCalibrateResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message VpuGrpc.OcrAiSetSportTypeRequest
 */
export interface OcrAiSetSportTypeRequest {
    /**
     * @generated from protobuf field: string sportType = 1;
     */
    sportType: string;
}
/**
 * @generated from protobuf message VpuGrpc.OcrAiSetSportTypeResponse
 */
export interface OcrAiSetSportTypeResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message VpuGrpc.OcrAiSetSwapHomeAwayRequest
 */
export interface OcrAiSetSwapHomeAwayRequest {
    /**
     * @generated from protobuf field: bool swap = 1;
     */
    swap: boolean;
}
/**
 * @generated from protobuf message VpuGrpc.OcrAiSetSwapHomeAwayResponse
 */
export interface OcrAiSetSwapHomeAwayResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message VpuGrpc.WifiHotspotDetails
 */
export interface WifiHotspotDetails {
    /**
     * @generated from protobuf field: string pn = 1;
     */
    pn: string;
    /**
     * @generated from protobuf field: string sn = 2;
     */
    sn: string;
}
/**
 * @generated from protobuf message VpuGrpc.CameraPartNumber
 */
export interface CameraPartNumber {
    /**
     * @generated from protobuf field: string pn = 1;
     */
    pn: string;
}
/**
 * @generated from protobuf message VpuGrpc.SystemLifeCycleStatus
 */
export interface SystemLifeCycleStatus {
    /**
     * @generated from protobuf field: string status = 1;
     */
    status: string;
}
/**
 * @generated from protobuf message VpuGrpc.PhaseInfoMessage
 */
export interface PhaseInfoMessage {
    /**
     * @generated from protobuf field: int32 phaseNumber = 1;
     */
    phaseNumber: number;
    /**
     * @generated from protobuf field: string phaseName = 2;
     */
    phaseName: string;
    /**
     * @generated from protobuf field: int64 phaseStartTime = 3;
     */
    phaseStartTime: bigint;
}
/**
 * @generated from protobuf message VpuGrpc.SetIsFirstReleaseRequest
 */
export interface SetIsFirstReleaseRequest {
    /**
     * @generated from protobuf field: bool value = 1;
     */
    value: boolean;
}
/**
 * @generated from protobuf message VpuGrpc.LocalLicenseInfoMessage
 */
export interface LocalLicenseInfoMessage {
    /**
     * @generated from protobuf field: string LocalLicenseInfo = 1 [json_name = "LocalLicenseInfo"];
     */
    localLicenseInfo: string;
}
/**
 * @generated from protobuf message VpuGrpc.Streams
 */
export interface Streams {
    /**
     * @generated from protobuf field: repeated VpuGrpc.StreamConfig streams = 1;
     */
    streams: StreamConfig[];
    /**
     * @generated from protobuf field: bool status = 2;
     */
    status: boolean;
}
/**
 * @generated from protobuf message VpuGrpc.IsAdvancedFlag
 */
export interface IsAdvancedFlag {
    /**
     * @generated from protobuf field: bool isAdvnaced = 1;
     */
    isAdvnaced: boolean;
}
/**
 * @generated from protobuf message VpuGrpc.PoeRequestMessage
 */
export interface PoeRequestMessage {
    /**
     * @generated from protobuf field: bool resetPoeRequest = 1;
     */
    resetPoeRequest: boolean;
}
/**
 * @generated from protobuf message VpuGrpc.AudioEnabledMessage
 */
export interface AudioEnabledMessage {
    /**
     * @generated from protobuf field: bool enableAudio = 1;
     */
    enableAudio: boolean;
}
/**
 * @generated from protobuf message VpuGrpc.AudioValueMessage
 */
export interface AudioValueMessage {
    /**
     * @generated from protobuf field: int32 audioValue = 1;
     */
    audioValue: number;
}
/**
 * @generated from protobuf message VpuGrpc.AutoProductionEnabledMessage
 */
export interface AutoProductionEnabledMessage {
    /**
     * @generated from protobuf field: bool enableAutoProduction = 1;
     */
    enableAutoProduction: boolean;
}
/**
 * @generated from protobuf message VpuGrpc.AutoLightControlModeMessage
 */
export interface AutoLightControlModeMessage {
    /**
     * @generated from protobuf field: VpuGrpc.AutoExpoModeEnum autoLightControlMode = 1;
     */
    autoLightControlMode: AutoExpoModeEnum;
}
/**
 * @generated from protobuf message VpuGrpc.EventId
 */
export interface EventId {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message VpuGrpc.StreamConfig
 */
export interface StreamConfig {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string url = 2;
     */
    url: string;
    /**
     * @generated from protobuf field: uint32 index = 3;
     */
    index: number;
    /**
     * @generated from protobuf field: uint32 bandwidth = 4;
     */
    bandwidth: number;
    /**
     * @generated from protobuf field: float fps = 5;
     */
    fps: number;
}
/**
 * @generated from protobuf message VpuGrpc.VPUCCUDataMessage
 */
export interface VPUCCUDataMessage {
    /**
     * @generated from protobuf field: float saturation = 1;
     */
    saturation: number;
    /**
     * float intensity = 2;
     *
     * @generated from protobuf field: float hue = 3;
     */
    hue: number;
    /**
     * @generated from protobuf field: float gamma = 4;
     */
    gamma: number;
    /**
     * @generated from protobuf field: float contrast = 5;
     */
    contrast: number;
    /**
     * @generated from protobuf field: float intensity = 6;
     */
    intensity: number;
    /**
     * @generated from protobuf field: float rx1 = 7;
     */
    rx1: number;
    /**
     * @generated from protobuf field: float rx2 = 8;
     */
    rx2: number;
    /**
     * @generated from protobuf field: float gx1 = 9;
     */
    gx1: number;
    /**
     * @generated from protobuf field: float gx2 = 10;
     */
    gx2: number;
    /**
     * @generated from protobuf field: float bx1 = 11;
     */
    bx1: number;
    /**
     * @generated from protobuf field: float bx2 = 12;
     */
    bx2: number;
    /**
     * @generated from protobuf field: bool success = 13;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string error = 14;
     */
    error: string;
    /**
     * @generated from protobuf field: string panoLocation = 15;
     */
    panoLocation: string;
}
/**
 * @generated from protobuf message VpuGrpc.DriveInformation
 */
export interface DriveInformation {
    /**
     * @generated from protobuf field: string letter = 1;
     */
    letter: string;
    /**
     * @generated from protobuf field: int64 totalSpace = 2;
     */
    totalSpace: bigint; // In MB
    /**
     * @generated from protobuf field: int64 freeSpace = 3;
     */
    freeSpace: bigint; // In MB
    /**
     * @generated from protobuf field: string toolTip = 4;
     */
    toolTip: string;
}
/**
 * @generated from protobuf message VpuGrpc.Vpu2AgentUiGeneralInfo
 */
export interface Vpu2AgentUiGeneralInfo {
    /**
     * @generated from protobuf field: string ap = 1;
     */
    ap: string;
    /**
     * @generated from protobuf field: string alc = 2;
     */
    alc: string;
    /**
     * @generated from protobuf field: string health = 3;
     */
    health: string;
    /**
     * @generated from protobuf field: string prettyReport = 4;
     */
    prettyReport: string;
    /**
     * @generated from protobuf field: uint32 panoStreamKbps = 5;
     */
    panoStreamKbps: number;
    /**
     * @generated from protobuf field: uint32 hdStreamKbps = 6;
     */
    hdStreamKbps: number;
    /**
     * @generated from protobuf field: string autoProductionType = 7;
     */
    autoProductionType: string;
    /**
     * @generated from protobuf field: string vpuInitializationStage = 8;
     */
    vpuInitializationStage: string;
    /**
     * @generated from protobuf field: string panoStreamStatus = 9;
     */
    panoStreamStatus: string;
    /**
     * @generated from protobuf field: string hdStreamStatus = 10;
     */
    hdStreamStatus: string;
    /**
     * @generated from protobuf field: bool maskCrashReport = 11;
     */
    maskCrashReport: boolean;
    /**
     * @generated from protobuf field: double cpuUsage = 12;
     */
    cpuUsage: number;
    /**
     * @generated from protobuf field: repeated VpuGrpc.DriveInformation drives = 13;
     */
    drives: DriveInformation[];
    /**
     * @generated from protobuf field: double gpuUsage = 14;
     */
    gpuUsage: number;
    /**
     * @generated from protobuf field: double cpuTemperature = 15;
     */
    cpuTemperature: number;
    /**
     * @generated from protobuf field: double memoryUsage = 16;
     */
    memoryUsage: number;
    /**
     * @generated from protobuf field: bool backendConnection = 17;
     */
    backendConnection: boolean;
    // 
    // string systemDriveLetter = 17;
    // int64 systemDriveTotalSpace = 18;
    // int64 systemDriveFreeSpace = 19;
    // string storageDriveLetter = 20;
    // int64 storageDriveTotalSpace = 21;
    // int64 storageDriveFreeSpace = 22;

    /**
     * @generated from protobuf field: bool audioStatus = 23;
     */
    audioStatus: boolean;
    /**
     * @generated from protobuf field: int32 alcValue = 24;
     */
    alcValue: number;
    /**
     * @generated from protobuf field: int32 alcHealth = 25;
     */
    alcHealth: number;
    /**
     * @generated from protobuf field: int32 alcDesiredBrightness = 26;
     */
    alcDesiredBrightness: number;
    /**
     * @generated from protobuf field: repeated CommonUsedMessages.AdapterStatus adapterStatus = 27;
     */
    adapterStatus: AdapterStatus[];
    /**
     * @generated from protobuf field: repeated CommonUsedMessages.CameraStatus cameraStatus = 28;
     */
    cameraStatus: CameraStatus[];
}
/**
 * @generated from protobuf message VpuGrpc.Vpu2AgentHealth
 */
export interface Vpu2AgentHealth {
    /**
     * @generated from protobuf field: double healthValue = 1;
     */
    healthValue: number;
    /**
     * @generated from protobuf field: bool status = 2;
     */
    status: boolean;
    /**
     * @generated from protobuf field: string updateTime = 3;
     */
    updateTime: string;
    /**
     * @generated from protobuf field: bool maskCrashReport = 4;
     */
    maskCrashReport: boolean;
}
/**
 * @generated from protobuf message VpuGrpc.Vpu2AgentCameraVersion
 */
export interface Vpu2AgentCameraVersion {
    /**
     * @generated from protobuf field: string version = 1;
     */
    version: string;
}
/**
 * @generated from protobuf message VpuGrpc.ChosenDoublePlayAPCameraMessage
 */
export interface ChosenDoublePlayAPCameraMessage {
    /**
     * @generated from protobuf field: VpuGrpc.ChosenDoublePlayAPCameraMessage.CameraType cameraType = 1;
     */
    cameraType: ChosenDoublePlayAPCameraMessage_CameraType;
}
/**
 * @generated from protobuf enum VpuGrpc.ChosenDoublePlayAPCameraMessage.CameraType
 */
export enum ChosenDoublePlayAPCameraMessage_CameraType {
    /**
     * @generated from protobuf enum value: HEAD_CAMERA = 0;
     */
    HEAD_CAMERA = 0,
    /**
     * @generated from protobuf enum value: AA_CAMERA = 1;
     */
    AA_CAMERA = 1
}
/**
 * @generated from protobuf message VpuGrpc.Agent2VpuReason
 */
export interface Agent2VpuReason {
    /**
     * @generated from protobuf field: string reason = 1;
     */
    reason: string;
}
/**
 * @generated from protobuf message VpuGrpc.AgentUi2VpuCommandMessage
 */
export interface AgentUi2VpuCommandMessage {
    /**
     * @generated from protobuf field: string agentUi2VpuCommandString = 1;
     */
    agentUi2VpuCommandString: string;
}
/**
 * @generated from protobuf message VpuGrpc.Vpu2AgentUiCommandListMessage
 */
export interface Vpu2AgentUiCommandListMessage {
    /**
     * @generated from protobuf field: repeated string Vpu2AgentUiGroupNameList = 1 [json_name = "Vpu2AgentUiGroupNameList"];
     */
    vpu2AgentUiGroupNameList: string[];
    /**
     * @generated from protobuf field: repeated VpuGrpc.Vpu2AgentUiCommandListMessage.Vpu2AgentUiCommandDetails Vpu2AgentUiCommandDetailsList = 2 [json_name = "Vpu2AgentUiCommandDetailsList"];
     */
    vpu2AgentUiCommandDetailsList: Vpu2AgentUiCommandListMessage_Vpu2AgentUiCommandDetails[];
}
/**
 * @generated from protobuf message VpuGrpc.Vpu2AgentUiCommandListMessage.Vpu2AgentUiCommandDetails
 */
export interface Vpu2AgentUiCommandListMessage_Vpu2AgentUiCommandDetails {
    /**
     * @generated from protobuf field: string Vpu2AgentUiCommandName = 1 [json_name = "Vpu2AgentUiCommandName"];
     */
    vpu2AgentUiCommandName: string;
    /**
     * @generated from protobuf field: int32 Vpu2AgentUiGroupNum = 2 [json_name = "Vpu2AgentUiGroupNum"];
     */
    vpu2AgentUiGroupNum: number;
    /**
     * @generated from protobuf field: bool ExpertMode = 3 [json_name = "ExpertMode"];
     */
    expertMode: boolean;
}
/**
 * @generated from protobuf message VpuGrpc.AgentService2AgentGuiInfoMessage
 */
export interface AgentService2AgentGuiInfoMessage {
    /**
     * @generated from protobuf field: string systemType = 1;
     */
    systemType: string;
    /**
     * @generated from protobuf field: repeated VpuGrpc.AgentService2AgentGuiInfoMessage.paramDetails paramDetailsList = 2;
     */
    paramDetailsList: AgentService2AgentGuiInfoMessage_paramDetails[];
}
/**
 * @generated from protobuf message VpuGrpc.AgentService2AgentGuiInfoMessage.paramDetails
 */
export interface AgentService2AgentGuiInfoMessage_paramDetails {
    /**
     * @generated from protobuf field: VpuGrpc.AgentService2AgentGuiInfoMessage.paramNameEnum paramName = 2;
     */
    paramName: AgentService2AgentGuiInfoMessage_paramNameEnum;
    /**
     * @generated from protobuf field: string paramValue = 3;
     */
    paramValue: string;
}
/**
 * @generated from protobuf enum VpuGrpc.AgentService2AgentGuiInfoMessage.paramNameEnum
 */
export enum AgentService2AgentGuiInfoMessage_paramNameEnum {
    /**
     *
     *
     * @generated from protobuf enum value: appMode = 0;
     */
    appMode = 0,
    /**
     *
     *
     * @generated from protobuf enum value: currentlyInEvent = 1;
     */
    currentlyInEvent = 1,
    /**
     *
     *
     * @generated from protobuf enum value: nextEventStartTime = 2;
     */
    nextEventStartTime = 2,
    /**
     *
     *
     * @generated from protobuf enum value: nextEventEndTime = 3;
     */
    nextEventEndTime = 3,
    /**
     *
     *
     * @generated from protobuf enum value: nextEventName = 4;
     */
    nextEventName = 4,
    /**
     *
     *
     * @generated from protobuf enum value: currentEventStartTime = 5;
     */
    currentEventStartTime = 5,
    /**
     *
     *
     * @generated from protobuf enum value: currentEventEndTime = 6;
     */
    currentEventEndTime = 6,
    /**
     *
     *
     * @generated from protobuf enum value: currentEventName = 7;
     */
    currentEventName = 7,
    /**
     *
     *
     * @generated from protobuf enum value: hdFreeSpaceGbps = 8;
     */
    hdFreeSpaceGbps = 8,
    /**
     *
     *
     * @generated from protobuf enum value: ssdFreeSpaceGbps = 9;
     */
    ssdFreeSpaceGbps = 9,
    /**
     * init by "streams.cfg","STREAM-PANO_0","STREAM_QUALITY",    updated by commnad: set_Pano_0_StreamQuality
     *
     * @generated from protobuf enum value: streamPanoQuality = 10;
     */
    streamPanoQuality = 10,
    /**
     * init by "streams.cfg","STREAM-HD_0","STREAM_QUALITY",    updated by commnad: set_HD_0_StreamQuality
     *
     * @generated from protobuf enum value: streamHdQuality = 11;
     */
    streamHdQuality = 11,
    /**
     *
     *
     * @generated from protobuf enum value: schedulingModeApp = 12;
     */
    schedulingModeApp = 12,
    /**
     * @generated from protobuf enum value: maintenanceMode = 13;
     */
    maintenanceMode = 13,
    /**
     * init by "setup.cfg","GENERAL","SPORT_TYPE",and "USE_AUTO_PRODUCTION",updated by command setSportType
     *
     * @generated from protobuf enum value: autoProductionType = 14;
     */
    autoProductionType = 14,
    /**
     * @generated from protobuf enum value: enableHighlights = 15;
     */
    enableHighlights = 15,
    /**
     * init by "streams.cfg","STREAM-PANO_0","WRITE_STREAM", updated also by command setPano0WriteStream,
     *
     * @generated from protobuf enum value: streamPanoWriteStream = 16;
     */
    streamPanoWriteStream = 16,
    /**
     * init by "streams.cfg","STREAM-HD_0","WRITE_STREAM", updated also by command setHD_0WriteStream
     *
     * @generated from protobuf enum value: streamHdWriteStream = 17;
     */
    streamHdWriteStream = 17,
    /**
     * init by "streams.cfg","STREAM-PANO_0","STREAM_PATH_0", updated also by command setPano0StreamPath0
     *
     * @generated from protobuf enum value: streamPanoUrl = 18;
     */
    streamPanoUrl = 18,
    /**
     * init by "streams.cfg","STREAM-HD_0","STREAM_PATH_0", updated also by command setHD0StreamPath0
     *
     * @generated from protobuf enum value: streamHdUrl = 19;
     */
    streamHdUrl = 19,
    /**
     * init by "agentSetup.cfg", "GENERAL", "FiberSwitchIp" ,updated by command setFiberSwitchIP
     *
     * @generated from protobuf enum value: fiberSwitchIP = 20;
     */
    fiberSwitchIP = 20,
    /**
     * init by "agentSetup.cfg", "GENERAL", "FiberSwitchType" ,updated by command setFiberSwitchType
     *
     * @generated from protobuf enum value: fiberSwitchType = 21;
     */
    fiberSwitchType = 21,
    /**
     *
     *
     * @generated from protobuf enum value: scoreboardType = 22;
     */
    scoreboardType = 22,
    /**
     *
     *
     * @generated from protobuf enum value: vpuName = 23;
     */
    vpuName = 23,
    /**
     *
     *
     * @generated from protobuf enum value: vpuDescription = 24;
     */
    vpuDescription = 24,
    /**
     * init by "graphics.cfg",    "GENERAL", "IP" , updated by command setGraphicsIp
     *
     * @generated from protobuf enum value: graphicsIp = 25;
     */
    graphicsIp = 25,
    /**
     * init by "PiP.cfg", "PIP", "CAMERA_URL" , updated by command setPipCameraUrl
     *
     * @generated from protobuf enum value: pipCameraUrl = 26;
     */
    pipCameraUrl = 26,
    /**
     * init by "setup.cfg", "CAMERA_INFORMATION_BROADCAST", "ENABLE" , updated by command setCameraInfoBroadEnable
     *
     * @generated from protobuf enum value: cameraInfoBroadEnable = 27;
     */
    cameraInfoBroadEnable = 27,
    /**
     * init by "agentSetup.cfg", "GENERAL", "VenueID"
     *
     * @generated from protobuf enum value: venueID = 28;
     */
    venueID = 28,
    /**
     *
     *
     * @generated from protobuf enum value: licenseInfo = 29;
     */
    licenseInfo = 29,
    /**
     * @generated from protobuf enum value: productType = 30;
     */
    productType = 30,
    /**
     * @generated from protobuf enum value: hlsConfigEnabled = 31;
     */
    hlsConfigEnabled = 31,
    /**
     * @generated from protobuf enum value: workingHoursStartTime = 32;
     */
    workingHoursStartTime = 32,
    /**
     * @generated from protobuf enum value: workingHoursEndTime = 33;
     */
    workingHoursEndTime = 33,
    /**
     * @generated from protobuf enum value: softwareVersion = 34;
     */
    softwareVersion = 34,
    /**
     * @generated from protobuf enum value: externalEventRecordFolder = 35;
     */
    externalEventRecordFolder = 35,
    /**
     * @generated from protobuf enum value: gpuName = 36;
     */
    gpuName = 36,
    /**
     * @generated from protobuf enum value: gpuDriverVersion = 37;
     */
    gpuDriverVersion = 37,
    /**
     * @generated from protobuf enum value: cameraInfoList = 38;
     */
    cameraInfoList = 38,
    /**
     * @generated from protobuf enum value: lastModifiedCalibration = 39;
     */
    lastModifiedCalibration = 39,
    /**
     * @generated from protobuf enum value: lastModifiedColorBalance = 40;
     */
    lastModifiedColorBalance = 40,
    /**
     * @generated from protobuf enum value: lastModifiedCCU = 41;
     */
    lastModifiedCCU = 41,
    /**
     * @generated from protobuf enum value: externalEventRecordEnable = 42;
     */
    externalEventRecordEnable = 42,
    /**
     * @generated from protobuf enum value: audioEnabled = 43;
     */
    audioEnabled = 43,
    /**
     * @generated from protobuf enum value: totalMemory = 44;
     */
    totalMemory = 44,
    /**
     * @generated from protobuf enum value: poeLastRestart = 45;
     */
    poeLastRestart = 45,
    /**
     * @generated from protobuf enum value: nicInfo = 46;
     */
    nicInfo = 46,
    /**
     * @generated from protobuf enum value: cameraFPS = 47;
     */
    cameraFPS = 47,
    /**
     * @generated from protobuf enum value: autoLightControlEnabled = 48;
     */
    autoLightControlEnabled = 48,
    /**
     * @generated from protobuf enum value: autoProductionEnabled = 49;
     */
    autoProductionEnabled = 49,
    /**
     * @generated from protobuf enum value: camerasPartNumber = 50;
     */
    camerasPartNumber = 50,
    /**
     * @generated from protobuf enum value: graphicsDataProvider = 51;
     */
    graphicsDataProvider = 51,
    /**
     * @generated from protobuf enum value: allowFpsChange = 55;
     */
    allowFpsChange = 55,
    /**
     * @generated from protobuf enum value: cgEngineUseSingular = 56;
     */
    cgEngineUseSingular = 56,
    /**
     * @generated from protobuf enum value: tryLeaveMaintenanceMode = 57;
     */
    tryLeaveMaintenanceMode = 57,
    /**
     * @generated from protobuf enum value: setupModeOn = 58;
     */
    setupModeOn = 58,
    /**
     * @generated from protobuf enum value: autoLightControlValue = 59;
     */
    autoLightControlValue = 59,
    /**
     * @generated from protobuf enum value: dongleId = 60;
     */
    dongleId = 60,
    /**
     * @generated from protobuf enum value: licenseUpdateSucceeded = 61;
     */
    licenseUpdateSucceeded = 61,
    /**
     * @generated from protobuf enum value: forceLeaveSetupMode = 62;
     */
    forceLeaveSetupMode = 62,
    /**
     * @generated from protobuf enum value: headType = 63;
     */
    headType = 63,
    /**
     * @generated from protobuf enum value: cgEngineState = 64;
     */
    cgEngineState = 64,
    /**
     * @generated from protobuf enum value: pipState = 65;
     */
    pipState = 65,
    /**
     * @generated from protobuf enum value: presentedProductType = 68;
     */
    presentedProductType = 68,
    /**
     * @generated from protobuf enum value: graphicsEngineType = 69;
     */
    graphicsEngineType = 69,
    /**
     * @generated from protobuf enum value: graphicsDataSource = 70;
     */
    graphicsDataSource = 70,
    /**
     * @generated from protobuf enum value: panoramaErrorMessage = 71;
     */
    panoramaErrorMessage = 71,
    /**
     * @generated from protobuf enum value: panoramaLocation = 72;
     */
    panoramaLocation = 72,
    /**
     * @generated from protobuf enum value: installationHour = 73;
     */
    installationHour = 73,
    /**
     * @generated from protobuf enum value: streamHdVideoFormat = 75;
     */
    streamHdVideoFormat = 75,
    /**
     * @generated from protobuf enum value: sdiEnabled = 80;
     */
    sdiEnabled = 80,
    /**
     * @generated from protobuf enum value: useOcr = 82;
     */
    useOcr = 82,
    /**
     * @generated from protobuf enum value: eventId = 85;
     */
    eventId = 85,
    /**
     * @generated from protobuf enum value: metadataFolder = 86;
     */
    metadataFolder = 86,
    /**
     * @generated from protobuf enum value: panoGraphics = 87;
     */
    panoGraphics = 87,
    /**
     * init by "graphics.cfg",    "GENERAL", "AUTHENTICATION" , updated by command setGraphicsAuth
     *
     * @generated from protobuf enum value: graphicsAuth = 88;
     */
    graphicsAuth = 88,
    /**
     * @generated from protobuf enum value: licenseInfoValid = 89;
     */
    licenseInfoValid = 89,
    /**
     * new parameters for 'capture frames' reply
     *
     * @generated from protobuf enum value: cameraFramesRequestId = 90;
     */
    cameraFramesRequestId = 90,
    /**
     * @generated from protobuf enum value: cameraFramesLocation = 91;
     */
    cameraFramesLocation = 91,
    /**
     * @generated from protobuf enum value: cameraFramesSizeType = 92;
     */
    cameraFramesSizeType = 92,
    /**
     * @generated from protobuf enum value: captureFramesReplyType = 93;
     */
    captureFramesReplyType = 93,
    /**
     * @generated from protobuf enum value: cameraFramesFailureMessage = 94;
     */
    cameraFramesFailureMessage = 94,
    /**
     * @generated from protobuf enum value: useEnhancedPip = 95;
     */
    useEnhancedPip = 95,
    /**
     * @generated from protobuf enum value: externalEventRecordUserName = 96;
     */
    externalEventRecordUserName = 96,
    /**
     * @generated from protobuf enum value: externalEventRecordPassword = 97;
     */
    externalEventRecordPassword = 97,
    /**
     * @generated from protobuf enum value: varSupportEnable = 98;
     */
    varSupportEnable = 98,
    /**
     * @generated from protobuf enum value: uiGraphicType = 99;
     */
    uiGraphicType = 99,
    /**
     * @generated from protobuf enum value: allowPing = 100;
     */
    allowPing = 100,
    /**
     * @generated from protobuf enum value: cameraFramesSource = 101;
     */
    cameraFramesSource = 101,
    /**
     * @generated from protobuf enum value: venueEnv = 102;
     */
    venueEnv = 102,
    /**
     * @generated from protobuf enum value: audioVolume = 103;
     */
    audioVolume = 103,
    /**
     * @generated from protobuf enum value: audioGain = 104;
     */
    audioGain = 104,
    /**
     * @generated from protobuf enum value: ligrEnabled = 105;
     */
    ligrEnabled = 105,
    /**
     * @generated from protobuf enum value: ligrUrl = 106;
     */
    ligrUrl = 106,
    /**
     * @generated from protobuf enum value: debugPrintoutsEnabled = 107;
     */
    debugPrintoutsEnabled = 107,
    /**
     * @generated from protobuf enum value: currentEventSportType = 108;
     */
    currentEventSportType = 108,
    /**
     * @generated from protobuf enum value: nextEventSportType = 109;
     */
    nextEventSportType = 109,
    /**
     * @generated from protobuf enum value: systemHasCalibration = 110;
     */
    systemHasCalibration = 110,
    /**
     * @generated from protobuf enum value: cpuName = 111;
     */
    cpuName = 111,
    /**
     * @generated from protobuf enum value: vpuMac = 112;
     */
    vpuMac = 112,
    /**
     * @generated from protobuf enum value: OemSerialNumber = 113;
     */
    OemSerialNumber = 113,
    /**
     * @generated from protobuf enum value: Environment = 114;
     */
    Environment = 114,
    /**
     * @generated from protobuf enum value: sdiFormat = 115;
     */
    sdiFormat = 115,
    /**
     * @generated from protobuf enum value: sdiGraphicsEnabled = 116;
     */
    sdiGraphicsEnabled = 116,
    /**
     * @generated from protobuf enum value: dualRenderingInProgress = 117;
     */
    dualRenderingInProgress = 117,
    /**
     * @generated from protobuf enum value: externalEventRecordProtocol = 118;
     */
    externalEventRecordProtocol = 118,
    /**
     * @generated from protobuf enum value: cameraHeaterMode = 119;
     */
    cameraHeaterMode = 119,
    /**
     * @generated from protobuf enum value: cameraRevision = 120;
     */
    cameraRevision = 120,
    /**
     * @generated from protobuf enum value: chuMode = 121;
     */
    chuMode = 121,
    /**
     * @generated from protobuf enum value: applyColorCalibrationMatrix = 122;
     */
    applyColorCalibrationMatrix = 122,
    /**
     * @generated from protobuf enum value: isOutdoorSports = 123;
     */
    isOutdoorSports = 123,
    /**
     * @generated from protobuf enum value: multiSportOcrEnabledInVpum = 124;
     */
    multiSportOcrEnabledInVpum = 124,
    /**
     * @generated from protobuf enum value: ocrAlcIsEnabled = 125;
     */
    ocrAlcIsEnabled = 125,
    /**
     * @generated from protobuf enum value: audioEqualizerMode = 126;
     */
    audioEqualizerMode = 126,
    /**
     * @generated from protobuf enum value: ocrAiEnabledInVpum = 127;
     */
    ocrAiEnabledInVpum = 127,
    /**
     * init by "setup.cfg", "MANUAL_MIDROLL", "ENABLE", updated by command setManualMidrollEnable
     *
     * @generated from protobuf enum value: manualMidrollEnabled = 128;
     */
    manualMidrollEnabled = 128,
    /**
     * init by "streams.cfg", "STREAM-HD_0", "USE_SMART_MIDROLL", updated by command setSmartMidrollEnable
     *
     * @generated from protobuf enum value: useSmartMidroll = 129;
     */
    useSmartMidroll = 129,
    /**
     * init by "setup.cfg", "SMART_MIDROLL", "SIMULATOR", updated by command setSmartMidrollSimulator
     *
     * @generated from protobuf enum value: smartMidrollSimulator = 130;
     */
    smartMidrollSimulator = 130,
    /**
     * init by "graphics", "GENERAL", "SCOREBOARD_MANUAL_FROM_VIDEO", updated by command setScoreboardManualFromVideo
     *
     * @generated from protobuf enum value: scoreboardManualFromVideo = 131;
     */
    scoreboardManualFromVideo = 131
}
/**
 * @generated from protobuf message VpuGrpc.AgentService2AgentGuiEventRecordMessage
 */
export interface AgentService2AgentGuiEventRecordMessage {
    /**
     * @generated from protobuf field: VpuGrpc.AgentService2AgentGuiEventRecordMessage.fileTypeEnum fileType = 1;
     */
    fileType: AgentService2AgentGuiEventRecordMessage_fileTypeEnum;
    /**
     * @generated from protobuf field: repeated VpuGrpc.AgentService2AgentGuiEventRecordMessage.EventRecordDetails EventRecordList = 2 [json_name = "EventRecordList"];
     */
    eventRecordList: AgentService2AgentGuiEventRecordMessage_EventRecordDetails[];
}
/**
 * @generated from protobuf message VpuGrpc.AgentService2AgentGuiEventRecordMessage.EventRecordDetails
 */
export interface AgentService2AgentGuiEventRecordMessage_EventRecordDetails {
    /**
     * @generated from protobuf field: string startDate = 1;
     */
    startDate: string;
    /**
     * @generated from protobuf field: string eventId = 2;
     */
    eventId: string;
    /**
     * @generated from protobuf field: string length = 3;
     */
    length: string;
    /**
     * @generated from protobuf field: string eventName = 4;
     */
    eventName: string;
}
/**
 * @generated from protobuf enum VpuGrpc.AgentService2AgentGuiEventRecordMessage.fileTypeEnum
 */
export enum AgentService2AgentGuiEventRecordMessage_fileTypeEnum {
    /**
     * @generated from protobuf enum value: any = 0;
     */
    any = 0,
    /**
     * @generated from protobuf enum value: raw = 1;
     */
    raw = 1,
    /**
     * @generated from protobuf enum value: highlights = 2;
     */
    highlights = 2,
    /**
     * @generated from protobuf enum value: pano = 3;
     */
    pano = 3,
    /**
     * @generated from protobuf enum value: hd = 4;
     */
    hd = 4,
    /**
     * @generated from protobuf enum value: scoreboard = 5;
     */
    scoreboard = 5,
    /**
     * @generated from protobuf enum value: AA = 6;
     */
    AA = 6
}
/**
 * @generated from protobuf message VpuGrpc.AgentToVPUGenericCommandDetails
 */
export interface AgentToVPUGenericCommandDetails {
    /**
     * @generated from protobuf field: VpuGrpc.AgentToVPUGenericCommandDetails.AgentToVPUGenericCommandEnum agentToVPUGenericCommandName = 1;
     */
    agentToVPUGenericCommandName: AgentToVPUGenericCommandDetails_AgentToVPUGenericCommandEnum;
    /**
     * @generated from protobuf field: string commnadParam = 2;
     */
    commnadParam: string;
    /**
     * @generated from protobuf field: VpuGrpc.AgentToVPUGenericCommandDetails.ImageTypeEnum imageType = 3;
     */
    imageType: AgentToVPUGenericCommandDetails_ImageTypeEnum;
    /**
     * @generated from protobuf field: bool rotateFrames = 4;
     */
    rotateFrames: boolean;
}
/**
 * @generated from protobuf enum VpuGrpc.AgentToVPUGenericCommandDetails.AgentToVPUGenericCommandEnum
 */
export enum AgentToVPUGenericCommandDetails_AgentToVPUGenericCommandEnum {
    /**
     * @generated from protobuf enum value: closeUnit = 0;
     */
    closeUnit = 0,
    /**
     * @generated from protobuf enum value: captureFrames = 1;
     */
    captureFrames = 1,
    /**
     * @generated from protobuf enum value: enableAudio = 2;
     */
    enableAudio = 2,
    /**
     * @generated from protobuf enum value: enableAutoProduction = 3;
     */
    enableAutoProduction = 3,
    /**
     * @generated from protobuf enum value: autoLightControlMode = 4;
     */
    autoLightControlMode = 4,
    /**
     * @generated from protobuf enum value: getPanorama = 5;
     */
    getPanorama = 5
}
/**
 * @generated from protobuf enum VpuGrpc.AgentToVPUGenericCommandDetails.ImageTypeEnum
 */
export enum AgentToVPUGenericCommandDetails_ImageTypeEnum {
    /**
     * @generated from protobuf enum value: pano = 0;
     */
    pano = 0,
    /**
     * @generated from protobuf enum value: frames = 1;
     */
    frames = 1
}
/**
 * @generated from protobuf message VpuGrpc.AgentGui2AgentServiceCommandMessage
 */
export interface AgentGui2AgentServiceCommandMessage {
    /**
     * @generated from protobuf field: VpuGrpc.AgentGui2AgentServiceCommandMessage.AgentGui2AgentCommnadEnum agentUi2AgentCommand = 1;
     */
    agentUi2AgentCommand: AgentGui2AgentServiceCommandMessage_AgentGui2AgentCommnadEnum;
    /**
     * @generated from protobuf field: string commandParamStr = 2;
     */
    commandParamStr: string;
    /**
     * @generated from protobuf field: bool commandParamBool = 3;
     */
    commandParamBool: boolean;
}
/**
 * @generated from protobuf enum VpuGrpc.AgentGui2AgentServiceCommandMessage.AgentGui2AgentCommnadEnum
 */
export enum AgentGui2AgentServiceCommandMessage_AgentGui2AgentCommnadEnum {
    /**
     * @generated from protobuf enum value: formatSsd = 0;
     */
    formatSsd = 0,
    /**
     * @generated from protobuf enum value: resetApps = 1;
     */
    resetApps = 1,
    /**
     * @generated from protobuf enum value: setSchedulingWorkingHours = 2;
     */
    setSchedulingWorkingHours = 2,
    /**
     * @generated from protobuf enum value: setSchedulingApp = 3;
     */
    setSchedulingApp = 3,
    /**
     * @generated from protobuf enum value: startPairingMode = 4;
     */
    startPairingMode = 4,
    /**
     * @generated from protobuf enum value: pairingModeLaunchVpu = 5;
     */
    pairingModeLaunchVpu = 5,
    /**
     * @generated from protobuf enum value: stopPairingMode = 6;
     */
    stopPairingMode = 6,
    /**
     * @generated from protobuf enum value: stopVpuAsAgentEnds = 7;
     */
    stopVpuAsAgentEnds = 7,
    /**
     * @generated from protobuf enum value: closeApps = 8;
     */
    closeApps = 8,
    /**
     * @generated from protobuf enum value: startPairingModeAndLaunchVpu = 9;
     */
    startPairingModeAndLaunchVpu = 9,
    /**
     * @generated from protobuf enum value: maskCrashReport = 10;
     */
    maskCrashReport = 10,
    /**
     * @generated from protobuf enum value: setEnableHighlights = 11;
     */
    setEnableHighlights = 11,
    /**
     * @generated from protobuf enum value: disableWatchdogfromVPU = 12;
     */
    disableWatchdogfromVPU = 12,
    /**
     * @generated from protobuf enum value: setFiberSwitchIP = 13;
     */
    setFiberSwitchIP = 13,
    /**
     * @generated from protobuf enum value: setFiberSwitchType = 14;
     */
    setFiberSwitchType = 14,
    /**
     * new command
     *
     * @generated from protobuf enum value: setScoreboardType = 15;
     */
    setScoreboardType = 15,
    /**
     * setVPUName = 16;
     *
     * @generated from protobuf enum value: setVPUDescription = 17;
     */
    setVPUDescription = 17,
    /**
     * coordinator will send this Only for manual mode!!, sets: "streams.cfg", "STREAM-HD_0", "WRITE_STREAM",
     *
     * @generated from protobuf enum value: setHd0WriteStream = 18;
     */
    setHd0WriteStream = 18,
    /**
     * coordinator will send this Only for manual mode!!, sets: "streams.cfg", "STREAM-PANO_0", "WRITE_STREAM",
     *
     * @generated from protobuf enum value: setPano0WriteStream = 19;
     */
    setPano0WriteStream = 19,
    /**
     * coordinator will send this Only for manual mode!!, sets: "streams.cfg", "STREAM-HD_0", "STREAM_PATH_0",
     *
     * @generated from protobuf enum value: setHd0StreamPath0 = 20;
     */
    setHd0StreamPath0 = 20,
    /**
     * coordinator will send this Only for manual mode!!, sets: "streams.cfg", "STREAM-HD_0", "STREAM_QUALITY",
     *
     * @generated from protobuf enum value: setHd0StreamQuality = 21;
     */
    setHd0StreamQuality = 21,
    /**
     * coordinator will send this Only for manual mode!!, sets: "streams.cfg", "STREAM-PANO_0", "STREAM_PATH_0",
     *
     * @generated from protobuf enum value: setPano0StreamPath0 = 22;
     */
    setPano0StreamPath0 = 22,
    /**
     * coordinator will send this Only for manual mode!!, sets: "streams.cfg", "STREAM-PANO_0", "STREAM_QUALITY",
     *
     * @generated from protobuf enum value: setPano0StreamQuality = 23;
     */
    setPano0StreamQuality = 23,
    /**
     * coordinator will send this Only for manual mode!!, sets: "setup.cfg", "GENERAL", "SPORT_TYPE",
     *
     * @generated from protobuf enum value: setSportType = 24;
     */
    setSportType = 24,
    /**
     * "setup.cfg",    "CAMERA_INFORMATION_BROADCAST",    "ENABLE",
     *
     * @generated from protobuf enum value: setCameraInfoBroadEnable = 25;
     */
    setCameraInfoBroadEnable = 25,
    /**
     * "graphics.cfg", "GENERAL", "IP",
     *
     * @generated from protobuf enum value: setGraphicsIp = 26;
     */
    setGraphicsIp = 26,
    /**
     * "PiP.cfg", "PIP", "CAMERA_URL",
     *
     * @generated from protobuf enum value: setPipCameraUrl = 27;
     */
    setPipCameraUrl = 27,
    /**
     * @generated from protobuf enum value: setHlsConfigEnabled = 28;
     */
    setHlsConfigEnabled = 28,
    /**
     * @generated from protobuf enum value: setWorkingHoursStartTime = 29;
     */
    setWorkingHoursStartTime = 29,
    /**
     * @generated from protobuf enum value: setWorkingHoursEndTime = 30;
     */
    setWorkingHoursEndTime = 30,
    /**
     * @generated from protobuf enum value: restartComputer = 31;
     */
    restartComputer = 31,
    /**
     * @generated from protobuf enum value: setExternalEventRecordFolder = 32;
     */
    setExternalEventRecordFolder = 32,
    /**
     * @generated from protobuf enum value: setExternalEventRecordEnable = 33;
     */
    setExternalEventRecordEnable = 33,
    /**
     * @generated from protobuf enum value: setAudioEnabled = 34;
     */
    setAudioEnabled = 34,
    /**
     * @generated from protobuf enum value: setCameraFps = 35;
     */
    setCameraFps = 35,
    /**
     * @generated from protobuf enum value: setAutoLightControlEnabled = 36;
     */
    setAutoLightControlEnabled = 36,
    /**
     * @generated from protobuf enum value: setAutoProductionEnabled = 37;
     */
    setAutoProductionEnabled = 37,
    /**
     * @generated from protobuf enum value: setGraphicsDataProvider = 38;
     */
    setGraphicsDataProvider = 38,
    /**
     * setCgengineLogoEnabled = 39;        //"graphics.cfg", "GENERAL", "ENABLE_LOGO_IN_CGENGINE"
     *   setCgengineLogoFadeIn = 40;         //"graphics.cfg",  "GENERAL", "SHOW_LOGO_FOR_X_SECONDS"
     *   setCgengineLogoFadeOut = 41;        //"graphics.cfg",  "GENERAL", "REMOVE_LOGO_FOR_X_SECONDS"
     *   setCgEngineUseSingular = 42;
     *
     * @generated from protobuf enum value: setStayInMaintenanceMode = 43;
     */
    setStayInMaintenanceMode = 43,
    /**
     * @generated from protobuf enum value: deactivateEngineering = 44;
     */
    deactivateEngineering = 44,
    /**
     * @generated from protobuf enum value: activateEngineering = 45;
     */
    activateEngineering = 45,
    /**
     * @generated from protobuf enum value: updateLicense = 46;
     */
    updateLicense = 46,
    /**
     * @generated from protobuf enum value: updateCameraPairing = 48;
     */
    updateCameraPairing = 48,
    /**
     * @generated from protobuf enum value: getPanorama = 49;
     */
    getPanorama = 49,
    /**
     * @generated from protobuf enum value: setInstallationHour = 50;
     */
    setInstallationHour = 50,
    /**
     * @generated from protobuf enum value: setHd0StreamVideoFormat = 56;
     */
    setHd0StreamVideoFormat = 56,
    /**
     * @generated from protobuf enum value: setSdiEnabled = 57;
     */
    setSdiEnabled = 57,
    /**
     * @generated from protobuf enum value: setUseOcr = 59;
     */
    setUseOcr = 59,
    /**
     * @generated from protobuf enum value: setPanoGraphics = 60;
     */
    setPanoGraphics = 60,
    /**
     * "graphics.cfg", "GENERAL", "AUTHENTICATION",
     *
     * @generated from protobuf enum value: setGraphicsAuth = 61;
     */
    setGraphicsAuth = 61,
    /**
     * @generated from protobuf enum value: setHeadType = 62;
     */
    setHeadType = 62,
    /**
     * @generated from protobuf enum value: setUseEnhancedPip = 63;
     */
    setUseEnhancedPip = 63,
    /**
     * @generated from protobuf enum value: restartPip = 64;
     */
    restartPip = 64,
    /**
     * @generated from protobuf enum value: restartCoordinator = 65;
     */
    restartCoordinator = 65,
    /**
     * @generated from protobuf enum value: restartCg = 66;
     */
    restartCg = 66,
    /**
     * @generated from protobuf enum value: restartAgent = 67;
     */
    restartAgent = 67,
    /**
     * @generated from protobuf enum value: resetPoeByVPUM = 68;
     */
    resetPoeByVPUM = 68,
    /**
     * @generated from protobuf enum value: setExternalEventRecordUserName = 69;
     */
    setExternalEventRecordUserName = 69,
    /**
     * @generated from protobuf enum value: setExternalEventRecordPassword = 70;
     */
    setExternalEventRecordPassword = 70,
    /**
     * @generated from protobuf enum value: startPipInSetUpMode = 71;
     */
    startPipInSetUpMode = 71,
    /**
     * @generated from protobuf enum value: stopPipInSetUpMode = 72;
     */
    stopPipInSetUpMode = 72,
    /**
     * @generated from protobuf enum value: setVarSupportEnable = 73;
     */
    setVarSupportEnable = 73,
    /**
     * @generated from protobuf enum value: updateLastCalibrationTime = 74;
     */
    updateLastCalibrationTime = 74,
    /**
     * @generated from protobuf enum value: SetGraphicsUiType = 75;
     */
    SetGraphicsUiType = 75,
    /**
     * @generated from protobuf enum value: startAAFrameCapture = 76;
     */
    startAAFrameCapture = 76,
    /**
     * @generated from protobuf enum value: stopFrameCapture = 77;
     */
    stopFrameCapture = 77,
    /**
     * @generated from protobuf enum value: GetStaticInfo = 78;
     */
    GetStaticInfo = 78,
    /**
     * @generated from protobuf enum value: setAllowPing = 79;
     */
    setAllowPing = 79,
    /**
     * @generated from protobuf enum value: startFrameCapture = 80;
     */
    startFrameCapture = 80,
    /**
     * @generated from protobuf enum value: setSystemName = 81;
     */
    setSystemName = 81,
    /**
     * @generated from protobuf enum value: setAudioVolume = 82;
     */
    setAudioVolume = 82,
    /**
     * @generated from protobuf enum value: setAudioGain = 83;
     */
    setAudioGain = 83,
    /**
     * @generated from protobuf enum value: setLigr = 84;
     */
    setLigr = 84,
    /**
     * @generated from protobuf enum value: setDebugPrintoutsEnabled = 85;
     */
    setDebugPrintoutsEnabled = 85,
    /**
     * @generated from protobuf enum value: cameraPairingStatus = 86;
     */
    cameraPairingStatus = 86,
    /**
     * @generated from protobuf enum value: updateAfterPairing = 87;
     */
    updateAfterPairing = 87,
    /**
     * @generated from protobuf enum value: restartVenue = 88;
     */
    restartVenue = 88,
    /**
     * @generated from protobuf enum value: networkTestResult = 89;
     */
    networkTestResult = 89,
    /**
     * @generated from protobuf enum value: cameraTestResult = 90;
     */
    cameraTestResult = 90,
    /**
     * @generated from protobuf enum value: gpuTestResult = 91;
     */
    gpuTestResult = 91,
    /**
     * @generated from protobuf enum value: venueSelfTestResult = 92;
     */
    venueSelfTestResult = 92,
    /**
     * @generated from protobuf enum value: hwTestResult = 93;
     */
    hwTestResult = 93,
    /**
     * @generated from protobuf enum value: setSdiFormat = 94;
     */
    setSdiFormat = 94,
    /**
     * @generated from protobuf enum value: setSdiGraphicsEnabled = 95;
     */
    setSdiGraphicsEnabled = 95,
    /**
     * @generated from protobuf enum value: setExternalEventRecordProtocol = 96;
     */
    setExternalEventRecordProtocol = 96,
    /**
     * @generated from protobuf enum value: startPostProcess = 97;
     */
    startPostProcess = 97,
    /**
     * @generated from protobuf enum value: exitedHeadsetupTab = 98;
     */
    exitedHeadsetupTab = 98,
    /**
     * @generated from protobuf enum value: setCameraHeaterMode = 99;
     */
    setCameraHeaterMode = 99,
    /**
     * @generated from protobuf enum value: enableWatchdogfromVPU = 100;
     */
    enableWatchdogfromVPU = 100,
    /**
     * @generated from protobuf enum value: setIsOutdoorSports = 101;
     */
    setIsOutdoorSports = 101,
    /**
     * @generated from protobuf enum value: setMultiSportEnabledVpum = 102;
     */
    setMultiSportEnabledVpum = 102,
    /**
     * @generated from protobuf enum value: handleCalibrationApproved = 103;
     */
    handleCalibrationApproved = 103,
    /**
     * @generated from protobuf enum value: setAudioEqualizerMode = 104;
     */
    setAudioEqualizerMode = 104,
    /**
     * @generated from protobuf enum value: networkSpeedTestResult = 105;
     */
    networkSpeedTestResult = 105,
    /**
     * @generated from protobuf enum value: setManualMidrollEnabled = 106;
     */
    setManualMidrollEnabled = 106,
    /**
     * @generated from protobuf enum value: setSmartMidrollEnabled = 107;
     */
    setSmartMidrollEnabled = 107,
    /**
     * @generated from protobuf enum value: setSmartMidrollSimulator = 108;
     */
    setSmartMidrollSimulator = 108,
    /**
     * @generated from protobuf enum value: setScoreboardManualFromVideo = 109;
     */
    setScoreboardManualFromVideo = 109
}
/**
 * @generated from protobuf message VpuGrpc.CoachingAdditionalAngleListMessage
 */
export interface CoachingAdditionalAngleListMessage {
    /**
     * @generated from protobuf field: repeated VpuGrpc.CoachingAdditionalAnglesMessage aaDetails = 1;
     */
    aaDetails: CoachingAdditionalAnglesMessage[];
}
/**
 * @generated from protobuf message VpuGrpc.CoachingAdditionalAnglesMessage
 */
export interface CoachingAdditionalAnglesMessage {
    /**
     * @generated from protobuf field: string cameraName = 1;
     */
    cameraName: string;
    /**
     * @generated from protobuf field: string url = 2;
     */
    url: string;
    /**
     * @generated from protobuf field: bool enable = 3;
     */
    enable: boolean;
}
/**
 * @generated from protobuf message VpuGrpc.AddStreamMessage
 */
export interface AddStreamMessage {
    /**
     * @generated from protobuf field: string encoderName = 1;
     */
    encoderName: string;
    /**
     * @generated from protobuf field: int32 encoderIdx = 2;
     */
    encoderIdx: number;
    /**
     * @generated from protobuf field: string streamUrl = 3;
     */
    streamUrl: string;
    /**
     * @generated from protobuf field: string s3Bucket = 4;
     */
    s3Bucket: string;
    /**
     * @generated from protobuf field: string s3Region = 5;
     */
    s3Region: string;
    /**
     * @generated from protobuf field: string awsAccessKeyId = 6;
     */
    awsAccessKeyId: string;
    /**
     * @generated from protobuf field: string awsSecretAccessKey = 7;
     */
    awsSecretAccessKey: string;
    /**
     * @generated from protobuf field: string awsSessionToken = 8;
     */
    awsSessionToken: string;
}
/**
 * @generated from protobuf message VpuGrpc.RemoveStreamMessage
 */
export interface RemoveStreamMessage {
    /**
     * @generated from protobuf field: string encoderName = 1;
     */
    encoderName: string;
    /**
     * @generated from protobuf field: int32 encoderIdx = 2;
     */
    encoderIdx: number;
    /**
     * @generated from protobuf field: string streamUrl = 3;
     */
    streamUrl: string;
}
/**
 * @generated from protobuf message VpuGrpc.InstantHighlightsMessage
 */
export interface InstantHighlightsMessage {
    /**
     * @generated from protobuf field: string metadataPath = 1;
     */
    metadataPath: string;
    /**
     * @generated from protobuf field: string subProductionType = 2;
     */
    subProductionType: string;
}
/**
 * @generated from protobuf message VpuGrpc.UpdateStreamBitRateMessage
 */
export interface UpdateStreamBitRateMessage {
    /**
     * @generated from protobuf field: string encoderName = 1;
     */
    encoderName: string;
    /**
     * @generated from protobuf field: int32 encoderIdx = 2;
     */
    encoderIdx: number;
    /**
     * @generated from protobuf field: int32 bitRate = 3;
     */
    bitRate: number;
}
/**
 * Used for Coordinator
 *
 * @generated from protobuf message VpuGrpc.CameraFPSChangeStatus
 */
export interface CameraFPSChangeStatus {
}
/**
 * @generated from protobuf enum VpuGrpc.CameraFPSChangeStatus.Status
 */
export enum CameraFPSChangeStatus_Status {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: ALLOW = 1;
     */
    ALLOW = 1,
    /**
     * @generated from protobuf enum value: DONOT_ALLOW = 2;
     */
    DONOT_ALLOW = 2
}
/**
 * @generated from protobuf message VpuGrpc.GraphicsEngineTypeMessage
 */
export interface GraphicsEngineTypeMessage {
    /**
     * @generated from protobuf field: string engineType = 1;
     */
    engineType: string;
}
/**
 * @generated from protobuf message VpuGrpc.RestartGraphicsMessage
 */
export interface RestartGraphicsMessage {
    /**
     * @generated from protobuf field: bool value = 1;
     */
    value: boolean;
    /**
     * @generated from protobuf field: string graphicsClientUrl = 2;
     */
    graphicsClientUrl: string;
    /**
     * @generated from protobuf field: bool force = 3;
     */
    force: boolean;
    /**
     * @generated from protobuf field: int32 oldGraphicsPortNumber = 4;
     */
    oldGraphicsPortNumber: number;
    /**
     * @generated from protobuf field: string venueEnvironment = 5;
     */
    venueEnvironment: string;
    /**
     * @generated from protobuf field: string proxyUsername = 6;
     */
    proxyUsername: string;
    /**
     * @generated from protobuf field: string proxyPassword = 7;
     */
    proxyPassword: string;
    /**
     * @generated from protobuf field: bool useProxy = 8;
     */
    useProxy: boolean;
    /**
     * @generated from protobuf field: string metadataDir = 9;
     */
    metadataDir: string;
    /**
     * @generated from protobuf field: bool logConsoleMessages = 10;
     */
    logConsoleMessages: boolean;
}
/**
 * @generated from protobuf message VpuGrpc.SingularFlowMessage
 */
export interface SingularFlowMessage {
    /**
     * @generated from protobuf field: string flowCommand = 1;
     */
    flowCommand: string;
    /**
     * @generated from protobuf field: VpuGrpc.SingularFlowMessage.flowCommandType type = 2;
     */
    type: SingularFlowMessage_flowCommandType;
}
/**
 * @generated from protobuf enum VpuGrpc.SingularFlowMessage.flowCommandType
 */
export enum SingularFlowMessage_flowCommandType {
    /**
     * @generated from protobuf enum value: PlayTo = 0;
     */
    PlayTo = 0,
    /**
     * @generated from protobuf enum value: SetPayload = 1;
     */
    SetPayload = 1,
    /**
     * @generated from protobuf enum value: RenderAppOutput = 2;
     */
    RenderAppOutput = 2
}
/**
 * @generated from protobuf message VpuGrpc.EventUpdateMessage
 */
export interface EventUpdateMessage {
    /**
     * @generated from protobuf field: string eventId = 1;
     */
    eventId: string;
    /**
     * @generated from protobuf field: bool received = 2;
     */
    received: boolean;
    /**
     * @generated from protobuf field: string metadataPath = 3;
     */
    metadataPath: string;
    /**
     * @generated from protobuf field: bool forceAsSecondaryEvent = 4;
     */
    forceAsSecondaryEvent: boolean;
    /**
     * @generated from protobuf field: string venueEnvironment = 5;
     */
    venueEnvironment: string;
    /**
     * @generated from protobuf field: string sportType = 6;
     */
    sportType: string;
    /**
     * @generated from protobuf field: string lgepAddress = 7;
     */
    lgepAddress: string;
    /**
     * @generated from protobuf field: string lgepAuth = 8;
     */
    lgepAuth: string;
    /**
     * @generated from protobuf field: bool sendMidrollCues = 9;
     */
    sendMidrollCues: boolean;
    /**
     * @generated from protobuf field: string venueId = 10;
     */
    venueId: string;
}
/**
 * @generated from protobuf message VpuGrpc.OcrDataMessage
 */
export interface OcrDataMessage {
    /**
     * @generated from protobuf field: int32 homeScore = 1;
     */
    homeScore: number;
    /**
     * @generated from protobuf field: int32 awayScore = 2;
     */
    awayScore: number;
    /**
     * @generated from protobuf field: string time = 3;
     */
    time: string;
    /**
     * @generated from protobuf field: string period = 4;
     */
    period: string;
    /**
     * @generated from protobuf field: string down = 5;
     */
    down: string;
    /**
     * @generated from protobuf field: string distance = 6;
     */
    distance: string;
    /**
     * @generated from protobuf field: string homeGamesWon = 7;
     */
    homeGamesWon: string;
    /**
     * @generated from protobuf field: string awayGamesWon = 8;
     */
    awayGamesWon: string;
    /**
     * @generated from protobuf field: string shotClock = 9;
     */
    shotClock: string;
    /**
     * @generated from protobuf field: int32 homeFouls = 10;
     */
    homeFouls: number;
    /**
     * @generated from protobuf field: int32 awayFouls = 11;
     */
    awayFouls: number;
    /**
     * @generated from protobuf field: bool ocrFailed = 12;
     */
    ocrFailed: boolean;
    /**
     * @generated from protobuf field: string possessionIndicator = 13;
     */
    possessionIndicator: string;
    /**
     * @generated from protobuf field: string penaltyClock = 14;
     */
    penaltyClock: string;
    /**
     * @generated from protobuf field: int32 homeShotsOnGoal = 15;
     */
    homeShotsOnGoal: number;
    /**
     * @generated from protobuf field: int32 awayShotsOnGoal = 16;
     */
    awayShotsOnGoal: number;
    /**
     * @generated from protobuf field: string powerPlayIndicator = 17;
     */
    powerPlayIndicator: string;
    /**
     * @generated from protobuf field: int32 setNumber = 18;
     */
    setNumber: number;
    /**
     * @generated from protobuf field: int32 homeSetScore = 19;
     */
    homeSetScore: number;
    /**
     * @generated from protobuf field: int32 awaySetScore = 20;
     */
    awaySetScore: number;
    /**
     * @generated from protobuf field: int32 homeTimeoutCount = 21;
     */
    homeTimeoutCount: number;
    /**
     * @generated from protobuf field: int32 awayTimeoutCount = 22;
     */
    awayTimeoutCount: number;
    /**
     * @generated from protobuf field: int32 homeChallengeCount = 23;
     */
    homeChallengeCount: number;
    /**
     * @generated from protobuf field: int32 awayChallengeCount = 24;
     */
    awayChallengeCount: number;
    /**
     * @generated from protobuf field: int32 inning = 25;
     */
    inning: number;
    /**
     * @generated from protobuf field: int32 outs = 26;
     */
    outs: number;
    /**
     * @generated from protobuf field: int32 balls = 27;
     */
    balls: number;
    /**
     * @generated from protobuf field: int32 strikes = 28;
     */
    strikes: number;
    /**
     * @generated from protobuf field: int32 runsPerInning = 29;
     */
    runsPerInning: number;
    /**
     * @generated from protobuf field: int32 homeTimeoutsLeft = 30;
     */
    homeTimeoutsLeft: number;
    /**
     * @generated from protobuf field: int32 awayTimeoutsLeft = 31;
     */
    awayTimeoutsLeft: number;
    /**
     * @generated from protobuf field: string timeOutIndicator = 32;
     */
    timeOutIndicator: string;
    /**
     * @generated from protobuf field: uint64 timestampMs = 33;
     */
    timestampMs: bigint; // Unix timestamp in milliseconds when frame was captured
}
/**
 * @generated from protobuf message VpuGrpc.GraphicsInfoMessage
 */
export interface GraphicsInfoMessage {
    /**
     * @generated from protobuf field: VpuGrpc.GraphicsInfoMessage.GraphicsInfoTypeEnum GraphicsInfoMessageType = 1 [json_name = "GraphicsInfoMessageType"];
     */
    graphicsInfoMessageType: GraphicsInfoMessage_GraphicsInfoTypeEnum;
    /**
     * @generated from protobuf field: VpuGrpc.GraphicsEngineTypeMessage GraphicsEngine = 2 [json_name = "GraphicsEngine"];
     */
    graphicsEngine?: GraphicsEngineTypeMessage;
    /**
     * @generated from protobuf field: VpuGrpc.SingularFlowMessage FlowMessage = 3 [json_name = "FlowMessage"];
     */
    flowMessage?: SingularFlowMessage;
    /**
     * @generated from protobuf field: VpuGrpc.EventUpdateMessage EventUpdate = 4 [json_name = "EventUpdate"];
     */
    eventUpdate?: EventUpdateMessage;
    /**
     * @generated from protobuf field: VpuGrpc.OcrDataMessage OcrMessage = 5 [json_name = "OcrMessage"];
     */
    ocrMessage?: OcrDataMessage;
    /**
     * @generated from protobuf field: VpuGrpc.OcrModeMessage OcrMode = 6 [json_name = "OcrMode"];
     */
    ocrMode?: OcrModeMessage;
    /**
     * @generated from protobuf field: VpuGrpc.GraphicsTypeOverrideMessage GraphicsTypeOverride = 7 [json_name = "GraphicsTypeOverride"];
     */
    graphicsTypeOverride?: GraphicsTypeOverrideMessage;
    /**
     * @generated from protobuf field: VpuGrpc.PipModeMessage PipMode = 8 [json_name = "PipMode"];
     */
    pipMode?: PipModeMessage;
    /**
     * @generated from protobuf field: VpuGrpc.RestartGraphicsMessage RestartGraphics = 9 [json_name = "RestartGraphics"];
     */
    restartGraphics?: RestartGraphicsMessage;
}
/**
 * @generated from protobuf enum VpuGrpc.GraphicsInfoMessage.GraphicsInfoTypeEnum
 */
export enum GraphicsInfoMessage_GraphicsInfoTypeEnum {
    /**
     * @generated from protobuf enum value: GRAPHICS_ENGINE_TYPE = 0;
     */
    GRAPHICS_ENGINE_TYPE = 0,
    /**
     * @generated from protobuf enum value: FLOW_MESSAGE = 1;
     */
    FLOW_MESSAGE = 1,
    /**
     * @generated from protobuf enum value: FLOW_STATUS = 2;
     */
    FLOW_STATUS = 2,
    /**
     * @generated from protobuf enum value: START_EVENT = 3;
     */
    START_EVENT = 3,
    /**
     * @generated from protobuf enum value: END_EVENT = 4;
     */
    END_EVENT = 4,
    /**
     * @generated from protobuf enum value: OCR_DATA = 5;
     */
    OCR_DATA = 5,
    /**
     * @generated from protobuf enum value: OCR_MODE = 6;
     */
    OCR_MODE = 6,
    /**
     * @generated from protobuf enum value: GRAPHICS_TYPE_OVERRIDE = 7;
     */
    GRAPHICS_TYPE_OVERRIDE = 7,
    /**
     * @generated from protobuf enum value: PIP_MODE = 8;
     */
    PIP_MODE = 8,
    /**
     * @generated from protobuf enum value: RESTART_GRAPHICS = 9;
     */
    RESTART_GRAPHICS = 9,
    /**
     * @generated from protobuf enum value: HEALTH_CHECK = 10;
     */
    HEALTH_CHECK = 10
}
/**
 * @generated from protobuf message VpuGrpc.PipScoreboardModeMessage
 */
export interface PipScoreboardModeMessage {
    /**
     * @generated from protobuf field: VpuGrpc.PipScoreboardModeMessage.Mode mode = 1;
     */
    mode: PipScoreboardModeMessage_Mode;
}
/**
 * @generated from protobuf enum VpuGrpc.PipScoreboardModeMessage.Mode
 */
export enum PipScoreboardModeMessage_Mode {
    /**
     * @generated from protobuf enum value: FULL_PIP = 0;
     */
    FULL_PIP = 0,
    /**
     * @generated from protobuf enum value: OCR_AI = 1;
     */
    OCR_AI = 1,
    /**
     * @generated from protobuf enum value: DEEP_OCR = 2;
     */
    DEEP_OCR = 2,
    /**
     * @generated from protobuf enum value: ENHANCED_PIP = 3;
     */
    ENHANCED_PIP = 3
}
/**
 * @generated from protobuf message VpuGrpc.PipFrameResponse
 */
export interface PipFrameResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string frame = 2;
     */
    frame: string;
}
/**
 * @generated from protobuf message VpuGrpc.FrameTimestampRequest
 */
export interface FrameTimestampRequest {
    /**
     * @generated from protobuf field: uint64 timestamp = 1;
     */
    timestamp: bigint; // Unix timestamp in milliseconds when frame was captured
}
/**
 * @generated from protobuf message VpuGrpc.CueOutMessage
 */
export interface CueOutMessage {
    /**
     * @generated from protobuf field: uint64 timestamp = 1;
     */
    timestamp: bigint;
    /**
     * @generated from protobuf field: uint64 duration = 2;
     */
    duration: bigint;
    /**
     * @generated from protobuf field: bool autoReturn = 3;
     */
    autoReturn: boolean;
}
/**
 * @generated from protobuf message VpuGrpc.CueInMessage
 */
export interface CueInMessage {
    /**
     * @generated from protobuf field: uint64 timestamp = 1;
     */
    timestamp: bigint;
}
/**
 * @generated from protobuf message VpuGrpc.ScoreboardStatusMessage
 */
export interface ScoreboardStatusMessage {
    /**
     * @generated from protobuf field: bool connected = 1;
     */
    connected: boolean;
    /**
     * @generated from protobuf field: bool hasData = 2;
     */
    hasData: boolean;
}
/**
 * WombatFirmawareInterface
 *
 * @generated from protobuf message VpuGrpc.ChuUpgradeStatusMessage
 */
export interface ChuUpgradeStatusMessage {
    /**
     * @generated from protobuf field: VpuGrpc.ChuUpgradeStatusMessage.Status UpdateStatus = 1 [json_name = "UpdateStatus"];
     */
    updateStatus: ChuUpgradeStatusMessage_Status;
    /**
     * @generated from protobuf field: string UpdateStep = 2 [json_name = "UpdateStep"];
     */
    updateStep: string;
    /**
     * @generated from protobuf field: int32 ProgressPercentage = 3 [json_name = "ProgressPercentage"];
     */
    progressPercentage: number;
}
/**
 * @generated from protobuf enum VpuGrpc.ChuUpgradeStatusMessage.Status
 */
export enum ChuUpgradeStatusMessage_Status {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: UPGRADING_THE_CHU = 1;
     */
    UPGRADING_THE_CHU = 1,
    /**
     * @generated from protobuf enum value: CHU_UPGRADE_COMPLETED = 2;
     */
    CHU_UPGRADE_COMPLETED = 2,
    /**
     * @generated from protobuf enum value: CHU_UPGRADE_FAILED = 3;
     */
    CHU_UPGRADE_FAILED = 3
}
/**
 * same parameters, as they appear in VPU::getCamerasParameters()
 *
 * @generated from protobuf message VpuGrpc.CamerasParametersMessage
 */
export interface CamerasParametersMessage {
    /**
     * @generated from protobuf field: float gain = 1;
     */
    gain: number;
    /**
     * @generated from protobuf field: int32 exposure = 2;
     */
    exposure: number; // must be 'signed' - to be able to set -1 in JavaScript and prevent exception when sending as a protobuf message 
    /**
     * @generated from protobuf field: float gamma = 3;
     */
    gamma: number;
    /**
     * @generated from protobuf field: float iris = 4;
     */
    iris: number;
    /**
     * @generated from protobuf field: float red = 5;
     */
    red: number;
    /**
     * @generated from protobuf field: float blue = 6;
     */
    blue: number;
    /**
     * int32 jpegQuality = 7;
     *
     * @generated from protobuf field: VpuGrpc.AutoExpoModeEnum autoExpoMode = 8;
     */
    autoExpoMode: AutoExpoModeEnum;
    /**
     * @generated from protobuf field: int32 brightnessLevel = 9;
     */
    brightnessLevel: number;
    /**
     * @generated from protobuf field: int32 fieldOfView = 10;
     */
    fieldOfView: number;
    /**
     * @generated from protobuf field: int32 maxExposure = 11;
     */
    maxExposure: number;
    /**
     * @generated from protobuf field: bool motorsError = 12;
     */
    motorsError: boolean;
}
/**
 * @generated from protobuf message VpuGrpc.MinMaxValues
 */
export interface MinMaxValues {
    /**
     * @generated from protobuf field: int32 minValue = 1;
     */
    minValue: number;
    /**
     * @generated from protobuf field: int32 maxValue = 2;
     */
    maxValue: number;
}
/**
 * please sync with struct CameraDetrails in VPUInterface.h
 *
 * @generated from protobuf message VpuGrpc.CameraDetails
 */
export interface CameraDetails {
    /**
     * @generated from protobuf field: int32 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: int32 width = 2;
     */
    width: number;
    /**
     * @generated from protobuf field: int32 height = 3;
     */
    height: number;
    /**
     * @generated from protobuf field: bool isTop = 4;
     */
    isTop: boolean;
}
// Request & reply messages

/**
 * @generated from protobuf message VpuGrpc.CamerasParametersMinMaxValuesRequestMessage
 */
export interface CamerasParametersMinMaxValuesRequestMessage {
}
/**
 * @generated from protobuf message VpuGrpc.CamerasParametersMinMaxValuesReplyMessage
 */
export interface CamerasParametersMinMaxValuesReplyMessage {
    /**
     * @generated from protobuf field: VpuGrpc.MinMaxValues brightness = 1;
     */
    brightness?: MinMaxValues;
    /**
     * @generated from protobuf field: VpuGrpc.MinMaxValues exposure = 2;
     */
    exposure?: MinMaxValues;
    /**
     * @generated from protobuf field: VpuGrpc.MinMaxValues gamma = 3;
     */
    gamma?: MinMaxValues;
    /**
     * @generated from protobuf field: VpuGrpc.MinMaxValues gain = 4;
     */
    gain?: MinMaxValues;
    /**
     * @generated from protobuf field: VpuGrpc.MinMaxValues red = 5;
     */
    red?: MinMaxValues;
    /**
     * @generated from protobuf field: VpuGrpc.MinMaxValues blue = 6;
     */
    blue?: MinMaxValues;
    /**
     * @generated from protobuf field: VpuGrpc.MinMaxValues fieldOfView = 7;
     */
    fieldOfView?: MinMaxValues;
    /**
     * @generated from protobuf field: VpuGrpc.MinMaxValues maxExposure = 8;
     */
    maxExposure?: MinMaxValues;
}
/**
 * @generated from protobuf message VpuGrpc.CamerasParametersRequestMessage
 */
export interface CamerasParametersRequestMessage {
}
/**
 * @generated from protobuf message VpuGrpc.CamerasParametersReplyMessage
 */
export interface CamerasParametersReplyMessage {
    /**
     * @generated from protobuf field: VpuGrpc.CamerasParametersMessage cameraParams = 1;
     */
    cameraParams?: CamerasParametersMessage;
    /**
     * @generated from protobuf field: bool success = 2;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 3;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message VpuGrpc.SetCameraParametersMessage
 */
export interface SetCameraParametersMessage {
    /**
     * @generated from protobuf field: int32 cameraId = 1;
     */
    cameraId: number;
    /**
     * @generated from protobuf field: VpuGrpc.CamerasParametersMessage cameraParams = 2;
     */
    cameraParams?: CamerasParametersMessage;
}
/**
 * @generated from protobuf message VpuGrpc.FieldOfViewResponseMessage
 */
export interface FieldOfViewResponseMessage {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
/**
 * similar to SetCameraParamMessage in RecorderMessages.h
 *
 * @generated from protobuf message VpuGrpc.SetCameraSingleParameterMessage
 */
export interface SetCameraSingleParameterMessage {
    /**
     * @generated from protobuf field: int32 cameraId = 1;
     */
    cameraId: number;
    /**
     * @generated from protobuf field: VpuGrpc.CameraParamRequestType requestType = 2;
     */
    requestType: CameraParamRequestType;
    /**
     * @generated from protobuf field: float focus = 3;
     */
    focus: number;
    /**
     * @generated from protobuf field: bool autoFocus = 4;
     */
    autoFocus: boolean;
    /**
     * @generated from protobuf field: int32 fieldOfView = 5;
     */
    fieldOfView: number;
}
/**
 * similar to CamerasOrderMessage in RecorderMessages.h
 *
 * @generated from protobuf message VpuGrpc.SetCamerasOrderMessage
 */
export interface SetCamerasOrderMessage {
    /**
     * @generated from protobuf field: int32 camera1 = 1;
     */
    camera1: number;
    /**
     * @generated from protobuf field: int32 camera2 = 2;
     */
    camera2: number;
}
/**
 * @generated from protobuf message VpuGrpc.CameraDetailsListRequestMessage
 */
export interface CameraDetailsListRequestMessage {
}
/**
 * @generated from protobuf message VpuGrpc.CameraDetailsListReplyMessage
 */
export interface CameraDetailsListReplyMessage {
    /**
     * @generated from protobuf field: repeated VpuGrpc.CameraDetails cameras = 2;
     */
    cameras: CameraDetails[];
}
/**
 * @generated from protobuf message VpuGrpc.FlipCameraMessage
 */
export interface FlipCameraMessage {
    /**
     * @generated from protobuf field: int32 cameraId = 1;
     */
    cameraId: number;
}
/**
 * @generated from protobuf message VpuGrpc.SetCamerasOrderResponseMessage
 */
export interface SetCamerasOrderResponseMessage {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
// ///////////////////////////////////////////////////////////////////////////
// Zoom messages

/**
 * @generated from protobuf message VpuGrpc.ZoomInRequestMessage
 */
export interface ZoomInRequestMessage {
    /**
     * @generated from protobuf field: repeated int32 cameraIds = 1;
     */
    cameraIds: number[];
    /**
     * @generated from protobuf field: int32 zoomStep = 2;
     */
    zoomStep: number;
}
/**
 * @generated from protobuf message VpuGrpc.ZoomOutRequestMessage
 */
export interface ZoomOutRequestMessage {
    /**
     * @generated from protobuf field: repeated int32 cameraIds = 1;
     */
    cameraIds: number[];
    /**
     * @generated from protobuf field: int32 zoomStep = 2;
     */
    zoomStep: number;
}
/**
 * @generated from protobuf message VpuGrpc.ResetZoomRequestMessage
 */
export interface ResetZoomRequestMessage {
    /**
     * @generated from protobuf field: repeated int32 cameraIds = 1;
     */
    cameraIds: number[];
}
// ///////////////////////////////////////////////////////////////////////////
// Iris messages

/**
 * @generated from protobuf message VpuGrpc.IncreaseIrisRequestMessage
 */
export interface IncreaseIrisRequestMessage {
    /**
     * @generated from protobuf field: repeated int32 cameraIds = 1;
     */
    cameraIds: number[];
}
/**
 * @generated from protobuf message VpuGrpc.DecreaseIrisRequestMessage
 */
export interface DecreaseIrisRequestMessage {
    /**
     * @generated from protobuf field: repeated int32 cameraIds = 1;
     */
    cameraIds: number[];
}
/**
 * @generated from protobuf message VpuGrpc.AutoIrisRequestMessage
 */
export interface AutoIrisRequestMessage {
    /**
     * @generated from protobuf field: repeated int32 cameraIds = 1;
     */
    cameraIds: number[];
}
/**
 * @generated from protobuf message VpuGrpc.ResetIrisRequestMessage
 */
export interface ResetIrisRequestMessage {
    /**
     * @generated from protobuf field: repeated int32 cameraIds = 1;
     */
    cameraIds: number[];
}
// ///////////////////////////////////////////////////////////////////////////
// Focus messages

/**
 * @generated from protobuf message VpuGrpc.FocusFarRequestMessage
 */
export interface FocusFarRequestMessage {
    /**
     * @generated from protobuf field: int32 cameraId = 1;
     */
    cameraId: number;
    /**
     * @generated from protobuf field: int32 focusStep = 2;
     */
    focusStep: number;
}
/**
 * @generated from protobuf message VpuGrpc.FocusNearRequestMessage
 */
export interface FocusNearRequestMessage {
    /**
     * @generated from protobuf field: int32 cameraId = 1;
     */
    cameraId: number;
    /**
     * @generated from protobuf field: int32 focusStep = 2;
     */
    focusStep: number;
}
/**
 * @generated from protobuf message VpuGrpc.AutoFocusRequestMessage
 */
export interface AutoFocusRequestMessage {
    /**
     * @generated from protobuf field: int32 cameraId = 1;
     */
    cameraId: number;
}
/**
 * @generated from protobuf message VpuGrpc.ResetFocusRequestMessage
 */
export interface ResetFocusRequestMessage {
    /**
     * @generated from protobuf field: int32 cameraId = 1;
     */
    cameraId: number;
}
/**
 * @generated from protobuf message VpuGrpc.FocusResponseMessage
 */
export interface FocusResponseMessage {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message VpuGrpc.GameplayData
 */
export interface GameplayData {
    /**
     * @generated from protobuf field: VpuGrpc.Team homeTeam = 1;
     */
    homeTeam?: Team;
    /**
     * @generated from protobuf field: VpuGrpc.Team awayTeam = 2;
     */
    awayTeam?: Team;
    /**
     * @generated from protobuf field: VpuGrpc.GameTime time = 3;
     */
    time?: GameTime;
}
/**
 * @generated from protobuf message VpuGrpc.Team
 */
export interface Team {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: int32 score = 2;
     */
    score: number;
}
/**
 * @generated from protobuf message VpuGrpc.GameTime
 */
export interface GameTime {
    /**
     * @generated from protobuf field: string clock = 1;
     */
    clock: string;
}
/**
 * @generated from protobuf message VpuGrpc.CamerasInfoMessage
 */
export interface CamerasInfoMessage {
    /**
     * @generated from protobuf field: uint32 camerasNum = 1;
     */
    camerasNum: number;
    /**
     * @generated from protobuf field: repeated VpuGrpc.HeadCameraInfoMessage headCameraInfo = 2;
     */
    headCameraInfo: HeadCameraInfoMessage[];
    /**
     * @generated from protobuf field: repeated VpuGrpc.PeripheralCameraInfoMessage peripheralCameraInfo = 3;
     */
    peripheralCameraInfo: PeripheralCameraInfoMessage[];
}
/**
 * @generated from protobuf message VpuGrpc.HeadCameraInfoMessage
 */
export interface HeadCameraInfoMessage {
    /**
     * @generated from protobuf field: string type = 1;
     */
    type: string;
    /**
     * @generated from protobuf field: string uid = 2;
     */
    uid: string;
    /**
     * @generated from protobuf field: string firmware = 3;
     */
    firmware: string;
    /**
     * @generated from protobuf field: string version = 4;
     */
    version: string;
    /**
     * @generated from protobuf field: string tvSystemMode = 5;
     */
    tvSystemMode: string;
    /**
     * @generated from protobuf field: string macAddress = 6;
     */
    macAddress: string;
    /**
     * @generated from protobuf field: string revision = 7;
     */
    revision: string;
    /**
     * @generated from protobuf field: string cameraModel = 8;
     */
    cameraModel: string;
}
/**
 * @generated from protobuf message VpuGrpc.PeripheralCameraInfoMessage
 */
export interface PeripheralCameraInfoMessage {
    /**
     * @generated from protobuf field: string uid = 1;
     */
    uid: string;
    /**
     * @generated from protobuf field: string firmware = 2;
     */
    firmware: string;
    /**
     * @generated from protobuf field: string macAddress = 3;
     */
    macAddress: string;
    /**
     * @generated from protobuf field: string modelName = 4;
     */
    modelName: string;
    /**
     * @generated from protobuf field: string type = 5;
     */
    type: string;
}
/**
 * @generated from protobuf message VpuGrpc.CameraFramesRequestData
 */
export interface CameraFramesRequestData {
    /**
     * @generated from protobuf field: string requestId = 1;
     */
    requestId: string;
    /**
     * @generated from protobuf field: VpuGrpc.FrameTypeInternal frameType = 2;
     */
    frameType: FrameTypeInternal;
    /**
     * @generated from protobuf field: VpuGrpc.CaptureFramesReplyTypeInternal replyType = 3;
     */
    replyType: CaptureFramesReplyTypeInternal;
    /**
     * @generated from protobuf field: bool rotateFrames = 4;
     */
    rotateFrames: boolean;
}
// End of Camera Frames stuff
// /////////////////////////////////////////////////////////////////////////////////

/**
 * @generated from protobuf message VpuGrpc.OcrModeMessage
 */
export interface OcrModeMessage {
    /**
     * @generated from protobuf field: bool enhancedPip = 1;
     */
    enhancedPip: boolean;
    /**
     * @generated from protobuf field: bool fullPip = 2;
     */
    fullPip: boolean;
    /**
     * @generated from protobuf field: bool ocr = 3;
     */
    ocr: boolean;
}
/**
 * @generated from protobuf message VpuGrpc.GraphicsTypeOverrideMessage
 */
export interface GraphicsTypeOverrideMessage {
    /**
     * @generated from protobuf field: string graphicsType = 1;
     */
    graphicsType: string;
}
/**
 * @generated from protobuf message VpuGrpc.PipModeMessage
 */
export interface PipModeMessage {
    /**
     * @generated from protobuf field: VpuGrpc.PipModeMessage.PipMode mode = 1;
     */
    mode: PipModeMessage_PipMode;
}
/**
 * @generated from protobuf enum VpuGrpc.PipModeMessage.PipMode
 */
export enum PipModeMessage_PipMode {
    /**
     * @generated from protobuf enum value: normal = 0;
     */
    normal = 0,
    /**
     * @generated from protobuf enum value: singleFrame = 1;
     */
    singleFrame = 1,
    /**
     * @generated from protobuf enum value: continuous = 2;
     */
    continuous = 2
}
/**
 * @generated from protobuf message VpuGrpc.SystemNameResponse
 */
export interface SystemNameResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
}
/**
 * @generated from protobuf message VpuGrpc.OcrCalibrationUpdate
 */
export interface OcrCalibrationUpdate {
    /**
     * @generated from protobuf field: VpuGrpc.OcrCalibrationMetaData metadata = 1;
     */
    metadata?: OcrCalibrationMetaData;
    /**
     * @generated from protobuf field: repeated string fields = 2;
     */
    fields: string[];
}
/**
 * @generated from protobuf message VpuGrpc.OcrCalibrationMetaData
 */
export interface OcrCalibrationMetaData {
    /**
     * @generated from protobuf field: string sportType = 1;
     */
    sportType: string;
    /**
     * @generated from protobuf field: string approvedDate = 2;
     */
    approvedDate: string;
    /**
     * @generated from protobuf field: string source = 3;
     */
    source: string;
    /**
     * @generated from protobuf field: string version = 4;
     */
    version: string;
}
/**
 * @generated from protobuf message VpuGrpc.RtspLinksCameraInfo
 */
export interface RtspLinksCameraInfo {
    /**
     * @generated from protobuf field: repeated CommonUsedMessages.RtspLinkInfo liveRtspLinks = 1;
     */
    liveRtspLinks: RtspLinkInfo[];
}
/**
 * @generated from protobuf message VpuGrpc.VenueCalibrationDataInfo
 */
export interface VenueCalibrationDataInfo {
    /**
     * @generated from protobuf field: repeated CommonUsedMessages.VenueCalibrationData venueDataCalibration = 1;
     */
    venueDataCalibration: VenueCalibrationData[];
}
/**
 * @generated from protobuf message VpuGrpc.GetVenueLogsByDurationRequest
 */
export interface GetVenueLogsByDurationRequest {
    /**
     * @generated from protobuf field: VpuGrpc.GetVenueLogsByDurationRequest.DurationType offsetDurationType = 1;
     */
    offsetDurationType: GetVenueLogsByDurationRequest_DurationType;
    /**
     * @generated from protobuf field: int64 offsetDurationUnits = 2;
     */
    offsetDurationUnits: bigint;
}
/**
 * @generated from protobuf enum VpuGrpc.GetVenueLogsByDurationRequest.DurationType
 */
export enum GetVenueLogsByDurationRequest_DurationType {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: HOURS = 1;
     */
    HOURS = 1,
    /**
     * @generated from protobuf enum value: DAYS = 2;
     */
    DAYS = 2
}
/**
 * @generated from protobuf message VpuGrpc.GetVenueLogsByDurationResponse
 */
export interface GetVenueLogsByDurationResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: bytes zipFileBytes = 2;
     */
    zipFileBytes: Uint8Array;
}
/**
 * @generated from protobuf message VpuGrpc.GetVenueLogsReplyMessage
 */
export interface GetVenueLogsReplyMessage {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string userMessage = 2;
     */
    userMessage: string;
    /**
     * @generated from protobuf field: CommonUsedMessages.DataChunkMessage dataChunk = 3;
     */
    dataChunk?: DataChunkMessage;
    /**
     * @generated from protobuf field: string archiveName = 4;
     */
    archiveName: string;
}
/**
 * @generated from protobuf message VpuGrpc.GetVenueLogsByDateRequest
 */
export interface GetVenueLogsByDateRequest {
    /**
     * @generated from protobuf field: uint64 timestamp = 1;
     */
    timestamp: bigint;
}
/**
 * @generated from protobuf message VpuGrpc.GetVenueLogsByDateResponse
 */
export interface GetVenueLogsByDateResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: bytes zipFileBytes = 2;
     */
    zipFileBytes: Uint8Array;
    /**
     * @generated from protobuf field: string archiveName = 3;
     */
    archiveName: string;
}
/**
 * @generated from protobuf message VpuGrpc.GetHeaterDataRequest
 */
export interface GetHeaterDataRequest {
    /**
     * @generated from protobuf field: int32 heaterNumber = 1;
     */
    heaterNumber: number;
}
/**
 * @generated from protobuf message VpuGrpc.SetHeaterModeRequest
 */
export interface SetHeaterModeRequest {
    /**
     * @generated from protobuf field: VpuGrpc.HeaterModes mode = 1;
     */
    mode: HeaterModes;
}
/**
 * @generated from protobuf message VpuGrpc.SetAudioEqualizerModeRequest
 */
export interface SetAudioEqualizerModeRequest {
    /**
     * @generated from protobuf field: VpuGrpc.AudioEqualizerModes mode = 1;
     */
    mode: AudioEqualizerModes;
}
/**
 * @generated from protobuf message VpuGrpc.GetHeaterDataResponse
 */
export interface GetHeaterDataResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: float heaterTemperature = 3;
     */
    heaterTemperature: number;
    /**
     * @generated from protobuf field: VpuGrpc.HeaterModes mode = 4;
     */
    mode: HeaterModes;
    /**
     * @generated from protobuf field: bool heaterOn = 5;
     */
    heaterOn: boolean;
}
/**
 * @generated from protobuf message VpuGrpc.GetHeaterDataStartRequest
 */
export interface GetHeaterDataStartRequest {
}
/**
 * @generated from protobuf message VpuGrpc.GetHeaterDataStopRequest
 */
export interface GetHeaterDataStopRequest {
}
/**
 * @generated from protobuf message VpuGrpc.LoginToAbeRequest
 */
export interface LoginToAbeRequest {
    /**
     * @generated from protobuf field: string username = 1;
     */
    username: string;
    /**
     * @generated from protobuf field: string password = 2;
     */
    password: string;
    /**
     * @generated from protobuf field: string systemName = 3;
     */
    systemName: string;
}
/**
 * @generated from protobuf message VpuGrpc.LoginToAbeResponse
 */
export interface LoginToAbeResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: string token = 3;
     */
    token: string;
    /**
     * @generated from protobuf field: repeated string tenants = 4;
     */
    tenants: string[];
}
/**
 * @generated from protobuf message VpuGrpc.ActivateSystemOnAbeRequest
 */
export interface ActivateSystemOnAbeRequest {
    /**
     * @generated from protobuf field: string token = 1;
     */
    token: string;
    /**
     * @generated from protobuf field: string systemName = 2;
     */
    systemName: string;
    /**
     * @generated from protobuf field: string tenant = 3;
     */
    tenant: string;
}
/**
 * @generated from protobuf message VpuGrpc.ActivateSystemOnAbeResponse
 */
export interface ActivateSystemOnAbeResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: string systemName = 3;
     */
    systemName: string;
    /**
     * @generated from protobuf field: string tenant = 4;
     */
    tenant: string;
}
/**
 * @generated from protobuf message VpuGrpc.EventArchitectureMessage
 */
export interface EventArchitectureMessage {
    /**
     * @generated from protobuf field: string architecture = 1;
     */
    architecture: string;
}
/**
 * @generated from protobuf message VpuGrpc.StartMetadataWritingRequest
 */
export interface StartMetadataWritingRequest {
    /**
     * @generated from protobuf field: string eventId = 1;
     */
    eventId: string;
    /**
     * @generated from protobuf field: string metadataFolderPath = 2;
     */
    metadataFolderPath: string;
}
/**
 * @generated from protobuf message VpuGrpc.StopMetadataWritingRequest
 */
export interface StopMetadataWritingRequest {
    /**
     * @generated from protobuf field: string eventId = 1;
     */
    eventId: string;
}
/**
 * @generated from protobuf message VpuGrpc.EnableOcrAiForPipResponse
 */
export interface EnableOcrAiForPipResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string errorMessage = 2;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf enum VpuGrpc.PipFeedSource
 */
export enum PipFeedSource {
    /**
     * @generated from protobuf enum value: PIP_FEED_SOURCE_SCOREBOARD_CAMERA = 0;
     */
    SCOREBOARD_CAMERA = 0,
    /**
     * @generated from protobuf enum value: PIP_FEED_SOURCE_CHU = 1;
     */
    CHU = 1
}
// Head Setup

/**
 * NOTE: please sync with enum class AutoExpoModeType defined in AutoLightControlBase.h
 *
 * @generated from protobuf enum VpuGrpc.AutoExpoModeEnum
 */
export enum AutoExpoModeEnum {
    /**
     * in Google Protobuf enums the first element must be 0
     *
     * @generated from protobuf enum value: OFF = 0;
     */
    OFF = 0,
    /**
     * @generated from protobuf enum value: NOTHING = -1;
     */
    NOTHING = -1,
    /**
     * @generated from protobuf enum value: AUTO = 1;
     */
    AUTO = 1,
    /**
     * @generated from protobuf enum value: FULL = 2;
     */
    FULL = 2
}
/**
 * NOTE: please sync with enum class CameraParamRequestType defined in CameraParamTypeDef.h
 *
 * @generated from protobuf enum VpuGrpc.CameraParamRequestType
 */
export enum CameraParamRequestType {
    /**
     * cannot use just NOTHING because it is already used in AutoExpoModeEnum, CPRT is 'CameraParamRequestType'
     *
     * @generated from protobuf enum value: CPRT_NOTHING = 0;
     */
    CPRT_NOTHING = 0,
    /**
     * @generated from protobuf enum value: SET_FOCUS = 1;
     */
    SET_FOCUS = 1,
    /**
     * @generated from protobuf enum value: ZOOM_IN_CONT = 2;
     */
    ZOOM_IN_CONT = 2,
    /**
     * @generated from protobuf enum value: ZOOM_OUT_CONT = 3;
     */
    ZOOM_OUT_CONT = 3,
    /**
     * @generated from protobuf enum value: ZOOM_STOP = 4;
     */
    ZOOM_STOP = 4,
    /**
     * @generated from protobuf enum value: ZOOM_IN_STEP = 5;
     */
    ZOOM_IN_STEP = 5,
    /**
     * @generated from protobuf enum value: ZOOM_OUT_STEP = 6;
     */
    ZOOM_OUT_STEP = 6,
    /**
     * @generated from protobuf enum value: ZOOM_RESET = 7;
     */
    ZOOM_RESET = 7,
    /**
     * @generated from protobuf enum value: FOCUS_NEAR_CONT = 8;
     */
    FOCUS_NEAR_CONT = 8,
    /**
     * @generated from protobuf enum value: FOCUS_FAR_CONT = 9;
     */
    FOCUS_FAR_CONT = 9,
    /**
     * @generated from protobuf enum value: FOCUS_STOP = 10;
     */
    FOCUS_STOP = 10,
    /**
     * @generated from protobuf enum value: FOCUS_NEAR_STEP = 11;
     */
    FOCUS_NEAR_STEP = 11,
    /**
     * @generated from protobuf enum value: FOCUS_FAR_STEP = 12;
     */
    FOCUS_FAR_STEP = 12,
    /**
     * @generated from protobuf enum value: FOCUS_RESET = 13;
     */
    FOCUS_RESET = 13,
    /**
     * @generated from protobuf enum value: AUTO_FOCUS = 14;
     */
    AUTO_FOCUS = 14,
    /**
     * @generated from protobuf enum value: IRIS_INCREASE = 15;
     */
    IRIS_INCREASE = 15,
    /**
     * @generated from protobuf enum value: IRIS_DECREASE = 16;
     */
    IRIS_DECREASE = 16,
    /**
     * @generated from protobuf enum value: IRIS_AUTO_SET = 17;
     */
    IRIS_AUTO_SET = 17,
    /**
     * @generated from protobuf enum value: IRIS_FULL_OPEN = 18;
     */
    IRIS_FULL_OPEN = 18,
    /**
     * @generated from protobuf enum value: AUDIO_INPUT_GAIN = 19;
     */
    AUDIO_INPUT_GAIN = 19,
    /**
     * @generated from protobuf enum value: AUDIO_OUTPUT_GAIN = 20;
     */
    AUDIO_OUTPUT_GAIN = 20,
    /**
     * @generated from protobuf enum value: FIELD_OF_VIEW = 21;
     */
    FIELD_OF_VIEW = 21
}
// /////////////////////////////////////////////////////////////////////////////////
// Camera Frames stuff
// 
// Note: currently these internal enums and messages are similar to the corresponding messages defined in Messages.proto
// TODO: find a way to use common messages

/**
 * @generated from protobuf enum VpuGrpc.FrameTypeInternal
 */
export enum FrameTypeInternal {
    /**
     * @generated from protobuf enum value: SIZE_TYPE_UNDEFINED = 0;
     */
    SIZE_TYPE_UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: SMALL_FRAMES = 1;
     */
    SMALL_FRAMES = 1,
    /**
     * @generated from protobuf enum value: LARGE_FRAMES = 2;
     */
    LARGE_FRAMES = 2,
    /**
     * @generated from protobuf enum value: PANO_IMAGE = 3;
     */
    PANO_IMAGE = 3,
    /**
     * @generated from protobuf enum value: PIP_IMAGE = 4;
     */
    PIP_IMAGE = 4,
    /**
     * @generated from protobuf enum value: AA_IMAGE = 5;
     */
    AA_IMAGE = 5
}
/**
 * @generated from protobuf enum VpuGrpc.CaptureFramesReplyTypeInternal
 */
export enum CaptureFramesReplyTypeInternal {
    /**
     * @generated from protobuf enum value: REPLY_TYPE_UNDEFINED = 0;
     */
    REPLY_TYPE_UNDEFINED = 0,
    /**
     * reply with BigDataMessage (for C++ clients)
     *
     * @generated from protobuf enum value: REPLY_WITH_BIG_DATA_MESSAGE = 1;
     */
    REPLY_WITH_BIG_DATA_MESSAGE = 1,
    /**
     * reply with DataChunkMessage (for web clients)
     *
     * @generated from protobuf enum value: REPLY_WITH_DATA_CHUNK_MESSAGE = 2;
     */
    REPLY_WITH_DATA_CHUNK_MESSAGE = 2
}
/**
 * @generated from protobuf enum VpuGrpc.HeaterModes
 */
export enum HeaterModes {
    /**
     * @generated from protobuf enum value: HM_OFF = 0;
     */
    HM_OFF = 0,
    /**
     * @generated from protobuf enum value: HM_ON = 1;
     */
    HM_ON = 1,
    /**
     * @generated from protobuf enum value: HM_AUTO = 2;
     */
    HM_AUTO = 2
}
/**
 * @generated from protobuf enum VpuGrpc.AudioEqualizerModes
 */
export enum AudioEqualizerModes {
    /**
     * @generated from protobuf enum value: AE_ENHANCED_AUDIO = 0;
     */
    AE_ENHANCED_AUDIO = 0,
    /**
     * @generated from protobuf enum value: AE_FLAT = 1;
     */
    AE_FLAT = 1,
    /**
     * @generated from protobuf enum value: AE_WIND_REDUCTION = 2;
     */
    AE_WIND_REDUCTION = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class FeedSourceLockRequest$Type extends MessageType<FeedSourceLockRequest> {
    constructor() {
        super("VpuGrpc.FeedSourceLockRequest", [
            { no: 1, name: "source", kind: "enum", T: () => ["VpuGrpc.PipFeedSource", PipFeedSource, "PIP_FEED_SOURCE_"] }
        ]);
    }
    create(value?: PartialMessage<FeedSourceLockRequest>): FeedSourceLockRequest {
        const message = { source: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FeedSourceLockRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FeedSourceLockRequest): FeedSourceLockRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuGrpc.PipFeedSource source */ 1:
                    message.source = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FeedSourceLockRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuGrpc.PipFeedSource source = 1; */
        if (message.source !== 0)
            writer.tag(1, WireType.Varint).int32(message.source);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.FeedSourceLockRequest
 */
export const FeedSourceLockRequest = new FeedSourceLockRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChuOcrFrameResponse$Type extends MessageType<ChuOcrFrameResponse> {
    constructor() {
        super("VpuGrpc.ChuOcrFrameResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "frame", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "scoreboardData", kind: "message", T: () => OcrDataMessage }
        ]);
    }
    create(value?: PartialMessage<ChuOcrFrameResponse>): ChuOcrFrameResponse {
        const message = { success: false, frame: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ChuOcrFrameResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChuOcrFrameResponse): ChuOcrFrameResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string frame */ 2:
                    message.frame = reader.string();
                    break;
                case /* VpuGrpc.OcrDataMessage scoreboardData */ 3:
                    message.scoreboardData = OcrDataMessage.internalBinaryRead(reader, reader.uint32(), options, message.scoreboardData);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChuOcrFrameResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string frame = 2; */
        if (message.frame !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.frame);
        /* VpuGrpc.OcrDataMessage scoreboardData = 3; */
        if (message.scoreboardData)
            OcrDataMessage.internalBinaryWrite(message.scoreboardData, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.ChuOcrFrameResponse
 */
export const ChuOcrFrameResponse = new ChuOcrFrameResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CoordinatesType$Type extends MessageType<CoordinatesType> {
    constructor() {
        super("VpuGrpc.CoordinatesType", [
            { no: 1, name: "type", kind: "enum", T: () => ["VpuGrpc.CoordinatesType.CoorType", CoordinatesType_CoorType] }
        ]);
    }
    create(value?: PartialMessage<CoordinatesType>): CoordinatesType {
        const message = { type: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CoordinatesType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CoordinatesType): CoordinatesType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuGrpc.CoordinatesType.CoorType type */ 1:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CoordinatesType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuGrpc.CoordinatesType.CoorType type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.CoordinatesType
 */
export const CoordinatesType = new CoordinatesType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServiceName$Type extends MessageType<ServiceName> {
    constructor() {
        super("VpuGrpc.ServiceName", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ServiceName>): ServiceName {
        const message = { name: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ServiceName>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServiceName): ServiceName {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServiceName, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.ServiceName
 */
export const ServiceName = new ServiceName$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PipMarkAndSaveOcrCalibrationResponse$Type extends MessageType<PipMarkAndSaveOcrCalibrationResponse> {
    constructor() {
        super("VpuGrpc.PipMarkAndSaveOcrCalibrationResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<PipMarkAndSaveOcrCalibrationResponse>): PipMarkAndSaveOcrCalibrationResponse {
        const message = { success: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PipMarkAndSaveOcrCalibrationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PipMarkAndSaveOcrCalibrationResponse): PipMarkAndSaveOcrCalibrationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PipMarkAndSaveOcrCalibrationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.PipMarkAndSaveOcrCalibrationResponse
 */
export const PipMarkAndSaveOcrCalibrationResponse = new PipMarkAndSaveOcrCalibrationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OcrAiCalibrateRequest$Type extends MessageType<OcrAiCalibrateRequest> {
    constructor() {
        super("VpuGrpc.OcrAiCalibrateRequest", [
            { no: 1, name: "sportType", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OcrAiCalibrateRequest>): OcrAiCalibrateRequest {
        const message = { sportType: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OcrAiCalibrateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OcrAiCalibrateRequest): OcrAiCalibrateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sportType */ 1:
                    message.sportType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OcrAiCalibrateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sportType = 1; */
        if (message.sportType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sportType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.OcrAiCalibrateRequest
 */
export const OcrAiCalibrateRequest = new OcrAiCalibrateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OcrAiCalibrateResponse$Type extends MessageType<OcrAiCalibrateResponse> {
    constructor() {
        super("VpuGrpc.OcrAiCalibrateResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OcrAiCalibrateResponse>): OcrAiCalibrateResponse {
        const message = { success: false, errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OcrAiCalibrateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OcrAiCalibrateResponse): OcrAiCalibrateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OcrAiCalibrateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.OcrAiCalibrateResponse
 */
export const OcrAiCalibrateResponse = new OcrAiCalibrateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OcrAiSetSportTypeRequest$Type extends MessageType<OcrAiSetSportTypeRequest> {
    constructor() {
        super("VpuGrpc.OcrAiSetSportTypeRequest", [
            { no: 1, name: "sportType", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OcrAiSetSportTypeRequest>): OcrAiSetSportTypeRequest {
        const message = { sportType: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OcrAiSetSportTypeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OcrAiSetSportTypeRequest): OcrAiSetSportTypeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sportType */ 1:
                    message.sportType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OcrAiSetSportTypeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sportType = 1; */
        if (message.sportType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sportType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.OcrAiSetSportTypeRequest
 */
export const OcrAiSetSportTypeRequest = new OcrAiSetSportTypeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OcrAiSetSportTypeResponse$Type extends MessageType<OcrAiSetSportTypeResponse> {
    constructor() {
        super("VpuGrpc.OcrAiSetSportTypeResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OcrAiSetSportTypeResponse>): OcrAiSetSportTypeResponse {
        const message = { success: false, errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OcrAiSetSportTypeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OcrAiSetSportTypeResponse): OcrAiSetSportTypeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OcrAiSetSportTypeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.OcrAiSetSportTypeResponse
 */
export const OcrAiSetSportTypeResponse = new OcrAiSetSportTypeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OcrAiSetSwapHomeAwayRequest$Type extends MessageType<OcrAiSetSwapHomeAwayRequest> {
    constructor() {
        super("VpuGrpc.OcrAiSetSwapHomeAwayRequest", [
            { no: 1, name: "swap", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<OcrAiSetSwapHomeAwayRequest>): OcrAiSetSwapHomeAwayRequest {
        const message = { swap: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OcrAiSetSwapHomeAwayRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OcrAiSetSwapHomeAwayRequest): OcrAiSetSwapHomeAwayRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool swap */ 1:
                    message.swap = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OcrAiSetSwapHomeAwayRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool swap = 1; */
        if (message.swap !== false)
            writer.tag(1, WireType.Varint).bool(message.swap);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.OcrAiSetSwapHomeAwayRequest
 */
export const OcrAiSetSwapHomeAwayRequest = new OcrAiSetSwapHomeAwayRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OcrAiSetSwapHomeAwayResponse$Type extends MessageType<OcrAiSetSwapHomeAwayResponse> {
    constructor() {
        super("VpuGrpc.OcrAiSetSwapHomeAwayResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OcrAiSetSwapHomeAwayResponse>): OcrAiSetSwapHomeAwayResponse {
        const message = { success: false, errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OcrAiSetSwapHomeAwayResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OcrAiSetSwapHomeAwayResponse): OcrAiSetSwapHomeAwayResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OcrAiSetSwapHomeAwayResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.OcrAiSetSwapHomeAwayResponse
 */
export const OcrAiSetSwapHomeAwayResponse = new OcrAiSetSwapHomeAwayResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WifiHotspotDetails$Type extends MessageType<WifiHotspotDetails> {
    constructor() {
        super("VpuGrpc.WifiHotspotDetails", [
            { no: 1, name: "pn", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sn", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WifiHotspotDetails>): WifiHotspotDetails {
        const message = { pn: "", sn: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<WifiHotspotDetails>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WifiHotspotDetails): WifiHotspotDetails {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string pn */ 1:
                    message.pn = reader.string();
                    break;
                case /* string sn */ 2:
                    message.sn = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WifiHotspotDetails, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string pn = 1; */
        if (message.pn !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.pn);
        /* string sn = 2; */
        if (message.sn !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sn);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.WifiHotspotDetails
 */
export const WifiHotspotDetails = new WifiHotspotDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraPartNumber$Type extends MessageType<CameraPartNumber> {
    constructor() {
        super("VpuGrpc.CameraPartNumber", [
            { no: 1, name: "pn", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CameraPartNumber>): CameraPartNumber {
        const message = { pn: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraPartNumber>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraPartNumber): CameraPartNumber {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string pn */ 1:
                    message.pn = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CameraPartNumber, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string pn = 1; */
        if (message.pn !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.pn);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.CameraPartNumber
 */
export const CameraPartNumber = new CameraPartNumber$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SystemLifeCycleStatus$Type extends MessageType<SystemLifeCycleStatus> {
    constructor() {
        super("VpuGrpc.SystemLifeCycleStatus", [
            { no: 1, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SystemLifeCycleStatus>): SystemLifeCycleStatus {
        const message = { status: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SystemLifeCycleStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SystemLifeCycleStatus): SystemLifeCycleStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string status */ 1:
                    message.status = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SystemLifeCycleStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string status = 1; */
        if (message.status !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.SystemLifeCycleStatus
 */
export const SystemLifeCycleStatus = new SystemLifeCycleStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PhaseInfoMessage$Type extends MessageType<PhaseInfoMessage> {
    constructor() {
        super("VpuGrpc.PhaseInfoMessage", [
            { no: 1, name: "phaseNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "phaseName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "phaseStartTime", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<PhaseInfoMessage>): PhaseInfoMessage {
        const message = { phaseNumber: 0, phaseName: "", phaseStartTime: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PhaseInfoMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PhaseInfoMessage): PhaseInfoMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 phaseNumber */ 1:
                    message.phaseNumber = reader.int32();
                    break;
                case /* string phaseName */ 2:
                    message.phaseName = reader.string();
                    break;
                case /* int64 phaseStartTime */ 3:
                    message.phaseStartTime = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PhaseInfoMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 phaseNumber = 1; */
        if (message.phaseNumber !== 0)
            writer.tag(1, WireType.Varint).int32(message.phaseNumber);
        /* string phaseName = 2; */
        if (message.phaseName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.phaseName);
        /* int64 phaseStartTime = 3; */
        if (message.phaseStartTime !== 0n)
            writer.tag(3, WireType.Varint).int64(message.phaseStartTime);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.PhaseInfoMessage
 */
export const PhaseInfoMessage = new PhaseInfoMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetIsFirstReleaseRequest$Type extends MessageType<SetIsFirstReleaseRequest> {
    constructor() {
        super("VpuGrpc.SetIsFirstReleaseRequest", [
            { no: 1, name: "value", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SetIsFirstReleaseRequest>): SetIsFirstReleaseRequest {
        const message = { value: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SetIsFirstReleaseRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetIsFirstReleaseRequest): SetIsFirstReleaseRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool value */ 1:
                    message.value = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetIsFirstReleaseRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool value = 1; */
        if (message.value !== false)
            writer.tag(1, WireType.Varint).bool(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.SetIsFirstReleaseRequest
 */
export const SetIsFirstReleaseRequest = new SetIsFirstReleaseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocalLicenseInfoMessage$Type extends MessageType<LocalLicenseInfoMessage> {
    constructor() {
        super("VpuGrpc.LocalLicenseInfoMessage", [
            { no: 1, name: "LocalLicenseInfo", kind: "scalar", jsonName: "LocalLicenseInfo", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<LocalLicenseInfoMessage>): LocalLicenseInfoMessage {
        const message = { localLicenseInfo: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<LocalLicenseInfoMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LocalLicenseInfoMessage): LocalLicenseInfoMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string LocalLicenseInfo = 1 [json_name = "LocalLicenseInfo"];*/ 1:
                    message.localLicenseInfo = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LocalLicenseInfoMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string LocalLicenseInfo = 1 [json_name = "LocalLicenseInfo"]; */
        if (message.localLicenseInfo !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.localLicenseInfo);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.LocalLicenseInfoMessage
 */
export const LocalLicenseInfoMessage = new LocalLicenseInfoMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Streams$Type extends MessageType<Streams> {
    constructor() {
        super("VpuGrpc.Streams", [
            { no: 1, name: "streams", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => StreamConfig },
            { no: 2, name: "status", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Streams>): Streams {
        const message = { streams: [], status: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Streams>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Streams): Streams {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated VpuGrpc.StreamConfig streams */ 1:
                    message.streams.push(StreamConfig.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool status */ 2:
                    message.status = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Streams, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated VpuGrpc.StreamConfig streams = 1; */
        for (let i = 0; i < message.streams.length; i++)
            StreamConfig.internalBinaryWrite(message.streams[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool status = 2; */
        if (message.status !== false)
            writer.tag(2, WireType.Varint).bool(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.Streams
 */
export const Streams = new Streams$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsAdvancedFlag$Type extends MessageType<IsAdvancedFlag> {
    constructor() {
        super("VpuGrpc.IsAdvancedFlag", [
            { no: 1, name: "isAdvnaced", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<IsAdvancedFlag>): IsAdvancedFlag {
        const message = { isAdvnaced: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<IsAdvancedFlag>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IsAdvancedFlag): IsAdvancedFlag {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isAdvnaced */ 1:
                    message.isAdvnaced = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IsAdvancedFlag, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isAdvnaced = 1; */
        if (message.isAdvnaced !== false)
            writer.tag(1, WireType.Varint).bool(message.isAdvnaced);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.IsAdvancedFlag
 */
export const IsAdvancedFlag = new IsAdvancedFlag$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PoeRequestMessage$Type extends MessageType<PoeRequestMessage> {
    constructor() {
        super("VpuGrpc.PoeRequestMessage", [
            { no: 1, name: "resetPoeRequest", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<PoeRequestMessage>): PoeRequestMessage {
        const message = { resetPoeRequest: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PoeRequestMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PoeRequestMessage): PoeRequestMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool resetPoeRequest */ 1:
                    message.resetPoeRequest = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PoeRequestMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool resetPoeRequest = 1; */
        if (message.resetPoeRequest !== false)
            writer.tag(1, WireType.Varint).bool(message.resetPoeRequest);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.PoeRequestMessage
 */
export const PoeRequestMessage = new PoeRequestMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioEnabledMessage$Type extends MessageType<AudioEnabledMessage> {
    constructor() {
        super("VpuGrpc.AudioEnabledMessage", [
            { no: 1, name: "enableAudio", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AudioEnabledMessage>): AudioEnabledMessage {
        const message = { enableAudio: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AudioEnabledMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioEnabledMessage): AudioEnabledMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enableAudio */ 1:
                    message.enableAudio = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioEnabledMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enableAudio = 1; */
        if (message.enableAudio !== false)
            writer.tag(1, WireType.Varint).bool(message.enableAudio);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.AudioEnabledMessage
 */
export const AudioEnabledMessage = new AudioEnabledMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioValueMessage$Type extends MessageType<AudioValueMessage> {
    constructor() {
        super("VpuGrpc.AudioValueMessage", [
            { no: 1, name: "audioValue", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AudioValueMessage>): AudioValueMessage {
        const message = { audioValue: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AudioValueMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioValueMessage): AudioValueMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 audioValue */ 1:
                    message.audioValue = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioValueMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 audioValue = 1; */
        if (message.audioValue !== 0)
            writer.tag(1, WireType.Varint).int32(message.audioValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.AudioValueMessage
 */
export const AudioValueMessage = new AudioValueMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutoProductionEnabledMessage$Type extends MessageType<AutoProductionEnabledMessage> {
    constructor() {
        super("VpuGrpc.AutoProductionEnabledMessage", [
            { no: 1, name: "enableAutoProduction", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AutoProductionEnabledMessage>): AutoProductionEnabledMessage {
        const message = { enableAutoProduction: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AutoProductionEnabledMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AutoProductionEnabledMessage): AutoProductionEnabledMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enableAutoProduction */ 1:
                    message.enableAutoProduction = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AutoProductionEnabledMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enableAutoProduction = 1; */
        if (message.enableAutoProduction !== false)
            writer.tag(1, WireType.Varint).bool(message.enableAutoProduction);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.AutoProductionEnabledMessage
 */
export const AutoProductionEnabledMessage = new AutoProductionEnabledMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutoLightControlModeMessage$Type extends MessageType<AutoLightControlModeMessage> {
    constructor() {
        super("VpuGrpc.AutoLightControlModeMessage", [
            { no: 1, name: "autoLightControlMode", kind: "enum", T: () => ["VpuGrpc.AutoExpoModeEnum", AutoExpoModeEnum] }
        ]);
    }
    create(value?: PartialMessage<AutoLightControlModeMessage>): AutoLightControlModeMessage {
        const message = { autoLightControlMode: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AutoLightControlModeMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AutoLightControlModeMessage): AutoLightControlModeMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuGrpc.AutoExpoModeEnum autoLightControlMode */ 1:
                    message.autoLightControlMode = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AutoLightControlModeMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuGrpc.AutoExpoModeEnum autoLightControlMode = 1; */
        if (message.autoLightControlMode !== 0)
            writer.tag(1, WireType.Varint).int32(message.autoLightControlMode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.AutoLightControlModeMessage
 */
export const AutoLightControlModeMessage = new AutoLightControlModeMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventId$Type extends MessageType<EventId> {
    constructor() {
        super("VpuGrpc.EventId", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EventId>): EventId {
        const message = { id: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<EventId>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EventId): EventId {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EventId, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.EventId
 */
export const EventId = new EventId$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamConfig$Type extends MessageType<StreamConfig> {
    constructor() {
        super("VpuGrpc.StreamConfig", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "index", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "bandwidth", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "fps", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value?: PartialMessage<StreamConfig>): StreamConfig {
        const message = { name: "", url: "", index: 0, bandwidth: 0, fps: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StreamConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StreamConfig): StreamConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string url */ 2:
                    message.url = reader.string();
                    break;
                case /* uint32 index */ 3:
                    message.index = reader.uint32();
                    break;
                case /* uint32 bandwidth */ 4:
                    message.bandwidth = reader.uint32();
                    break;
                case /* float fps */ 5:
                    message.fps = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StreamConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string url = 2; */
        if (message.url !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.url);
        /* uint32 index = 3; */
        if (message.index !== 0)
            writer.tag(3, WireType.Varint).uint32(message.index);
        /* uint32 bandwidth = 4; */
        if (message.bandwidth !== 0)
            writer.tag(4, WireType.Varint).uint32(message.bandwidth);
        /* float fps = 5; */
        if (message.fps !== 0)
            writer.tag(5, WireType.Bit32).float(message.fps);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.StreamConfig
 */
export const StreamConfig = new StreamConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VPUCCUDataMessage$Type extends MessageType<VPUCCUDataMessage> {
    constructor() {
        super("VpuGrpc.VPUCCUDataMessage", [
            { no: 1, name: "saturation", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 3, name: "hue", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "gamma", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "contrast", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "intensity", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 7, name: "rx1", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 8, name: "rx2", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "gx1", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 10, name: "gx2", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 11, name: "bx1", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 12, name: "bx2", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 13, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "panoLocation", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VPUCCUDataMessage>): VPUCCUDataMessage {
        const message = { saturation: 0, hue: 0, gamma: 0, contrast: 0, intensity: 0, rx1: 0, rx2: 0, gx1: 0, gx2: 0, bx1: 0, bx2: 0, success: false, error: "", panoLocation: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VPUCCUDataMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VPUCCUDataMessage): VPUCCUDataMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* float saturation */ 1:
                    message.saturation = reader.float();
                    break;
                case /* float hue */ 3:
                    message.hue = reader.float();
                    break;
                case /* float gamma */ 4:
                    message.gamma = reader.float();
                    break;
                case /* float contrast */ 5:
                    message.contrast = reader.float();
                    break;
                case /* float intensity */ 6:
                    message.intensity = reader.float();
                    break;
                case /* float rx1 */ 7:
                    message.rx1 = reader.float();
                    break;
                case /* float rx2 */ 8:
                    message.rx2 = reader.float();
                    break;
                case /* float gx1 */ 9:
                    message.gx1 = reader.float();
                    break;
                case /* float gx2 */ 10:
                    message.gx2 = reader.float();
                    break;
                case /* float bx1 */ 11:
                    message.bx1 = reader.float();
                    break;
                case /* float bx2 */ 12:
                    message.bx2 = reader.float();
                    break;
                case /* bool success */ 13:
                    message.success = reader.bool();
                    break;
                case /* string error */ 14:
                    message.error = reader.string();
                    break;
                case /* string panoLocation */ 15:
                    message.panoLocation = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VPUCCUDataMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* float saturation = 1; */
        if (message.saturation !== 0)
            writer.tag(1, WireType.Bit32).float(message.saturation);
        /* float hue = 3; */
        if (message.hue !== 0)
            writer.tag(3, WireType.Bit32).float(message.hue);
        /* float gamma = 4; */
        if (message.gamma !== 0)
            writer.tag(4, WireType.Bit32).float(message.gamma);
        /* float contrast = 5; */
        if (message.contrast !== 0)
            writer.tag(5, WireType.Bit32).float(message.contrast);
        /* float intensity = 6; */
        if (message.intensity !== 0)
            writer.tag(6, WireType.Bit32).float(message.intensity);
        /* float rx1 = 7; */
        if (message.rx1 !== 0)
            writer.tag(7, WireType.Bit32).float(message.rx1);
        /* float rx2 = 8; */
        if (message.rx2 !== 0)
            writer.tag(8, WireType.Bit32).float(message.rx2);
        /* float gx1 = 9; */
        if (message.gx1 !== 0)
            writer.tag(9, WireType.Bit32).float(message.gx1);
        /* float gx2 = 10; */
        if (message.gx2 !== 0)
            writer.tag(10, WireType.Bit32).float(message.gx2);
        /* float bx1 = 11; */
        if (message.bx1 !== 0)
            writer.tag(11, WireType.Bit32).float(message.bx1);
        /* float bx2 = 12; */
        if (message.bx2 !== 0)
            writer.tag(12, WireType.Bit32).float(message.bx2);
        /* bool success = 13; */
        if (message.success !== false)
            writer.tag(13, WireType.Varint).bool(message.success);
        /* string error = 14; */
        if (message.error !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.error);
        /* string panoLocation = 15; */
        if (message.panoLocation !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.panoLocation);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.VPUCCUDataMessage
 */
export const VPUCCUDataMessage = new VPUCCUDataMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DriveInformation$Type extends MessageType<DriveInformation> {
    constructor() {
        super("VpuGrpc.DriveInformation", [
            { no: 1, name: "letter", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "totalSpace", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "freeSpace", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "toolTip", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DriveInformation>): DriveInformation {
        const message = { letter: "", totalSpace: 0n, freeSpace: 0n, toolTip: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DriveInformation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DriveInformation): DriveInformation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string letter */ 1:
                    message.letter = reader.string();
                    break;
                case /* int64 totalSpace */ 2:
                    message.totalSpace = reader.int64().toBigInt();
                    break;
                case /* int64 freeSpace */ 3:
                    message.freeSpace = reader.int64().toBigInt();
                    break;
                case /* string toolTip */ 4:
                    message.toolTip = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DriveInformation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string letter = 1; */
        if (message.letter !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.letter);
        /* int64 totalSpace = 2; */
        if (message.totalSpace !== 0n)
            writer.tag(2, WireType.Varint).int64(message.totalSpace);
        /* int64 freeSpace = 3; */
        if (message.freeSpace !== 0n)
            writer.tag(3, WireType.Varint).int64(message.freeSpace);
        /* string toolTip = 4; */
        if (message.toolTip !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.toolTip);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.DriveInformation
 */
export const DriveInformation = new DriveInformation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Vpu2AgentUiGeneralInfo$Type extends MessageType<Vpu2AgentUiGeneralInfo> {
    constructor() {
        super("VpuGrpc.Vpu2AgentUiGeneralInfo", [
            { no: 1, name: "ap", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "alc", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "health", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "prettyReport", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "panoStreamKbps", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "hdStreamKbps", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "autoProductionType", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "vpuInitializationStage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "panoStreamStatus", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "hdStreamStatus", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "maskCrashReport", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "cpuUsage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "drives", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DriveInformation },
            { no: 14, name: "gpuUsage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 15, name: "cpuTemperature", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 16, name: "memoryUsage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 17, name: "backendConnection", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 23, name: "audioStatus", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 24, name: "alcValue", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 25, name: "alcHealth", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 26, name: "alcDesiredBrightness", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 27, name: "adapterStatus", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => AdapterStatus },
            { no: 28, name: "cameraStatus", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CameraStatus }
        ]);
    }
    create(value?: PartialMessage<Vpu2AgentUiGeneralInfo>): Vpu2AgentUiGeneralInfo {
        const message = { ap: "", alc: "", health: "", prettyReport: "", panoStreamKbps: 0, hdStreamKbps: 0, autoProductionType: "", vpuInitializationStage: "", panoStreamStatus: "", hdStreamStatus: "", maskCrashReport: false, cpuUsage: 0, drives: [], gpuUsage: 0, cpuTemperature: 0, memoryUsage: 0, backendConnection: false, audioStatus: false, alcValue: 0, alcHealth: 0, alcDesiredBrightness: 0, adapterStatus: [], cameraStatus: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Vpu2AgentUiGeneralInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Vpu2AgentUiGeneralInfo): Vpu2AgentUiGeneralInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string ap */ 1:
                    message.ap = reader.string();
                    break;
                case /* string alc */ 2:
                    message.alc = reader.string();
                    break;
                case /* string health */ 3:
                    message.health = reader.string();
                    break;
                case /* string prettyReport */ 4:
                    message.prettyReport = reader.string();
                    break;
                case /* uint32 panoStreamKbps */ 5:
                    message.panoStreamKbps = reader.uint32();
                    break;
                case /* uint32 hdStreamKbps */ 6:
                    message.hdStreamKbps = reader.uint32();
                    break;
                case /* string autoProductionType */ 7:
                    message.autoProductionType = reader.string();
                    break;
                case /* string vpuInitializationStage */ 8:
                    message.vpuInitializationStage = reader.string();
                    break;
                case /* string panoStreamStatus */ 9:
                    message.panoStreamStatus = reader.string();
                    break;
                case /* string hdStreamStatus */ 10:
                    message.hdStreamStatus = reader.string();
                    break;
                case /* bool maskCrashReport */ 11:
                    message.maskCrashReport = reader.bool();
                    break;
                case /* double cpuUsage */ 12:
                    message.cpuUsage = reader.double();
                    break;
                case /* repeated VpuGrpc.DriveInformation drives */ 13:
                    message.drives.push(DriveInformation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* double gpuUsage */ 14:
                    message.gpuUsage = reader.double();
                    break;
                case /* double cpuTemperature */ 15:
                    message.cpuTemperature = reader.double();
                    break;
                case /* double memoryUsage */ 16:
                    message.memoryUsage = reader.double();
                    break;
                case /* bool backendConnection */ 17:
                    message.backendConnection = reader.bool();
                    break;
                case /* bool audioStatus */ 23:
                    message.audioStatus = reader.bool();
                    break;
                case /* int32 alcValue */ 24:
                    message.alcValue = reader.int32();
                    break;
                case /* int32 alcHealth */ 25:
                    message.alcHealth = reader.int32();
                    break;
                case /* int32 alcDesiredBrightness */ 26:
                    message.alcDesiredBrightness = reader.int32();
                    break;
                case /* repeated CommonUsedMessages.AdapterStatus adapterStatus */ 27:
                    message.adapterStatus.push(AdapterStatus.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated CommonUsedMessages.CameraStatus cameraStatus */ 28:
                    message.cameraStatus.push(CameraStatus.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Vpu2AgentUiGeneralInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string ap = 1; */
        if (message.ap !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.ap);
        /* string alc = 2; */
        if (message.alc !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.alc);
        /* string health = 3; */
        if (message.health !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.health);
        /* string prettyReport = 4; */
        if (message.prettyReport !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.prettyReport);
        /* uint32 panoStreamKbps = 5; */
        if (message.panoStreamKbps !== 0)
            writer.tag(5, WireType.Varint).uint32(message.panoStreamKbps);
        /* uint32 hdStreamKbps = 6; */
        if (message.hdStreamKbps !== 0)
            writer.tag(6, WireType.Varint).uint32(message.hdStreamKbps);
        /* string autoProductionType = 7; */
        if (message.autoProductionType !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.autoProductionType);
        /* string vpuInitializationStage = 8; */
        if (message.vpuInitializationStage !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.vpuInitializationStage);
        /* string panoStreamStatus = 9; */
        if (message.panoStreamStatus !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.panoStreamStatus);
        /* string hdStreamStatus = 10; */
        if (message.hdStreamStatus !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.hdStreamStatus);
        /* bool maskCrashReport = 11; */
        if (message.maskCrashReport !== false)
            writer.tag(11, WireType.Varint).bool(message.maskCrashReport);
        /* double cpuUsage = 12; */
        if (message.cpuUsage !== 0)
            writer.tag(12, WireType.Bit64).double(message.cpuUsage);
        /* repeated VpuGrpc.DriveInformation drives = 13; */
        for (let i = 0; i < message.drives.length; i++)
            DriveInformation.internalBinaryWrite(message.drives[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* double gpuUsage = 14; */
        if (message.gpuUsage !== 0)
            writer.tag(14, WireType.Bit64).double(message.gpuUsage);
        /* double cpuTemperature = 15; */
        if (message.cpuTemperature !== 0)
            writer.tag(15, WireType.Bit64).double(message.cpuTemperature);
        /* double memoryUsage = 16; */
        if (message.memoryUsage !== 0)
            writer.tag(16, WireType.Bit64).double(message.memoryUsage);
        /* bool backendConnection = 17; */
        if (message.backendConnection !== false)
            writer.tag(17, WireType.Varint).bool(message.backendConnection);
        /* bool audioStatus = 23; */
        if (message.audioStatus !== false)
            writer.tag(23, WireType.Varint).bool(message.audioStatus);
        /* int32 alcValue = 24; */
        if (message.alcValue !== 0)
            writer.tag(24, WireType.Varint).int32(message.alcValue);
        /* int32 alcHealth = 25; */
        if (message.alcHealth !== 0)
            writer.tag(25, WireType.Varint).int32(message.alcHealth);
        /* int32 alcDesiredBrightness = 26; */
        if (message.alcDesiredBrightness !== 0)
            writer.tag(26, WireType.Varint).int32(message.alcDesiredBrightness);
        /* repeated CommonUsedMessages.AdapterStatus adapterStatus = 27; */
        for (let i = 0; i < message.adapterStatus.length; i++)
            AdapterStatus.internalBinaryWrite(message.adapterStatus[i], writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* repeated CommonUsedMessages.CameraStatus cameraStatus = 28; */
        for (let i = 0; i < message.cameraStatus.length; i++)
            CameraStatus.internalBinaryWrite(message.cameraStatus[i], writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.Vpu2AgentUiGeneralInfo
 */
export const Vpu2AgentUiGeneralInfo = new Vpu2AgentUiGeneralInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Vpu2AgentHealth$Type extends MessageType<Vpu2AgentHealth> {
    constructor() {
        super("VpuGrpc.Vpu2AgentHealth", [
            { no: 1, name: "healthValue", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "status", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "updateTime", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "maskCrashReport", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Vpu2AgentHealth>): Vpu2AgentHealth {
        const message = { healthValue: 0, status: false, updateTime: "", maskCrashReport: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Vpu2AgentHealth>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Vpu2AgentHealth): Vpu2AgentHealth {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double healthValue */ 1:
                    message.healthValue = reader.double();
                    break;
                case /* bool status */ 2:
                    message.status = reader.bool();
                    break;
                case /* string updateTime */ 3:
                    message.updateTime = reader.string();
                    break;
                case /* bool maskCrashReport */ 4:
                    message.maskCrashReport = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Vpu2AgentHealth, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double healthValue = 1; */
        if (message.healthValue !== 0)
            writer.tag(1, WireType.Bit64).double(message.healthValue);
        /* bool status = 2; */
        if (message.status !== false)
            writer.tag(2, WireType.Varint).bool(message.status);
        /* string updateTime = 3; */
        if (message.updateTime !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.updateTime);
        /* bool maskCrashReport = 4; */
        if (message.maskCrashReport !== false)
            writer.tag(4, WireType.Varint).bool(message.maskCrashReport);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.Vpu2AgentHealth
 */
export const Vpu2AgentHealth = new Vpu2AgentHealth$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Vpu2AgentCameraVersion$Type extends MessageType<Vpu2AgentCameraVersion> {
    constructor() {
        super("VpuGrpc.Vpu2AgentCameraVersion", [
            { no: 1, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Vpu2AgentCameraVersion>): Vpu2AgentCameraVersion {
        const message = { version: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Vpu2AgentCameraVersion>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Vpu2AgentCameraVersion): Vpu2AgentCameraVersion {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string version */ 1:
                    message.version = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Vpu2AgentCameraVersion, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string version = 1; */
        if (message.version !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.version);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.Vpu2AgentCameraVersion
 */
export const Vpu2AgentCameraVersion = new Vpu2AgentCameraVersion$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChosenDoublePlayAPCameraMessage$Type extends MessageType<ChosenDoublePlayAPCameraMessage> {
    constructor() {
        super("VpuGrpc.ChosenDoublePlayAPCameraMessage", [
            { no: 1, name: "cameraType", kind: "enum", T: () => ["VpuGrpc.ChosenDoublePlayAPCameraMessage.CameraType", ChosenDoublePlayAPCameraMessage_CameraType] }
        ]);
    }
    create(value?: PartialMessage<ChosenDoublePlayAPCameraMessage>): ChosenDoublePlayAPCameraMessage {
        const message = { cameraType: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ChosenDoublePlayAPCameraMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChosenDoublePlayAPCameraMessage): ChosenDoublePlayAPCameraMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuGrpc.ChosenDoublePlayAPCameraMessage.CameraType cameraType */ 1:
                    message.cameraType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChosenDoublePlayAPCameraMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuGrpc.ChosenDoublePlayAPCameraMessage.CameraType cameraType = 1; */
        if (message.cameraType !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.ChosenDoublePlayAPCameraMessage
 */
export const ChosenDoublePlayAPCameraMessage = new ChosenDoublePlayAPCameraMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Agent2VpuReason$Type extends MessageType<Agent2VpuReason> {
    constructor() {
        super("VpuGrpc.Agent2VpuReason", [
            { no: 1, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Agent2VpuReason>): Agent2VpuReason {
        const message = { reason: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Agent2VpuReason>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Agent2VpuReason): Agent2VpuReason {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string reason */ 1:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Agent2VpuReason, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string reason = 1; */
        if (message.reason !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.Agent2VpuReason
 */
export const Agent2VpuReason = new Agent2VpuReason$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentUi2VpuCommandMessage$Type extends MessageType<AgentUi2VpuCommandMessage> {
    constructor() {
        super("VpuGrpc.AgentUi2VpuCommandMessage", [
            { no: 1, name: "agentUi2VpuCommandString", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AgentUi2VpuCommandMessage>): AgentUi2VpuCommandMessage {
        const message = { agentUi2VpuCommandString: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AgentUi2VpuCommandMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AgentUi2VpuCommandMessage): AgentUi2VpuCommandMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string agentUi2VpuCommandString */ 1:
                    message.agentUi2VpuCommandString = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AgentUi2VpuCommandMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string agentUi2VpuCommandString = 1; */
        if (message.agentUi2VpuCommandString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.agentUi2VpuCommandString);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.AgentUi2VpuCommandMessage
 */
export const AgentUi2VpuCommandMessage = new AgentUi2VpuCommandMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Vpu2AgentUiCommandListMessage$Type extends MessageType<Vpu2AgentUiCommandListMessage> {
    constructor() {
        super("VpuGrpc.Vpu2AgentUiCommandListMessage", [
            { no: 1, name: "Vpu2AgentUiGroupNameList", kind: "scalar", jsonName: "Vpu2AgentUiGroupNameList", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "Vpu2AgentUiCommandDetailsList", kind: "message", jsonName: "Vpu2AgentUiCommandDetailsList", repeat: 1 /*RepeatType.PACKED*/, T: () => Vpu2AgentUiCommandListMessage_Vpu2AgentUiCommandDetails }
        ]);
    }
    create(value?: PartialMessage<Vpu2AgentUiCommandListMessage>): Vpu2AgentUiCommandListMessage {
        const message = { vpu2AgentUiGroupNameList: [], vpu2AgentUiCommandDetailsList: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Vpu2AgentUiCommandListMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Vpu2AgentUiCommandListMessage): Vpu2AgentUiCommandListMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string Vpu2AgentUiGroupNameList = 1 [json_name = "Vpu2AgentUiGroupNameList"];*/ 1:
                    message.vpu2AgentUiGroupNameList.push(reader.string());
                    break;
                case /* repeated VpuGrpc.Vpu2AgentUiCommandListMessage.Vpu2AgentUiCommandDetails Vpu2AgentUiCommandDetailsList = 2 [json_name = "Vpu2AgentUiCommandDetailsList"];*/ 2:
                    message.vpu2AgentUiCommandDetailsList.push(Vpu2AgentUiCommandListMessage_Vpu2AgentUiCommandDetails.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Vpu2AgentUiCommandListMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string Vpu2AgentUiGroupNameList = 1 [json_name = "Vpu2AgentUiGroupNameList"]; */
        for (let i = 0; i < message.vpu2AgentUiGroupNameList.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.vpu2AgentUiGroupNameList[i]);
        /* repeated VpuGrpc.Vpu2AgentUiCommandListMessage.Vpu2AgentUiCommandDetails Vpu2AgentUiCommandDetailsList = 2 [json_name = "Vpu2AgentUiCommandDetailsList"]; */
        for (let i = 0; i < message.vpu2AgentUiCommandDetailsList.length; i++)
            Vpu2AgentUiCommandListMessage_Vpu2AgentUiCommandDetails.internalBinaryWrite(message.vpu2AgentUiCommandDetailsList[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.Vpu2AgentUiCommandListMessage
 */
export const Vpu2AgentUiCommandListMessage = new Vpu2AgentUiCommandListMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Vpu2AgentUiCommandListMessage_Vpu2AgentUiCommandDetails$Type extends MessageType<Vpu2AgentUiCommandListMessage_Vpu2AgentUiCommandDetails> {
    constructor() {
        super("VpuGrpc.Vpu2AgentUiCommandListMessage.Vpu2AgentUiCommandDetails", [
            { no: 1, name: "Vpu2AgentUiCommandName", kind: "scalar", jsonName: "Vpu2AgentUiCommandName", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "Vpu2AgentUiGroupNum", kind: "scalar", jsonName: "Vpu2AgentUiGroupNum", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "ExpertMode", kind: "scalar", jsonName: "ExpertMode", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Vpu2AgentUiCommandListMessage_Vpu2AgentUiCommandDetails>): Vpu2AgentUiCommandListMessage_Vpu2AgentUiCommandDetails {
        const message = { vpu2AgentUiCommandName: "", vpu2AgentUiGroupNum: 0, expertMode: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Vpu2AgentUiCommandListMessage_Vpu2AgentUiCommandDetails>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Vpu2AgentUiCommandListMessage_Vpu2AgentUiCommandDetails): Vpu2AgentUiCommandListMessage_Vpu2AgentUiCommandDetails {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string Vpu2AgentUiCommandName = 1 [json_name = "Vpu2AgentUiCommandName"];*/ 1:
                    message.vpu2AgentUiCommandName = reader.string();
                    break;
                case /* int32 Vpu2AgentUiGroupNum = 2 [json_name = "Vpu2AgentUiGroupNum"];*/ 2:
                    message.vpu2AgentUiGroupNum = reader.int32();
                    break;
                case /* bool ExpertMode = 3 [json_name = "ExpertMode"];*/ 3:
                    message.expertMode = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Vpu2AgentUiCommandListMessage_Vpu2AgentUiCommandDetails, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string Vpu2AgentUiCommandName = 1 [json_name = "Vpu2AgentUiCommandName"]; */
        if (message.vpu2AgentUiCommandName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.vpu2AgentUiCommandName);
        /* int32 Vpu2AgentUiGroupNum = 2 [json_name = "Vpu2AgentUiGroupNum"]; */
        if (message.vpu2AgentUiGroupNum !== 0)
            writer.tag(2, WireType.Varint).int32(message.vpu2AgentUiGroupNum);
        /* bool ExpertMode = 3 [json_name = "ExpertMode"]; */
        if (message.expertMode !== false)
            writer.tag(3, WireType.Varint).bool(message.expertMode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.Vpu2AgentUiCommandListMessage.Vpu2AgentUiCommandDetails
 */
export const Vpu2AgentUiCommandListMessage_Vpu2AgentUiCommandDetails = new Vpu2AgentUiCommandListMessage_Vpu2AgentUiCommandDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentService2AgentGuiInfoMessage$Type extends MessageType<AgentService2AgentGuiInfoMessage> {
    constructor() {
        super("VpuGrpc.AgentService2AgentGuiInfoMessage", [
            { no: 1, name: "systemType", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "paramDetailsList", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => AgentService2AgentGuiInfoMessage_paramDetails }
        ]);
    }
    create(value?: PartialMessage<AgentService2AgentGuiInfoMessage>): AgentService2AgentGuiInfoMessage {
        const message = { systemType: "", paramDetailsList: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AgentService2AgentGuiInfoMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AgentService2AgentGuiInfoMessage): AgentService2AgentGuiInfoMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string systemType */ 1:
                    message.systemType = reader.string();
                    break;
                case /* repeated VpuGrpc.AgentService2AgentGuiInfoMessage.paramDetails paramDetailsList */ 2:
                    message.paramDetailsList.push(AgentService2AgentGuiInfoMessage_paramDetails.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AgentService2AgentGuiInfoMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string systemType = 1; */
        if (message.systemType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.systemType);
        /* repeated VpuGrpc.AgentService2AgentGuiInfoMessage.paramDetails paramDetailsList = 2; */
        for (let i = 0; i < message.paramDetailsList.length; i++)
            AgentService2AgentGuiInfoMessage_paramDetails.internalBinaryWrite(message.paramDetailsList[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.AgentService2AgentGuiInfoMessage
 */
export const AgentService2AgentGuiInfoMessage = new AgentService2AgentGuiInfoMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentService2AgentGuiInfoMessage_paramDetails$Type extends MessageType<AgentService2AgentGuiInfoMessage_paramDetails> {
    constructor() {
        super("VpuGrpc.AgentService2AgentGuiInfoMessage.paramDetails", [
            { no: 2, name: "paramName", kind: "enum", T: () => ["VpuGrpc.AgentService2AgentGuiInfoMessage.paramNameEnum", AgentService2AgentGuiInfoMessage_paramNameEnum] },
            { no: 3, name: "paramValue", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AgentService2AgentGuiInfoMessage_paramDetails>): AgentService2AgentGuiInfoMessage_paramDetails {
        const message = { paramName: 0, paramValue: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AgentService2AgentGuiInfoMessage_paramDetails>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AgentService2AgentGuiInfoMessage_paramDetails): AgentService2AgentGuiInfoMessage_paramDetails {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuGrpc.AgentService2AgentGuiInfoMessage.paramNameEnum paramName */ 2:
                    message.paramName = reader.int32();
                    break;
                case /* string paramValue */ 3:
                    message.paramValue = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AgentService2AgentGuiInfoMessage_paramDetails, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuGrpc.AgentService2AgentGuiInfoMessage.paramNameEnum paramName = 2; */
        if (message.paramName !== 0)
            writer.tag(2, WireType.Varint).int32(message.paramName);
        /* string paramValue = 3; */
        if (message.paramValue !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.paramValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.AgentService2AgentGuiInfoMessage.paramDetails
 */
export const AgentService2AgentGuiInfoMessage_paramDetails = new AgentService2AgentGuiInfoMessage_paramDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentService2AgentGuiEventRecordMessage$Type extends MessageType<AgentService2AgentGuiEventRecordMessage> {
    constructor() {
        super("VpuGrpc.AgentService2AgentGuiEventRecordMessage", [
            { no: 1, name: "fileType", kind: "enum", T: () => ["VpuGrpc.AgentService2AgentGuiEventRecordMessage.fileTypeEnum", AgentService2AgentGuiEventRecordMessage_fileTypeEnum] },
            { no: 2, name: "EventRecordList", kind: "message", jsonName: "EventRecordList", repeat: 1 /*RepeatType.PACKED*/, T: () => AgentService2AgentGuiEventRecordMessage_EventRecordDetails }
        ]);
    }
    create(value?: PartialMessage<AgentService2AgentGuiEventRecordMessage>): AgentService2AgentGuiEventRecordMessage {
        const message = { fileType: 0, eventRecordList: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AgentService2AgentGuiEventRecordMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AgentService2AgentGuiEventRecordMessage): AgentService2AgentGuiEventRecordMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuGrpc.AgentService2AgentGuiEventRecordMessage.fileTypeEnum fileType */ 1:
                    message.fileType = reader.int32();
                    break;
                case /* repeated VpuGrpc.AgentService2AgentGuiEventRecordMessage.EventRecordDetails EventRecordList = 2 [json_name = "EventRecordList"];*/ 2:
                    message.eventRecordList.push(AgentService2AgentGuiEventRecordMessage_EventRecordDetails.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AgentService2AgentGuiEventRecordMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuGrpc.AgentService2AgentGuiEventRecordMessage.fileTypeEnum fileType = 1; */
        if (message.fileType !== 0)
            writer.tag(1, WireType.Varint).int32(message.fileType);
        /* repeated VpuGrpc.AgentService2AgentGuiEventRecordMessage.EventRecordDetails EventRecordList = 2 [json_name = "EventRecordList"]; */
        for (let i = 0; i < message.eventRecordList.length; i++)
            AgentService2AgentGuiEventRecordMessage_EventRecordDetails.internalBinaryWrite(message.eventRecordList[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.AgentService2AgentGuiEventRecordMessage
 */
export const AgentService2AgentGuiEventRecordMessage = new AgentService2AgentGuiEventRecordMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentService2AgentGuiEventRecordMessage_EventRecordDetails$Type extends MessageType<AgentService2AgentGuiEventRecordMessage_EventRecordDetails> {
    constructor() {
        super("VpuGrpc.AgentService2AgentGuiEventRecordMessage.EventRecordDetails", [
            { no: 1, name: "startDate", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "eventId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "length", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "eventName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AgentService2AgentGuiEventRecordMessage_EventRecordDetails>): AgentService2AgentGuiEventRecordMessage_EventRecordDetails {
        const message = { startDate: "", eventId: "", length: "", eventName: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AgentService2AgentGuiEventRecordMessage_EventRecordDetails>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AgentService2AgentGuiEventRecordMessage_EventRecordDetails): AgentService2AgentGuiEventRecordMessage_EventRecordDetails {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string startDate */ 1:
                    message.startDate = reader.string();
                    break;
                case /* string eventId */ 2:
                    message.eventId = reader.string();
                    break;
                case /* string length */ 3:
                    message.length = reader.string();
                    break;
                case /* string eventName */ 4:
                    message.eventName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AgentService2AgentGuiEventRecordMessage_EventRecordDetails, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string startDate = 1; */
        if (message.startDate !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.startDate);
        /* string eventId = 2; */
        if (message.eventId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.eventId);
        /* string length = 3; */
        if (message.length !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.length);
        /* string eventName = 4; */
        if (message.eventName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.eventName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.AgentService2AgentGuiEventRecordMessage.EventRecordDetails
 */
export const AgentService2AgentGuiEventRecordMessage_EventRecordDetails = new AgentService2AgentGuiEventRecordMessage_EventRecordDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentToVPUGenericCommandDetails$Type extends MessageType<AgentToVPUGenericCommandDetails> {
    constructor() {
        super("VpuGrpc.AgentToVPUGenericCommandDetails", [
            { no: 1, name: "agentToVPUGenericCommandName", kind: "enum", T: () => ["VpuGrpc.AgentToVPUGenericCommandDetails.AgentToVPUGenericCommandEnum", AgentToVPUGenericCommandDetails_AgentToVPUGenericCommandEnum] },
            { no: 2, name: "commnadParam", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "imageType", kind: "enum", T: () => ["VpuGrpc.AgentToVPUGenericCommandDetails.ImageTypeEnum", AgentToVPUGenericCommandDetails_ImageTypeEnum] },
            { no: 4, name: "rotateFrames", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AgentToVPUGenericCommandDetails>): AgentToVPUGenericCommandDetails {
        const message = { agentToVPUGenericCommandName: 0, commnadParam: "", imageType: 0, rotateFrames: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AgentToVPUGenericCommandDetails>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AgentToVPUGenericCommandDetails): AgentToVPUGenericCommandDetails {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuGrpc.AgentToVPUGenericCommandDetails.AgentToVPUGenericCommandEnum agentToVPUGenericCommandName */ 1:
                    message.agentToVPUGenericCommandName = reader.int32();
                    break;
                case /* string commnadParam */ 2:
                    message.commnadParam = reader.string();
                    break;
                case /* VpuGrpc.AgentToVPUGenericCommandDetails.ImageTypeEnum imageType */ 3:
                    message.imageType = reader.int32();
                    break;
                case /* bool rotateFrames */ 4:
                    message.rotateFrames = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AgentToVPUGenericCommandDetails, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuGrpc.AgentToVPUGenericCommandDetails.AgentToVPUGenericCommandEnum agentToVPUGenericCommandName = 1; */
        if (message.agentToVPUGenericCommandName !== 0)
            writer.tag(1, WireType.Varint).int32(message.agentToVPUGenericCommandName);
        /* string commnadParam = 2; */
        if (message.commnadParam !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.commnadParam);
        /* VpuGrpc.AgentToVPUGenericCommandDetails.ImageTypeEnum imageType = 3; */
        if (message.imageType !== 0)
            writer.tag(3, WireType.Varint).int32(message.imageType);
        /* bool rotateFrames = 4; */
        if (message.rotateFrames !== false)
            writer.tag(4, WireType.Varint).bool(message.rotateFrames);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.AgentToVPUGenericCommandDetails
 */
export const AgentToVPUGenericCommandDetails = new AgentToVPUGenericCommandDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentGui2AgentServiceCommandMessage$Type extends MessageType<AgentGui2AgentServiceCommandMessage> {
    constructor() {
        super("VpuGrpc.AgentGui2AgentServiceCommandMessage", [
            { no: 1, name: "agentUi2AgentCommand", kind: "enum", T: () => ["VpuGrpc.AgentGui2AgentServiceCommandMessage.AgentGui2AgentCommnadEnum", AgentGui2AgentServiceCommandMessage_AgentGui2AgentCommnadEnum] },
            { no: 2, name: "commandParamStr", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "commandParamBool", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AgentGui2AgentServiceCommandMessage>): AgentGui2AgentServiceCommandMessage {
        const message = { agentUi2AgentCommand: 0, commandParamStr: "", commandParamBool: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AgentGui2AgentServiceCommandMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AgentGui2AgentServiceCommandMessage): AgentGui2AgentServiceCommandMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuGrpc.AgentGui2AgentServiceCommandMessage.AgentGui2AgentCommnadEnum agentUi2AgentCommand */ 1:
                    message.agentUi2AgentCommand = reader.int32();
                    break;
                case /* string commandParamStr */ 2:
                    message.commandParamStr = reader.string();
                    break;
                case /* bool commandParamBool */ 3:
                    message.commandParamBool = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AgentGui2AgentServiceCommandMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuGrpc.AgentGui2AgentServiceCommandMessage.AgentGui2AgentCommnadEnum agentUi2AgentCommand = 1; */
        if (message.agentUi2AgentCommand !== 0)
            writer.tag(1, WireType.Varint).int32(message.agentUi2AgentCommand);
        /* string commandParamStr = 2; */
        if (message.commandParamStr !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.commandParamStr);
        /* bool commandParamBool = 3; */
        if (message.commandParamBool !== false)
            writer.tag(3, WireType.Varint).bool(message.commandParamBool);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.AgentGui2AgentServiceCommandMessage
 */
export const AgentGui2AgentServiceCommandMessage = new AgentGui2AgentServiceCommandMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CoachingAdditionalAngleListMessage$Type extends MessageType<CoachingAdditionalAngleListMessage> {
    constructor() {
        super("VpuGrpc.CoachingAdditionalAngleListMessage", [
            { no: 1, name: "aaDetails", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CoachingAdditionalAnglesMessage }
        ]);
    }
    create(value?: PartialMessage<CoachingAdditionalAngleListMessage>): CoachingAdditionalAngleListMessage {
        const message = { aaDetails: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CoachingAdditionalAngleListMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CoachingAdditionalAngleListMessage): CoachingAdditionalAngleListMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated VpuGrpc.CoachingAdditionalAnglesMessage aaDetails */ 1:
                    message.aaDetails.push(CoachingAdditionalAnglesMessage.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CoachingAdditionalAngleListMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated VpuGrpc.CoachingAdditionalAnglesMessage aaDetails = 1; */
        for (let i = 0; i < message.aaDetails.length; i++)
            CoachingAdditionalAnglesMessage.internalBinaryWrite(message.aaDetails[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.CoachingAdditionalAngleListMessage
 */
export const CoachingAdditionalAngleListMessage = new CoachingAdditionalAngleListMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CoachingAdditionalAnglesMessage$Type extends MessageType<CoachingAdditionalAnglesMessage> {
    constructor() {
        super("VpuGrpc.CoachingAdditionalAnglesMessage", [
            { no: 1, name: "cameraName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "enable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CoachingAdditionalAnglesMessage>): CoachingAdditionalAnglesMessage {
        const message = { cameraName: "", url: "", enable: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CoachingAdditionalAnglesMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CoachingAdditionalAnglesMessage): CoachingAdditionalAnglesMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string cameraName */ 1:
                    message.cameraName = reader.string();
                    break;
                case /* string url */ 2:
                    message.url = reader.string();
                    break;
                case /* bool enable */ 3:
                    message.enable = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CoachingAdditionalAnglesMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string cameraName = 1; */
        if (message.cameraName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.cameraName);
        /* string url = 2; */
        if (message.url !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.url);
        /* bool enable = 3; */
        if (message.enable !== false)
            writer.tag(3, WireType.Varint).bool(message.enable);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.CoachingAdditionalAnglesMessage
 */
export const CoachingAdditionalAnglesMessage = new CoachingAdditionalAnglesMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddStreamMessage$Type extends MessageType<AddStreamMessage> {
    constructor() {
        super("VpuGrpc.AddStreamMessage", [
            { no: 1, name: "encoderName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "encoderIdx", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "streamUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "s3Bucket", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "s3Region", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "awsAccessKeyId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "awsSecretAccessKey", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "awsSessionToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AddStreamMessage>): AddStreamMessage {
        const message = { encoderName: "", encoderIdx: 0, streamUrl: "", s3Bucket: "", s3Region: "", awsAccessKeyId: "", awsSecretAccessKey: "", awsSessionToken: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AddStreamMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddStreamMessage): AddStreamMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string encoderName */ 1:
                    message.encoderName = reader.string();
                    break;
                case /* int32 encoderIdx */ 2:
                    message.encoderIdx = reader.int32();
                    break;
                case /* string streamUrl */ 3:
                    message.streamUrl = reader.string();
                    break;
                case /* string s3Bucket */ 4:
                    message.s3Bucket = reader.string();
                    break;
                case /* string s3Region */ 5:
                    message.s3Region = reader.string();
                    break;
                case /* string awsAccessKeyId */ 6:
                    message.awsAccessKeyId = reader.string();
                    break;
                case /* string awsSecretAccessKey */ 7:
                    message.awsSecretAccessKey = reader.string();
                    break;
                case /* string awsSessionToken */ 8:
                    message.awsSessionToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddStreamMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string encoderName = 1; */
        if (message.encoderName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.encoderName);
        /* int32 encoderIdx = 2; */
        if (message.encoderIdx !== 0)
            writer.tag(2, WireType.Varint).int32(message.encoderIdx);
        /* string streamUrl = 3; */
        if (message.streamUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.streamUrl);
        /* string s3Bucket = 4; */
        if (message.s3Bucket !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.s3Bucket);
        /* string s3Region = 5; */
        if (message.s3Region !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.s3Region);
        /* string awsAccessKeyId = 6; */
        if (message.awsAccessKeyId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.awsAccessKeyId);
        /* string awsSecretAccessKey = 7; */
        if (message.awsSecretAccessKey !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.awsSecretAccessKey);
        /* string awsSessionToken = 8; */
        if (message.awsSessionToken !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.awsSessionToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.AddStreamMessage
 */
export const AddStreamMessage = new AddStreamMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveStreamMessage$Type extends MessageType<RemoveStreamMessage> {
    constructor() {
        super("VpuGrpc.RemoveStreamMessage", [
            { no: 1, name: "encoderName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "encoderIdx", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "streamUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RemoveStreamMessage>): RemoveStreamMessage {
        const message = { encoderName: "", encoderIdx: 0, streamUrl: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RemoveStreamMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveStreamMessage): RemoveStreamMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string encoderName */ 1:
                    message.encoderName = reader.string();
                    break;
                case /* int32 encoderIdx */ 2:
                    message.encoderIdx = reader.int32();
                    break;
                case /* string streamUrl */ 3:
                    message.streamUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveStreamMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string encoderName = 1; */
        if (message.encoderName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.encoderName);
        /* int32 encoderIdx = 2; */
        if (message.encoderIdx !== 0)
            writer.tag(2, WireType.Varint).int32(message.encoderIdx);
        /* string streamUrl = 3; */
        if (message.streamUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.streamUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.RemoveStreamMessage
 */
export const RemoveStreamMessage = new RemoveStreamMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InstantHighlightsMessage$Type extends MessageType<InstantHighlightsMessage> {
    constructor() {
        super("VpuGrpc.InstantHighlightsMessage", [
            { no: 1, name: "metadataPath", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "subProductionType", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<InstantHighlightsMessage>): InstantHighlightsMessage {
        const message = { metadataPath: "", subProductionType: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<InstantHighlightsMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InstantHighlightsMessage): InstantHighlightsMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string metadataPath */ 1:
                    message.metadataPath = reader.string();
                    break;
                case /* string subProductionType */ 2:
                    message.subProductionType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InstantHighlightsMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string metadataPath = 1; */
        if (message.metadataPath !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.metadataPath);
        /* string subProductionType = 2; */
        if (message.subProductionType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.subProductionType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.InstantHighlightsMessage
 */
export const InstantHighlightsMessage = new InstantHighlightsMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateStreamBitRateMessage$Type extends MessageType<UpdateStreamBitRateMessage> {
    constructor() {
        super("VpuGrpc.UpdateStreamBitRateMessage", [
            { no: 1, name: "encoderName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "encoderIdx", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "bitRate", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateStreamBitRateMessage>): UpdateStreamBitRateMessage {
        const message = { encoderName: "", encoderIdx: 0, bitRate: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UpdateStreamBitRateMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateStreamBitRateMessage): UpdateStreamBitRateMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string encoderName */ 1:
                    message.encoderName = reader.string();
                    break;
                case /* int32 encoderIdx */ 2:
                    message.encoderIdx = reader.int32();
                    break;
                case /* int32 bitRate */ 3:
                    message.bitRate = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateStreamBitRateMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string encoderName = 1; */
        if (message.encoderName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.encoderName);
        /* int32 encoderIdx = 2; */
        if (message.encoderIdx !== 0)
            writer.tag(2, WireType.Varint).int32(message.encoderIdx);
        /* int32 bitRate = 3; */
        if (message.bitRate !== 0)
            writer.tag(3, WireType.Varint).int32(message.bitRate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.UpdateStreamBitRateMessage
 */
export const UpdateStreamBitRateMessage = new UpdateStreamBitRateMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraFPSChangeStatus$Type extends MessageType<CameraFPSChangeStatus> {
    constructor() {
        super("VpuGrpc.CameraFPSChangeStatus", []);
    }
    create(value?: PartialMessage<CameraFPSChangeStatus>): CameraFPSChangeStatus {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraFPSChangeStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraFPSChangeStatus): CameraFPSChangeStatus {
        return target ?? this.create();
    }
    internalBinaryWrite(message: CameraFPSChangeStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.CameraFPSChangeStatus
 */
export const CameraFPSChangeStatus = new CameraFPSChangeStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GraphicsEngineTypeMessage$Type extends MessageType<GraphicsEngineTypeMessage> {
    constructor() {
        super("VpuGrpc.GraphicsEngineTypeMessage", [
            { no: 1, name: "engineType", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GraphicsEngineTypeMessage>): GraphicsEngineTypeMessage {
        const message = { engineType: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GraphicsEngineTypeMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GraphicsEngineTypeMessage): GraphicsEngineTypeMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string engineType */ 1:
                    message.engineType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GraphicsEngineTypeMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string engineType = 1; */
        if (message.engineType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.engineType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.GraphicsEngineTypeMessage
 */
export const GraphicsEngineTypeMessage = new GraphicsEngineTypeMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RestartGraphicsMessage$Type extends MessageType<RestartGraphicsMessage> {
    constructor() {
        super("VpuGrpc.RestartGraphicsMessage", [
            { no: 1, name: "value", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "graphicsClientUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "force", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "oldGraphicsPortNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "venueEnvironment", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "proxyUsername", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "proxyPassword", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "useProxy", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "metadataDir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "logConsoleMessages", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<RestartGraphicsMessage>): RestartGraphicsMessage {
        const message = { value: false, graphicsClientUrl: "", force: false, oldGraphicsPortNumber: 0, venueEnvironment: "", proxyUsername: "", proxyPassword: "", useProxy: false, metadataDir: "", logConsoleMessages: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RestartGraphicsMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RestartGraphicsMessage): RestartGraphicsMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool value */ 1:
                    message.value = reader.bool();
                    break;
                case /* string graphicsClientUrl */ 2:
                    message.graphicsClientUrl = reader.string();
                    break;
                case /* bool force */ 3:
                    message.force = reader.bool();
                    break;
                case /* int32 oldGraphicsPortNumber */ 4:
                    message.oldGraphicsPortNumber = reader.int32();
                    break;
                case /* string venueEnvironment */ 5:
                    message.venueEnvironment = reader.string();
                    break;
                case /* string proxyUsername */ 6:
                    message.proxyUsername = reader.string();
                    break;
                case /* string proxyPassword */ 7:
                    message.proxyPassword = reader.string();
                    break;
                case /* bool useProxy */ 8:
                    message.useProxy = reader.bool();
                    break;
                case /* string metadataDir */ 9:
                    message.metadataDir = reader.string();
                    break;
                case /* bool logConsoleMessages */ 10:
                    message.logConsoleMessages = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RestartGraphicsMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool value = 1; */
        if (message.value !== false)
            writer.tag(1, WireType.Varint).bool(message.value);
        /* string graphicsClientUrl = 2; */
        if (message.graphicsClientUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.graphicsClientUrl);
        /* bool force = 3; */
        if (message.force !== false)
            writer.tag(3, WireType.Varint).bool(message.force);
        /* int32 oldGraphicsPortNumber = 4; */
        if (message.oldGraphicsPortNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.oldGraphicsPortNumber);
        /* string venueEnvironment = 5; */
        if (message.venueEnvironment !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.venueEnvironment);
        /* string proxyUsername = 6; */
        if (message.proxyUsername !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.proxyUsername);
        /* string proxyPassword = 7; */
        if (message.proxyPassword !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.proxyPassword);
        /* bool useProxy = 8; */
        if (message.useProxy !== false)
            writer.tag(8, WireType.Varint).bool(message.useProxy);
        /* string metadataDir = 9; */
        if (message.metadataDir !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.metadataDir);
        /* bool logConsoleMessages = 10; */
        if (message.logConsoleMessages !== false)
            writer.tag(10, WireType.Varint).bool(message.logConsoleMessages);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.RestartGraphicsMessage
 */
export const RestartGraphicsMessage = new RestartGraphicsMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SingularFlowMessage$Type extends MessageType<SingularFlowMessage> {
    constructor() {
        super("VpuGrpc.SingularFlowMessage", [
            { no: 1, name: "flowCommand", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["VpuGrpc.SingularFlowMessage.flowCommandType", SingularFlowMessage_flowCommandType] }
        ]);
    }
    create(value?: PartialMessage<SingularFlowMessage>): SingularFlowMessage {
        const message = { flowCommand: "", type: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SingularFlowMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SingularFlowMessage): SingularFlowMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string flowCommand */ 1:
                    message.flowCommand = reader.string();
                    break;
                case /* VpuGrpc.SingularFlowMessage.flowCommandType type */ 2:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SingularFlowMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string flowCommand = 1; */
        if (message.flowCommand !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.flowCommand);
        /* VpuGrpc.SingularFlowMessage.flowCommandType type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.SingularFlowMessage
 */
export const SingularFlowMessage = new SingularFlowMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventUpdateMessage$Type extends MessageType<EventUpdateMessage> {
    constructor() {
        super("VpuGrpc.EventUpdateMessage", [
            { no: 1, name: "eventId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "received", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "metadataPath", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "forceAsSecondaryEvent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "venueEnvironment", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "sportType", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "lgepAddress", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "lgepAuth", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "sendMidrollCues", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "venueId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EventUpdateMessage>): EventUpdateMessage {
        const message = { eventId: "", received: false, metadataPath: "", forceAsSecondaryEvent: false, venueEnvironment: "", sportType: "", lgepAddress: "", lgepAuth: "", sendMidrollCues: false, venueId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<EventUpdateMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EventUpdateMessage): EventUpdateMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string eventId */ 1:
                    message.eventId = reader.string();
                    break;
                case /* bool received */ 2:
                    message.received = reader.bool();
                    break;
                case /* string metadataPath */ 3:
                    message.metadataPath = reader.string();
                    break;
                case /* bool forceAsSecondaryEvent */ 4:
                    message.forceAsSecondaryEvent = reader.bool();
                    break;
                case /* string venueEnvironment */ 5:
                    message.venueEnvironment = reader.string();
                    break;
                case /* string sportType */ 6:
                    message.sportType = reader.string();
                    break;
                case /* string lgepAddress */ 7:
                    message.lgepAddress = reader.string();
                    break;
                case /* string lgepAuth */ 8:
                    message.lgepAuth = reader.string();
                    break;
                case /* bool sendMidrollCues */ 9:
                    message.sendMidrollCues = reader.bool();
                    break;
                case /* string venueId */ 10:
                    message.venueId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EventUpdateMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string eventId = 1; */
        if (message.eventId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.eventId);
        /* bool received = 2; */
        if (message.received !== false)
            writer.tag(2, WireType.Varint).bool(message.received);
        /* string metadataPath = 3; */
        if (message.metadataPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.metadataPath);
        /* bool forceAsSecondaryEvent = 4; */
        if (message.forceAsSecondaryEvent !== false)
            writer.tag(4, WireType.Varint).bool(message.forceAsSecondaryEvent);
        /* string venueEnvironment = 5; */
        if (message.venueEnvironment !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.venueEnvironment);
        /* string sportType = 6; */
        if (message.sportType !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.sportType);
        /* string lgepAddress = 7; */
        if (message.lgepAddress !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.lgepAddress);
        /* string lgepAuth = 8; */
        if (message.lgepAuth !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.lgepAuth);
        /* bool sendMidrollCues = 9; */
        if (message.sendMidrollCues !== false)
            writer.tag(9, WireType.Varint).bool(message.sendMidrollCues);
        /* string venueId = 10; */
        if (message.venueId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.venueId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.EventUpdateMessage
 */
export const EventUpdateMessage = new EventUpdateMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OcrDataMessage$Type extends MessageType<OcrDataMessage> {
    constructor() {
        super("VpuGrpc.OcrDataMessage", [
            { no: 1, name: "homeScore", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "awayScore", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "period", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "down", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "distance", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "homeGamesWon", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "awayGamesWon", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "shotClock", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "homeFouls", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "awayFouls", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "ocrFailed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "possessionIndicator", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "penaltyClock", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "homeShotsOnGoal", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "awayShotsOnGoal", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "powerPlayIndicator", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "setNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "homeSetScore", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 20, name: "awaySetScore", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "homeTimeoutCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 22, name: "awayTimeoutCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 23, name: "homeChallengeCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 24, name: "awayChallengeCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 25, name: "inning", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 26, name: "outs", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 27, name: "balls", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 28, name: "strikes", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 29, name: "runsPerInning", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 30, name: "homeTimeoutsLeft", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 31, name: "awayTimeoutsLeft", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 32, name: "timeOutIndicator", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 33, name: "timestampMs", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<OcrDataMessage>): OcrDataMessage {
        const message = { homeScore: 0, awayScore: 0, time: "", period: "", down: "", distance: "", homeGamesWon: "", awayGamesWon: "", shotClock: "", homeFouls: 0, awayFouls: 0, ocrFailed: false, possessionIndicator: "", penaltyClock: "", homeShotsOnGoal: 0, awayShotsOnGoal: 0, powerPlayIndicator: "", setNumber: 0, homeSetScore: 0, awaySetScore: 0, homeTimeoutCount: 0, awayTimeoutCount: 0, homeChallengeCount: 0, awayChallengeCount: 0, inning: 0, outs: 0, balls: 0, strikes: 0, runsPerInning: 0, homeTimeoutsLeft: 0, awayTimeoutsLeft: 0, timeOutIndicator: "", timestampMs: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OcrDataMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OcrDataMessage): OcrDataMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 homeScore */ 1:
                    message.homeScore = reader.int32();
                    break;
                case /* int32 awayScore */ 2:
                    message.awayScore = reader.int32();
                    break;
                case /* string time */ 3:
                    message.time = reader.string();
                    break;
                case /* string period */ 4:
                    message.period = reader.string();
                    break;
                case /* string down */ 5:
                    message.down = reader.string();
                    break;
                case /* string distance */ 6:
                    message.distance = reader.string();
                    break;
                case /* string homeGamesWon */ 7:
                    message.homeGamesWon = reader.string();
                    break;
                case /* string awayGamesWon */ 8:
                    message.awayGamesWon = reader.string();
                    break;
                case /* string shotClock */ 9:
                    message.shotClock = reader.string();
                    break;
                case /* int32 homeFouls */ 10:
                    message.homeFouls = reader.int32();
                    break;
                case /* int32 awayFouls */ 11:
                    message.awayFouls = reader.int32();
                    break;
                case /* bool ocrFailed */ 12:
                    message.ocrFailed = reader.bool();
                    break;
                case /* string possessionIndicator */ 13:
                    message.possessionIndicator = reader.string();
                    break;
                case /* string penaltyClock */ 14:
                    message.penaltyClock = reader.string();
                    break;
                case /* int32 homeShotsOnGoal */ 15:
                    message.homeShotsOnGoal = reader.int32();
                    break;
                case /* int32 awayShotsOnGoal */ 16:
                    message.awayShotsOnGoal = reader.int32();
                    break;
                case /* string powerPlayIndicator */ 17:
                    message.powerPlayIndicator = reader.string();
                    break;
                case /* int32 setNumber */ 18:
                    message.setNumber = reader.int32();
                    break;
                case /* int32 homeSetScore */ 19:
                    message.homeSetScore = reader.int32();
                    break;
                case /* int32 awaySetScore */ 20:
                    message.awaySetScore = reader.int32();
                    break;
                case /* int32 homeTimeoutCount */ 21:
                    message.homeTimeoutCount = reader.int32();
                    break;
                case /* int32 awayTimeoutCount */ 22:
                    message.awayTimeoutCount = reader.int32();
                    break;
                case /* int32 homeChallengeCount */ 23:
                    message.homeChallengeCount = reader.int32();
                    break;
                case /* int32 awayChallengeCount */ 24:
                    message.awayChallengeCount = reader.int32();
                    break;
                case /* int32 inning */ 25:
                    message.inning = reader.int32();
                    break;
                case /* int32 outs */ 26:
                    message.outs = reader.int32();
                    break;
                case /* int32 balls */ 27:
                    message.balls = reader.int32();
                    break;
                case /* int32 strikes */ 28:
                    message.strikes = reader.int32();
                    break;
                case /* int32 runsPerInning */ 29:
                    message.runsPerInning = reader.int32();
                    break;
                case /* int32 homeTimeoutsLeft */ 30:
                    message.homeTimeoutsLeft = reader.int32();
                    break;
                case /* int32 awayTimeoutsLeft */ 31:
                    message.awayTimeoutsLeft = reader.int32();
                    break;
                case /* string timeOutIndicator */ 32:
                    message.timeOutIndicator = reader.string();
                    break;
                case /* uint64 timestampMs */ 33:
                    message.timestampMs = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OcrDataMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 homeScore = 1; */
        if (message.homeScore !== 0)
            writer.tag(1, WireType.Varint).int32(message.homeScore);
        /* int32 awayScore = 2; */
        if (message.awayScore !== 0)
            writer.tag(2, WireType.Varint).int32(message.awayScore);
        /* string time = 3; */
        if (message.time !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.time);
        /* string period = 4; */
        if (message.period !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.period);
        /* string down = 5; */
        if (message.down !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.down);
        /* string distance = 6; */
        if (message.distance !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.distance);
        /* string homeGamesWon = 7; */
        if (message.homeGamesWon !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.homeGamesWon);
        /* string awayGamesWon = 8; */
        if (message.awayGamesWon !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.awayGamesWon);
        /* string shotClock = 9; */
        if (message.shotClock !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.shotClock);
        /* int32 homeFouls = 10; */
        if (message.homeFouls !== 0)
            writer.tag(10, WireType.Varint).int32(message.homeFouls);
        /* int32 awayFouls = 11; */
        if (message.awayFouls !== 0)
            writer.tag(11, WireType.Varint).int32(message.awayFouls);
        /* bool ocrFailed = 12; */
        if (message.ocrFailed !== false)
            writer.tag(12, WireType.Varint).bool(message.ocrFailed);
        /* string possessionIndicator = 13; */
        if (message.possessionIndicator !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.possessionIndicator);
        /* string penaltyClock = 14; */
        if (message.penaltyClock !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.penaltyClock);
        /* int32 homeShotsOnGoal = 15; */
        if (message.homeShotsOnGoal !== 0)
            writer.tag(15, WireType.Varint).int32(message.homeShotsOnGoal);
        /* int32 awayShotsOnGoal = 16; */
        if (message.awayShotsOnGoal !== 0)
            writer.tag(16, WireType.Varint).int32(message.awayShotsOnGoal);
        /* string powerPlayIndicator = 17; */
        if (message.powerPlayIndicator !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.powerPlayIndicator);
        /* int32 setNumber = 18; */
        if (message.setNumber !== 0)
            writer.tag(18, WireType.Varint).int32(message.setNumber);
        /* int32 homeSetScore = 19; */
        if (message.homeSetScore !== 0)
            writer.tag(19, WireType.Varint).int32(message.homeSetScore);
        /* int32 awaySetScore = 20; */
        if (message.awaySetScore !== 0)
            writer.tag(20, WireType.Varint).int32(message.awaySetScore);
        /* int32 homeTimeoutCount = 21; */
        if (message.homeTimeoutCount !== 0)
            writer.tag(21, WireType.Varint).int32(message.homeTimeoutCount);
        /* int32 awayTimeoutCount = 22; */
        if (message.awayTimeoutCount !== 0)
            writer.tag(22, WireType.Varint).int32(message.awayTimeoutCount);
        /* int32 homeChallengeCount = 23; */
        if (message.homeChallengeCount !== 0)
            writer.tag(23, WireType.Varint).int32(message.homeChallengeCount);
        /* int32 awayChallengeCount = 24; */
        if (message.awayChallengeCount !== 0)
            writer.tag(24, WireType.Varint).int32(message.awayChallengeCount);
        /* int32 inning = 25; */
        if (message.inning !== 0)
            writer.tag(25, WireType.Varint).int32(message.inning);
        /* int32 outs = 26; */
        if (message.outs !== 0)
            writer.tag(26, WireType.Varint).int32(message.outs);
        /* int32 balls = 27; */
        if (message.balls !== 0)
            writer.tag(27, WireType.Varint).int32(message.balls);
        /* int32 strikes = 28; */
        if (message.strikes !== 0)
            writer.tag(28, WireType.Varint).int32(message.strikes);
        /* int32 runsPerInning = 29; */
        if (message.runsPerInning !== 0)
            writer.tag(29, WireType.Varint).int32(message.runsPerInning);
        /* int32 homeTimeoutsLeft = 30; */
        if (message.homeTimeoutsLeft !== 0)
            writer.tag(30, WireType.Varint).int32(message.homeTimeoutsLeft);
        /* int32 awayTimeoutsLeft = 31; */
        if (message.awayTimeoutsLeft !== 0)
            writer.tag(31, WireType.Varint).int32(message.awayTimeoutsLeft);
        /* string timeOutIndicator = 32; */
        if (message.timeOutIndicator !== "")
            writer.tag(32, WireType.LengthDelimited).string(message.timeOutIndicator);
        /* uint64 timestampMs = 33; */
        if (message.timestampMs !== 0n)
            writer.tag(33, WireType.Varint).uint64(message.timestampMs);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.OcrDataMessage
 */
export const OcrDataMessage = new OcrDataMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GraphicsInfoMessage$Type extends MessageType<GraphicsInfoMessage> {
    constructor() {
        super("VpuGrpc.GraphicsInfoMessage", [
            { no: 1, name: "GraphicsInfoMessageType", kind: "enum", jsonName: "GraphicsInfoMessageType", T: () => ["VpuGrpc.GraphicsInfoMessage.GraphicsInfoTypeEnum", GraphicsInfoMessage_GraphicsInfoTypeEnum] },
            { no: 2, name: "GraphicsEngine", kind: "message", jsonName: "GraphicsEngine", T: () => GraphicsEngineTypeMessage },
            { no: 3, name: "FlowMessage", kind: "message", jsonName: "FlowMessage", T: () => SingularFlowMessage },
            { no: 4, name: "EventUpdate", kind: "message", jsonName: "EventUpdate", T: () => EventUpdateMessage },
            { no: 5, name: "OcrMessage", kind: "message", jsonName: "OcrMessage", T: () => OcrDataMessage },
            { no: 6, name: "OcrMode", kind: "message", jsonName: "OcrMode", T: () => OcrModeMessage },
            { no: 7, name: "GraphicsTypeOverride", kind: "message", jsonName: "GraphicsTypeOverride", T: () => GraphicsTypeOverrideMessage },
            { no: 8, name: "PipMode", kind: "message", jsonName: "PipMode", T: () => PipModeMessage },
            { no: 9, name: "RestartGraphics", kind: "message", jsonName: "RestartGraphics", T: () => RestartGraphicsMessage }
        ]);
    }
    create(value?: PartialMessage<GraphicsInfoMessage>): GraphicsInfoMessage {
        const message = { graphicsInfoMessageType: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GraphicsInfoMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GraphicsInfoMessage): GraphicsInfoMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuGrpc.GraphicsInfoMessage.GraphicsInfoTypeEnum GraphicsInfoMessageType = 1 [json_name = "GraphicsInfoMessageType"];*/ 1:
                    message.graphicsInfoMessageType = reader.int32();
                    break;
                case /* VpuGrpc.GraphicsEngineTypeMessage GraphicsEngine = 2 [json_name = "GraphicsEngine"];*/ 2:
                    message.graphicsEngine = GraphicsEngineTypeMessage.internalBinaryRead(reader, reader.uint32(), options, message.graphicsEngine);
                    break;
                case /* VpuGrpc.SingularFlowMessage FlowMessage = 3 [json_name = "FlowMessage"];*/ 3:
                    message.flowMessage = SingularFlowMessage.internalBinaryRead(reader, reader.uint32(), options, message.flowMessage);
                    break;
                case /* VpuGrpc.EventUpdateMessage EventUpdate = 4 [json_name = "EventUpdate"];*/ 4:
                    message.eventUpdate = EventUpdateMessage.internalBinaryRead(reader, reader.uint32(), options, message.eventUpdate);
                    break;
                case /* VpuGrpc.OcrDataMessage OcrMessage = 5 [json_name = "OcrMessage"];*/ 5:
                    message.ocrMessage = OcrDataMessage.internalBinaryRead(reader, reader.uint32(), options, message.ocrMessage);
                    break;
                case /* VpuGrpc.OcrModeMessage OcrMode = 6 [json_name = "OcrMode"];*/ 6:
                    message.ocrMode = OcrModeMessage.internalBinaryRead(reader, reader.uint32(), options, message.ocrMode);
                    break;
                case /* VpuGrpc.GraphicsTypeOverrideMessage GraphicsTypeOverride = 7 [json_name = "GraphicsTypeOverride"];*/ 7:
                    message.graphicsTypeOverride = GraphicsTypeOverrideMessage.internalBinaryRead(reader, reader.uint32(), options, message.graphicsTypeOverride);
                    break;
                case /* VpuGrpc.PipModeMessage PipMode = 8 [json_name = "PipMode"];*/ 8:
                    message.pipMode = PipModeMessage.internalBinaryRead(reader, reader.uint32(), options, message.pipMode);
                    break;
                case /* VpuGrpc.RestartGraphicsMessage RestartGraphics = 9 [json_name = "RestartGraphics"];*/ 9:
                    message.restartGraphics = RestartGraphicsMessage.internalBinaryRead(reader, reader.uint32(), options, message.restartGraphics);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GraphicsInfoMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuGrpc.GraphicsInfoMessage.GraphicsInfoTypeEnum GraphicsInfoMessageType = 1 [json_name = "GraphicsInfoMessageType"]; */
        if (message.graphicsInfoMessageType !== 0)
            writer.tag(1, WireType.Varint).int32(message.graphicsInfoMessageType);
        /* VpuGrpc.GraphicsEngineTypeMessage GraphicsEngine = 2 [json_name = "GraphicsEngine"]; */
        if (message.graphicsEngine)
            GraphicsEngineTypeMessage.internalBinaryWrite(message.graphicsEngine, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* VpuGrpc.SingularFlowMessage FlowMessage = 3 [json_name = "FlowMessage"]; */
        if (message.flowMessage)
            SingularFlowMessage.internalBinaryWrite(message.flowMessage, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* VpuGrpc.EventUpdateMessage EventUpdate = 4 [json_name = "EventUpdate"]; */
        if (message.eventUpdate)
            EventUpdateMessage.internalBinaryWrite(message.eventUpdate, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* VpuGrpc.OcrDataMessage OcrMessage = 5 [json_name = "OcrMessage"]; */
        if (message.ocrMessage)
            OcrDataMessage.internalBinaryWrite(message.ocrMessage, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* VpuGrpc.OcrModeMessage OcrMode = 6 [json_name = "OcrMode"]; */
        if (message.ocrMode)
            OcrModeMessage.internalBinaryWrite(message.ocrMode, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* VpuGrpc.GraphicsTypeOverrideMessage GraphicsTypeOverride = 7 [json_name = "GraphicsTypeOverride"]; */
        if (message.graphicsTypeOverride)
            GraphicsTypeOverrideMessage.internalBinaryWrite(message.graphicsTypeOverride, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* VpuGrpc.PipModeMessage PipMode = 8 [json_name = "PipMode"]; */
        if (message.pipMode)
            PipModeMessage.internalBinaryWrite(message.pipMode, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* VpuGrpc.RestartGraphicsMessage RestartGraphics = 9 [json_name = "RestartGraphics"]; */
        if (message.restartGraphics)
            RestartGraphicsMessage.internalBinaryWrite(message.restartGraphics, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.GraphicsInfoMessage
 */
export const GraphicsInfoMessage = new GraphicsInfoMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PipScoreboardModeMessage$Type extends MessageType<PipScoreboardModeMessage> {
    constructor() {
        super("VpuGrpc.PipScoreboardModeMessage", [
            { no: 1, name: "mode", kind: "enum", T: () => ["VpuGrpc.PipScoreboardModeMessage.Mode", PipScoreboardModeMessage_Mode] }
        ]);
    }
    create(value?: PartialMessage<PipScoreboardModeMessage>): PipScoreboardModeMessage {
        const message = { mode: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PipScoreboardModeMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PipScoreboardModeMessage): PipScoreboardModeMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuGrpc.PipScoreboardModeMessage.Mode mode */ 1:
                    message.mode = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PipScoreboardModeMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuGrpc.PipScoreboardModeMessage.Mode mode = 1; */
        if (message.mode !== 0)
            writer.tag(1, WireType.Varint).int32(message.mode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.PipScoreboardModeMessage
 */
export const PipScoreboardModeMessage = new PipScoreboardModeMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PipFrameResponse$Type extends MessageType<PipFrameResponse> {
    constructor() {
        super("VpuGrpc.PipFrameResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "frame", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PipFrameResponse>): PipFrameResponse {
        const message = { success: false, frame: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PipFrameResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PipFrameResponse): PipFrameResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string frame */ 2:
                    message.frame = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PipFrameResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string frame = 2; */
        if (message.frame !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.frame);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.PipFrameResponse
 */
export const PipFrameResponse = new PipFrameResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FrameTimestampRequest$Type extends MessageType<FrameTimestampRequest> {
    constructor() {
        super("VpuGrpc.FrameTimestampRequest", [
            { no: 1, name: "timestamp", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<FrameTimestampRequest>): FrameTimestampRequest {
        const message = { timestamp: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FrameTimestampRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FrameTimestampRequest): FrameTimestampRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 timestamp */ 1:
                    message.timestamp = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FrameTimestampRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint64 timestamp = 1; */
        if (message.timestamp !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.timestamp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.FrameTimestampRequest
 */
export const FrameTimestampRequest = new FrameTimestampRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CueOutMessage$Type extends MessageType<CueOutMessage> {
    constructor() {
        super("VpuGrpc.CueOutMessage", [
            { no: 1, name: "timestamp", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "duration", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "autoReturn", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CueOutMessage>): CueOutMessage {
        const message = { timestamp: 0n, duration: 0n, autoReturn: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CueOutMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CueOutMessage): CueOutMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 timestamp */ 1:
                    message.timestamp = reader.uint64().toBigInt();
                    break;
                case /* uint64 duration */ 2:
                    message.duration = reader.uint64().toBigInt();
                    break;
                case /* bool autoReturn */ 3:
                    message.autoReturn = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CueOutMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint64 timestamp = 1; */
        if (message.timestamp !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.timestamp);
        /* uint64 duration = 2; */
        if (message.duration !== 0n)
            writer.tag(2, WireType.Varint).uint64(message.duration);
        /* bool autoReturn = 3; */
        if (message.autoReturn !== false)
            writer.tag(3, WireType.Varint).bool(message.autoReturn);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.CueOutMessage
 */
export const CueOutMessage = new CueOutMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CueInMessage$Type extends MessageType<CueInMessage> {
    constructor() {
        super("VpuGrpc.CueInMessage", [
            { no: 1, name: "timestamp", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<CueInMessage>): CueInMessage {
        const message = { timestamp: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CueInMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CueInMessage): CueInMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 timestamp */ 1:
                    message.timestamp = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CueInMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint64 timestamp = 1; */
        if (message.timestamp !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.timestamp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.CueInMessage
 */
export const CueInMessage = new CueInMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScoreboardStatusMessage$Type extends MessageType<ScoreboardStatusMessage> {
    constructor() {
        super("VpuGrpc.ScoreboardStatusMessage", [
            { no: 1, name: "connected", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "hasData", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ScoreboardStatusMessage>): ScoreboardStatusMessage {
        const message = { connected: false, hasData: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ScoreboardStatusMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ScoreboardStatusMessage): ScoreboardStatusMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool connected */ 1:
                    message.connected = reader.bool();
                    break;
                case /* bool hasData */ 2:
                    message.hasData = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ScoreboardStatusMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool connected = 1; */
        if (message.connected !== false)
            writer.tag(1, WireType.Varint).bool(message.connected);
        /* bool hasData = 2; */
        if (message.hasData !== false)
            writer.tag(2, WireType.Varint).bool(message.hasData);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.ScoreboardStatusMessage
 */
export const ScoreboardStatusMessage = new ScoreboardStatusMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChuUpgradeStatusMessage$Type extends MessageType<ChuUpgradeStatusMessage> {
    constructor() {
        super("VpuGrpc.ChuUpgradeStatusMessage", [
            { no: 1, name: "UpdateStatus", kind: "enum", jsonName: "UpdateStatus", T: () => ["VpuGrpc.ChuUpgradeStatusMessage.Status", ChuUpgradeStatusMessage_Status] },
            { no: 2, name: "UpdateStep", kind: "scalar", jsonName: "UpdateStep", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "ProgressPercentage", kind: "scalar", jsonName: "ProgressPercentage", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ChuUpgradeStatusMessage>): ChuUpgradeStatusMessage {
        const message = { updateStatus: 0, updateStep: "", progressPercentage: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ChuUpgradeStatusMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChuUpgradeStatusMessage): ChuUpgradeStatusMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuGrpc.ChuUpgradeStatusMessage.Status UpdateStatus = 1 [json_name = "UpdateStatus"];*/ 1:
                    message.updateStatus = reader.int32();
                    break;
                case /* string UpdateStep = 2 [json_name = "UpdateStep"];*/ 2:
                    message.updateStep = reader.string();
                    break;
                case /* int32 ProgressPercentage = 3 [json_name = "ProgressPercentage"];*/ 3:
                    message.progressPercentage = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChuUpgradeStatusMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuGrpc.ChuUpgradeStatusMessage.Status UpdateStatus = 1 [json_name = "UpdateStatus"]; */
        if (message.updateStatus !== 0)
            writer.tag(1, WireType.Varint).int32(message.updateStatus);
        /* string UpdateStep = 2 [json_name = "UpdateStep"]; */
        if (message.updateStep !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.updateStep);
        /* int32 ProgressPercentage = 3 [json_name = "ProgressPercentage"]; */
        if (message.progressPercentage !== 0)
            writer.tag(3, WireType.Varint).int32(message.progressPercentage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.ChuUpgradeStatusMessage
 */
export const ChuUpgradeStatusMessage = new ChuUpgradeStatusMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CamerasParametersMessage$Type extends MessageType<CamerasParametersMessage> {
    constructor() {
        super("VpuGrpc.CamerasParametersMessage", [
            { no: 1, name: "gain", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 2, name: "exposure", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "gamma", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "iris", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "red", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "blue", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 8, name: "autoExpoMode", kind: "enum", T: () => ["VpuGrpc.AutoExpoModeEnum", AutoExpoModeEnum] },
            { no: 9, name: "brightnessLevel", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "fieldOfView", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "maxExposure", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "motorsError", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CamerasParametersMessage>): CamerasParametersMessage {
        const message = { gain: 0, exposure: 0, gamma: 0, iris: 0, red: 0, blue: 0, autoExpoMode: 0, brightnessLevel: 0, fieldOfView: 0, maxExposure: 0, motorsError: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CamerasParametersMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CamerasParametersMessage): CamerasParametersMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* float gain */ 1:
                    message.gain = reader.float();
                    break;
                case /* int32 exposure */ 2:
                    message.exposure = reader.int32();
                    break;
                case /* float gamma */ 3:
                    message.gamma = reader.float();
                    break;
                case /* float iris */ 4:
                    message.iris = reader.float();
                    break;
                case /* float red */ 5:
                    message.red = reader.float();
                    break;
                case /* float blue */ 6:
                    message.blue = reader.float();
                    break;
                case /* VpuGrpc.AutoExpoModeEnum autoExpoMode */ 8:
                    message.autoExpoMode = reader.int32();
                    break;
                case /* int32 brightnessLevel */ 9:
                    message.brightnessLevel = reader.int32();
                    break;
                case /* int32 fieldOfView */ 10:
                    message.fieldOfView = reader.int32();
                    break;
                case /* int32 maxExposure */ 11:
                    message.maxExposure = reader.int32();
                    break;
                case /* bool motorsError */ 12:
                    message.motorsError = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CamerasParametersMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* float gain = 1; */
        if (message.gain !== 0)
            writer.tag(1, WireType.Bit32).float(message.gain);
        /* int32 exposure = 2; */
        if (message.exposure !== 0)
            writer.tag(2, WireType.Varint).int32(message.exposure);
        /* float gamma = 3; */
        if (message.gamma !== 0)
            writer.tag(3, WireType.Bit32).float(message.gamma);
        /* float iris = 4; */
        if (message.iris !== 0)
            writer.tag(4, WireType.Bit32).float(message.iris);
        /* float red = 5; */
        if (message.red !== 0)
            writer.tag(5, WireType.Bit32).float(message.red);
        /* float blue = 6; */
        if (message.blue !== 0)
            writer.tag(6, WireType.Bit32).float(message.blue);
        /* VpuGrpc.AutoExpoModeEnum autoExpoMode = 8; */
        if (message.autoExpoMode !== 0)
            writer.tag(8, WireType.Varint).int32(message.autoExpoMode);
        /* int32 brightnessLevel = 9; */
        if (message.brightnessLevel !== 0)
            writer.tag(9, WireType.Varint).int32(message.brightnessLevel);
        /* int32 fieldOfView = 10; */
        if (message.fieldOfView !== 0)
            writer.tag(10, WireType.Varint).int32(message.fieldOfView);
        /* int32 maxExposure = 11; */
        if (message.maxExposure !== 0)
            writer.tag(11, WireType.Varint).int32(message.maxExposure);
        /* bool motorsError = 12; */
        if (message.motorsError !== false)
            writer.tag(12, WireType.Varint).bool(message.motorsError);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.CamerasParametersMessage
 */
export const CamerasParametersMessage = new CamerasParametersMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MinMaxValues$Type extends MessageType<MinMaxValues> {
    constructor() {
        super("VpuGrpc.MinMaxValues", [
            { no: 1, name: "minValue", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "maxValue", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<MinMaxValues>): MinMaxValues {
        const message = { minValue: 0, maxValue: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<MinMaxValues>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MinMaxValues): MinMaxValues {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 minValue */ 1:
                    message.minValue = reader.int32();
                    break;
                case /* int32 maxValue */ 2:
                    message.maxValue = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MinMaxValues, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 minValue = 1; */
        if (message.minValue !== 0)
            writer.tag(1, WireType.Varint).int32(message.minValue);
        /* int32 maxValue = 2; */
        if (message.maxValue !== 0)
            writer.tag(2, WireType.Varint).int32(message.maxValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.MinMaxValues
 */
export const MinMaxValues = new MinMaxValues$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraDetails$Type extends MessageType<CameraDetails> {
    constructor() {
        super("VpuGrpc.CameraDetails", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "width", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "height", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "isTop", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CameraDetails>): CameraDetails {
        const message = { id: 0, width: 0, height: 0, isTop: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraDetails>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraDetails): CameraDetails {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 width */ 2:
                    message.width = reader.int32();
                    break;
                case /* int32 height */ 3:
                    message.height = reader.int32();
                    break;
                case /* bool isTop */ 4:
                    message.isTop = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CameraDetails, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 width = 2; */
        if (message.width !== 0)
            writer.tag(2, WireType.Varint).int32(message.width);
        /* int32 height = 3; */
        if (message.height !== 0)
            writer.tag(3, WireType.Varint).int32(message.height);
        /* bool isTop = 4; */
        if (message.isTop !== false)
            writer.tag(4, WireType.Varint).bool(message.isTop);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.CameraDetails
 */
export const CameraDetails = new CameraDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CamerasParametersMinMaxValuesRequestMessage$Type extends MessageType<CamerasParametersMinMaxValuesRequestMessage> {
    constructor() {
        super("VpuGrpc.CamerasParametersMinMaxValuesRequestMessage", []);
    }
    create(value?: PartialMessage<CamerasParametersMinMaxValuesRequestMessage>): CamerasParametersMinMaxValuesRequestMessage {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CamerasParametersMinMaxValuesRequestMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CamerasParametersMinMaxValuesRequestMessage): CamerasParametersMinMaxValuesRequestMessage {
        return target ?? this.create();
    }
    internalBinaryWrite(message: CamerasParametersMinMaxValuesRequestMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.CamerasParametersMinMaxValuesRequestMessage
 */
export const CamerasParametersMinMaxValuesRequestMessage = new CamerasParametersMinMaxValuesRequestMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CamerasParametersMinMaxValuesReplyMessage$Type extends MessageType<CamerasParametersMinMaxValuesReplyMessage> {
    constructor() {
        super("VpuGrpc.CamerasParametersMinMaxValuesReplyMessage", [
            { no: 1, name: "brightness", kind: "message", T: () => MinMaxValues },
            { no: 2, name: "exposure", kind: "message", T: () => MinMaxValues },
            { no: 3, name: "gamma", kind: "message", T: () => MinMaxValues },
            { no: 4, name: "gain", kind: "message", T: () => MinMaxValues },
            { no: 5, name: "red", kind: "message", T: () => MinMaxValues },
            { no: 6, name: "blue", kind: "message", T: () => MinMaxValues },
            { no: 7, name: "fieldOfView", kind: "message", T: () => MinMaxValues },
            { no: 8, name: "maxExposure", kind: "message", T: () => MinMaxValues }
        ]);
    }
    create(value?: PartialMessage<CamerasParametersMinMaxValuesReplyMessage>): CamerasParametersMinMaxValuesReplyMessage {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CamerasParametersMinMaxValuesReplyMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CamerasParametersMinMaxValuesReplyMessage): CamerasParametersMinMaxValuesReplyMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuGrpc.MinMaxValues brightness */ 1:
                    message.brightness = MinMaxValues.internalBinaryRead(reader, reader.uint32(), options, message.brightness);
                    break;
                case /* VpuGrpc.MinMaxValues exposure */ 2:
                    message.exposure = MinMaxValues.internalBinaryRead(reader, reader.uint32(), options, message.exposure);
                    break;
                case /* VpuGrpc.MinMaxValues gamma */ 3:
                    message.gamma = MinMaxValues.internalBinaryRead(reader, reader.uint32(), options, message.gamma);
                    break;
                case /* VpuGrpc.MinMaxValues gain */ 4:
                    message.gain = MinMaxValues.internalBinaryRead(reader, reader.uint32(), options, message.gain);
                    break;
                case /* VpuGrpc.MinMaxValues red */ 5:
                    message.red = MinMaxValues.internalBinaryRead(reader, reader.uint32(), options, message.red);
                    break;
                case /* VpuGrpc.MinMaxValues blue */ 6:
                    message.blue = MinMaxValues.internalBinaryRead(reader, reader.uint32(), options, message.blue);
                    break;
                case /* VpuGrpc.MinMaxValues fieldOfView */ 7:
                    message.fieldOfView = MinMaxValues.internalBinaryRead(reader, reader.uint32(), options, message.fieldOfView);
                    break;
                case /* VpuGrpc.MinMaxValues maxExposure */ 8:
                    message.maxExposure = MinMaxValues.internalBinaryRead(reader, reader.uint32(), options, message.maxExposure);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CamerasParametersMinMaxValuesReplyMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuGrpc.MinMaxValues brightness = 1; */
        if (message.brightness)
            MinMaxValues.internalBinaryWrite(message.brightness, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* VpuGrpc.MinMaxValues exposure = 2; */
        if (message.exposure)
            MinMaxValues.internalBinaryWrite(message.exposure, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* VpuGrpc.MinMaxValues gamma = 3; */
        if (message.gamma)
            MinMaxValues.internalBinaryWrite(message.gamma, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* VpuGrpc.MinMaxValues gain = 4; */
        if (message.gain)
            MinMaxValues.internalBinaryWrite(message.gain, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* VpuGrpc.MinMaxValues red = 5; */
        if (message.red)
            MinMaxValues.internalBinaryWrite(message.red, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* VpuGrpc.MinMaxValues blue = 6; */
        if (message.blue)
            MinMaxValues.internalBinaryWrite(message.blue, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* VpuGrpc.MinMaxValues fieldOfView = 7; */
        if (message.fieldOfView)
            MinMaxValues.internalBinaryWrite(message.fieldOfView, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* VpuGrpc.MinMaxValues maxExposure = 8; */
        if (message.maxExposure)
            MinMaxValues.internalBinaryWrite(message.maxExposure, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.CamerasParametersMinMaxValuesReplyMessage
 */
export const CamerasParametersMinMaxValuesReplyMessage = new CamerasParametersMinMaxValuesReplyMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CamerasParametersRequestMessage$Type extends MessageType<CamerasParametersRequestMessage> {
    constructor() {
        super("VpuGrpc.CamerasParametersRequestMessage", []);
    }
    create(value?: PartialMessage<CamerasParametersRequestMessage>): CamerasParametersRequestMessage {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CamerasParametersRequestMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CamerasParametersRequestMessage): CamerasParametersRequestMessage {
        return target ?? this.create();
    }
    internalBinaryWrite(message: CamerasParametersRequestMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.CamerasParametersRequestMessage
 */
export const CamerasParametersRequestMessage = new CamerasParametersRequestMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CamerasParametersReplyMessage$Type extends MessageType<CamerasParametersReplyMessage> {
    constructor() {
        super("VpuGrpc.CamerasParametersReplyMessage", [
            { no: 1, name: "cameraParams", kind: "message", T: () => CamerasParametersMessage },
            { no: 2, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CamerasParametersReplyMessage>): CamerasParametersReplyMessage {
        const message = { success: false, errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CamerasParametersReplyMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CamerasParametersReplyMessage): CamerasParametersReplyMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuGrpc.CamerasParametersMessage cameraParams */ 1:
                    message.cameraParams = CamerasParametersMessage.internalBinaryRead(reader, reader.uint32(), options, message.cameraParams);
                    break;
                case /* bool success */ 2:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 3:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CamerasParametersReplyMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuGrpc.CamerasParametersMessage cameraParams = 1; */
        if (message.cameraParams)
            CamerasParametersMessage.internalBinaryWrite(message.cameraParams, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool success = 2; */
        if (message.success !== false)
            writer.tag(2, WireType.Varint).bool(message.success);
        /* string errorMessage = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.CamerasParametersReplyMessage
 */
export const CamerasParametersReplyMessage = new CamerasParametersReplyMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetCameraParametersMessage$Type extends MessageType<SetCameraParametersMessage> {
    constructor() {
        super("VpuGrpc.SetCameraParametersMessage", [
            { no: 1, name: "cameraId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "cameraParams", kind: "message", T: () => CamerasParametersMessage }
        ]);
    }
    create(value?: PartialMessage<SetCameraParametersMessage>): SetCameraParametersMessage {
        const message = { cameraId: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SetCameraParametersMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetCameraParametersMessage): SetCameraParametersMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 cameraId */ 1:
                    message.cameraId = reader.int32();
                    break;
                case /* VpuGrpc.CamerasParametersMessage cameraParams */ 2:
                    message.cameraParams = CamerasParametersMessage.internalBinaryRead(reader, reader.uint32(), options, message.cameraParams);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetCameraParametersMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 cameraId = 1; */
        if (message.cameraId !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraId);
        /* VpuGrpc.CamerasParametersMessage cameraParams = 2; */
        if (message.cameraParams)
            CamerasParametersMessage.internalBinaryWrite(message.cameraParams, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.SetCameraParametersMessage
 */
export const SetCameraParametersMessage = new SetCameraParametersMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FieldOfViewResponseMessage$Type extends MessageType<FieldOfViewResponseMessage> {
    constructor() {
        super("VpuGrpc.FieldOfViewResponseMessage", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FieldOfViewResponseMessage>): FieldOfViewResponseMessage {
        const message = { success: false, errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FieldOfViewResponseMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FieldOfViewResponseMessage): FieldOfViewResponseMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FieldOfViewResponseMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.FieldOfViewResponseMessage
 */
export const FieldOfViewResponseMessage = new FieldOfViewResponseMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetCameraSingleParameterMessage$Type extends MessageType<SetCameraSingleParameterMessage> {
    constructor() {
        super("VpuGrpc.SetCameraSingleParameterMessage", [
            { no: 1, name: "cameraId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "requestType", kind: "enum", T: () => ["VpuGrpc.CameraParamRequestType", CameraParamRequestType] },
            { no: 3, name: "focus", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "autoFocus", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "fieldOfView", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<SetCameraSingleParameterMessage>): SetCameraSingleParameterMessage {
        const message = { cameraId: 0, requestType: 0, focus: 0, autoFocus: false, fieldOfView: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SetCameraSingleParameterMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetCameraSingleParameterMessage): SetCameraSingleParameterMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 cameraId */ 1:
                    message.cameraId = reader.int32();
                    break;
                case /* VpuGrpc.CameraParamRequestType requestType */ 2:
                    message.requestType = reader.int32();
                    break;
                case /* float focus */ 3:
                    message.focus = reader.float();
                    break;
                case /* bool autoFocus */ 4:
                    message.autoFocus = reader.bool();
                    break;
                case /* int32 fieldOfView */ 5:
                    message.fieldOfView = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetCameraSingleParameterMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 cameraId = 1; */
        if (message.cameraId !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraId);
        /* VpuGrpc.CameraParamRequestType requestType = 2; */
        if (message.requestType !== 0)
            writer.tag(2, WireType.Varint).int32(message.requestType);
        /* float focus = 3; */
        if (message.focus !== 0)
            writer.tag(3, WireType.Bit32).float(message.focus);
        /* bool autoFocus = 4; */
        if (message.autoFocus !== false)
            writer.tag(4, WireType.Varint).bool(message.autoFocus);
        /* int32 fieldOfView = 5; */
        if (message.fieldOfView !== 0)
            writer.tag(5, WireType.Varint).int32(message.fieldOfView);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.SetCameraSingleParameterMessage
 */
export const SetCameraSingleParameterMessage = new SetCameraSingleParameterMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetCamerasOrderMessage$Type extends MessageType<SetCamerasOrderMessage> {
    constructor() {
        super("VpuGrpc.SetCamerasOrderMessage", [
            { no: 1, name: "camera1", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "camera2", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<SetCamerasOrderMessage>): SetCamerasOrderMessage {
        const message = { camera1: 0, camera2: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SetCamerasOrderMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetCamerasOrderMessage): SetCamerasOrderMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 camera1 */ 1:
                    message.camera1 = reader.int32();
                    break;
                case /* int32 camera2 */ 2:
                    message.camera2 = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetCamerasOrderMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 camera1 = 1; */
        if (message.camera1 !== 0)
            writer.tag(1, WireType.Varint).int32(message.camera1);
        /* int32 camera2 = 2; */
        if (message.camera2 !== 0)
            writer.tag(2, WireType.Varint).int32(message.camera2);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.SetCamerasOrderMessage
 */
export const SetCamerasOrderMessage = new SetCamerasOrderMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraDetailsListRequestMessage$Type extends MessageType<CameraDetailsListRequestMessage> {
    constructor() {
        super("VpuGrpc.CameraDetailsListRequestMessage", []);
    }
    create(value?: PartialMessage<CameraDetailsListRequestMessage>): CameraDetailsListRequestMessage {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraDetailsListRequestMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraDetailsListRequestMessage): CameraDetailsListRequestMessage {
        return target ?? this.create();
    }
    internalBinaryWrite(message: CameraDetailsListRequestMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.CameraDetailsListRequestMessage
 */
export const CameraDetailsListRequestMessage = new CameraDetailsListRequestMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraDetailsListReplyMessage$Type extends MessageType<CameraDetailsListReplyMessage> {
    constructor() {
        super("VpuGrpc.CameraDetailsListReplyMessage", [
            { no: 2, name: "cameras", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CameraDetails }
        ]);
    }
    create(value?: PartialMessage<CameraDetailsListReplyMessage>): CameraDetailsListReplyMessage {
        const message = { cameras: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraDetailsListReplyMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraDetailsListReplyMessage): CameraDetailsListReplyMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated VpuGrpc.CameraDetails cameras */ 2:
                    message.cameras.push(CameraDetails.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CameraDetailsListReplyMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated VpuGrpc.CameraDetails cameras = 2; */
        for (let i = 0; i < message.cameras.length; i++)
            CameraDetails.internalBinaryWrite(message.cameras[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.CameraDetailsListReplyMessage
 */
export const CameraDetailsListReplyMessage = new CameraDetailsListReplyMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FlipCameraMessage$Type extends MessageType<FlipCameraMessage> {
    constructor() {
        super("VpuGrpc.FlipCameraMessage", [
            { no: 1, name: "cameraId", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<FlipCameraMessage>): FlipCameraMessage {
        const message = { cameraId: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FlipCameraMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FlipCameraMessage): FlipCameraMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 cameraId */ 1:
                    message.cameraId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FlipCameraMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 cameraId = 1; */
        if (message.cameraId !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.FlipCameraMessage
 */
export const FlipCameraMessage = new FlipCameraMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetCamerasOrderResponseMessage$Type extends MessageType<SetCamerasOrderResponseMessage> {
    constructor() {
        super("VpuGrpc.SetCamerasOrderResponseMessage", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SetCamerasOrderResponseMessage>): SetCamerasOrderResponseMessage {
        const message = { success: false, errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SetCamerasOrderResponseMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetCamerasOrderResponseMessage): SetCamerasOrderResponseMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetCamerasOrderResponseMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.SetCamerasOrderResponseMessage
 */
export const SetCamerasOrderResponseMessage = new SetCamerasOrderResponseMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ZoomInRequestMessage$Type extends MessageType<ZoomInRequestMessage> {
    constructor() {
        super("VpuGrpc.ZoomInRequestMessage", [
            { no: 1, name: "cameraIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "zoomStep", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ZoomInRequestMessage>): ZoomInRequestMessage {
        const message = { cameraIds: [], zoomStep: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ZoomInRequestMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ZoomInRequestMessage): ZoomInRequestMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int32 cameraIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.cameraIds.push(reader.int32());
                    else
                        message.cameraIds.push(reader.int32());
                    break;
                case /* int32 zoomStep */ 2:
                    message.zoomStep = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ZoomInRequestMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int32 cameraIds = 1; */
        if (message.cameraIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.cameraIds.length; i++)
                writer.int32(message.cameraIds[i]);
            writer.join();
        }
        /* int32 zoomStep = 2; */
        if (message.zoomStep !== 0)
            writer.tag(2, WireType.Varint).int32(message.zoomStep);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.ZoomInRequestMessage
 */
export const ZoomInRequestMessage = new ZoomInRequestMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ZoomOutRequestMessage$Type extends MessageType<ZoomOutRequestMessage> {
    constructor() {
        super("VpuGrpc.ZoomOutRequestMessage", [
            { no: 1, name: "cameraIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "zoomStep", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ZoomOutRequestMessage>): ZoomOutRequestMessage {
        const message = { cameraIds: [], zoomStep: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ZoomOutRequestMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ZoomOutRequestMessage): ZoomOutRequestMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int32 cameraIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.cameraIds.push(reader.int32());
                    else
                        message.cameraIds.push(reader.int32());
                    break;
                case /* int32 zoomStep */ 2:
                    message.zoomStep = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ZoomOutRequestMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int32 cameraIds = 1; */
        if (message.cameraIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.cameraIds.length; i++)
                writer.int32(message.cameraIds[i]);
            writer.join();
        }
        /* int32 zoomStep = 2; */
        if (message.zoomStep !== 0)
            writer.tag(2, WireType.Varint).int32(message.zoomStep);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.ZoomOutRequestMessage
 */
export const ZoomOutRequestMessage = new ZoomOutRequestMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResetZoomRequestMessage$Type extends MessageType<ResetZoomRequestMessage> {
    constructor() {
        super("VpuGrpc.ResetZoomRequestMessage", [
            { no: 1, name: "cameraIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ResetZoomRequestMessage>): ResetZoomRequestMessage {
        const message = { cameraIds: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ResetZoomRequestMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResetZoomRequestMessage): ResetZoomRequestMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int32 cameraIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.cameraIds.push(reader.int32());
                    else
                        message.cameraIds.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResetZoomRequestMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int32 cameraIds = 1; */
        if (message.cameraIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.cameraIds.length; i++)
                writer.int32(message.cameraIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.ResetZoomRequestMessage
 */
export const ResetZoomRequestMessage = new ResetZoomRequestMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IncreaseIrisRequestMessage$Type extends MessageType<IncreaseIrisRequestMessage> {
    constructor() {
        super("VpuGrpc.IncreaseIrisRequestMessage", [
            { no: 1, name: "cameraIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<IncreaseIrisRequestMessage>): IncreaseIrisRequestMessage {
        const message = { cameraIds: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<IncreaseIrisRequestMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IncreaseIrisRequestMessage): IncreaseIrisRequestMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int32 cameraIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.cameraIds.push(reader.int32());
                    else
                        message.cameraIds.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IncreaseIrisRequestMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int32 cameraIds = 1; */
        if (message.cameraIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.cameraIds.length; i++)
                writer.int32(message.cameraIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.IncreaseIrisRequestMessage
 */
export const IncreaseIrisRequestMessage = new IncreaseIrisRequestMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DecreaseIrisRequestMessage$Type extends MessageType<DecreaseIrisRequestMessage> {
    constructor() {
        super("VpuGrpc.DecreaseIrisRequestMessage", [
            { no: 1, name: "cameraIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<DecreaseIrisRequestMessage>): DecreaseIrisRequestMessage {
        const message = { cameraIds: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DecreaseIrisRequestMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DecreaseIrisRequestMessage): DecreaseIrisRequestMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int32 cameraIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.cameraIds.push(reader.int32());
                    else
                        message.cameraIds.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DecreaseIrisRequestMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int32 cameraIds = 1; */
        if (message.cameraIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.cameraIds.length; i++)
                writer.int32(message.cameraIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.DecreaseIrisRequestMessage
 */
export const DecreaseIrisRequestMessage = new DecreaseIrisRequestMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutoIrisRequestMessage$Type extends MessageType<AutoIrisRequestMessage> {
    constructor() {
        super("VpuGrpc.AutoIrisRequestMessage", [
            { no: 1, name: "cameraIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AutoIrisRequestMessage>): AutoIrisRequestMessage {
        const message = { cameraIds: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AutoIrisRequestMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AutoIrisRequestMessage): AutoIrisRequestMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int32 cameraIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.cameraIds.push(reader.int32());
                    else
                        message.cameraIds.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AutoIrisRequestMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int32 cameraIds = 1; */
        if (message.cameraIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.cameraIds.length; i++)
                writer.int32(message.cameraIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.AutoIrisRequestMessage
 */
export const AutoIrisRequestMessage = new AutoIrisRequestMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResetIrisRequestMessage$Type extends MessageType<ResetIrisRequestMessage> {
    constructor() {
        super("VpuGrpc.ResetIrisRequestMessage", [
            { no: 1, name: "cameraIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ResetIrisRequestMessage>): ResetIrisRequestMessage {
        const message = { cameraIds: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ResetIrisRequestMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResetIrisRequestMessage): ResetIrisRequestMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int32 cameraIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.cameraIds.push(reader.int32());
                    else
                        message.cameraIds.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResetIrisRequestMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int32 cameraIds = 1; */
        if (message.cameraIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.cameraIds.length; i++)
                writer.int32(message.cameraIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.ResetIrisRequestMessage
 */
export const ResetIrisRequestMessage = new ResetIrisRequestMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FocusFarRequestMessage$Type extends MessageType<FocusFarRequestMessage> {
    constructor() {
        super("VpuGrpc.FocusFarRequestMessage", [
            { no: 1, name: "cameraId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "focusStep", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<FocusFarRequestMessage>): FocusFarRequestMessage {
        const message = { cameraId: 0, focusStep: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FocusFarRequestMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FocusFarRequestMessage): FocusFarRequestMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 cameraId */ 1:
                    message.cameraId = reader.int32();
                    break;
                case /* int32 focusStep */ 2:
                    message.focusStep = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FocusFarRequestMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 cameraId = 1; */
        if (message.cameraId !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraId);
        /* int32 focusStep = 2; */
        if (message.focusStep !== 0)
            writer.tag(2, WireType.Varint).int32(message.focusStep);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.FocusFarRequestMessage
 */
export const FocusFarRequestMessage = new FocusFarRequestMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FocusNearRequestMessage$Type extends MessageType<FocusNearRequestMessage> {
    constructor() {
        super("VpuGrpc.FocusNearRequestMessage", [
            { no: 1, name: "cameraId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "focusStep", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<FocusNearRequestMessage>): FocusNearRequestMessage {
        const message = { cameraId: 0, focusStep: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FocusNearRequestMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FocusNearRequestMessage): FocusNearRequestMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 cameraId */ 1:
                    message.cameraId = reader.int32();
                    break;
                case /* int32 focusStep */ 2:
                    message.focusStep = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FocusNearRequestMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 cameraId = 1; */
        if (message.cameraId !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraId);
        /* int32 focusStep = 2; */
        if (message.focusStep !== 0)
            writer.tag(2, WireType.Varint).int32(message.focusStep);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.FocusNearRequestMessage
 */
export const FocusNearRequestMessage = new FocusNearRequestMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutoFocusRequestMessage$Type extends MessageType<AutoFocusRequestMessage> {
    constructor() {
        super("VpuGrpc.AutoFocusRequestMessage", [
            { no: 1, name: "cameraId", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AutoFocusRequestMessage>): AutoFocusRequestMessage {
        const message = { cameraId: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<AutoFocusRequestMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AutoFocusRequestMessage): AutoFocusRequestMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 cameraId */ 1:
                    message.cameraId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AutoFocusRequestMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 cameraId = 1; */
        if (message.cameraId !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.AutoFocusRequestMessage
 */
export const AutoFocusRequestMessage = new AutoFocusRequestMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResetFocusRequestMessage$Type extends MessageType<ResetFocusRequestMessage> {
    constructor() {
        super("VpuGrpc.ResetFocusRequestMessage", [
            { no: 1, name: "cameraId", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ResetFocusRequestMessage>): ResetFocusRequestMessage {
        const message = { cameraId: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ResetFocusRequestMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResetFocusRequestMessage): ResetFocusRequestMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 cameraId */ 1:
                    message.cameraId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResetFocusRequestMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 cameraId = 1; */
        if (message.cameraId !== 0)
            writer.tag(1, WireType.Varint).int32(message.cameraId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.ResetFocusRequestMessage
 */
export const ResetFocusRequestMessage = new ResetFocusRequestMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FocusResponseMessage$Type extends MessageType<FocusResponseMessage> {
    constructor() {
        super("VpuGrpc.FocusResponseMessage", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FocusResponseMessage>): FocusResponseMessage {
        const message = { success: false, errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FocusResponseMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FocusResponseMessage): FocusResponseMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FocusResponseMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.FocusResponseMessage
 */
export const FocusResponseMessage = new FocusResponseMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GameplayData$Type extends MessageType<GameplayData> {
    constructor() {
        super("VpuGrpc.GameplayData", [
            { no: 1, name: "homeTeam", kind: "message", T: () => Team },
            { no: 2, name: "awayTeam", kind: "message", T: () => Team },
            { no: 3, name: "time", kind: "message", T: () => GameTime }
        ]);
    }
    create(value?: PartialMessage<GameplayData>): GameplayData {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GameplayData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GameplayData): GameplayData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuGrpc.Team homeTeam */ 1:
                    message.homeTeam = Team.internalBinaryRead(reader, reader.uint32(), options, message.homeTeam);
                    break;
                case /* VpuGrpc.Team awayTeam */ 2:
                    message.awayTeam = Team.internalBinaryRead(reader, reader.uint32(), options, message.awayTeam);
                    break;
                case /* VpuGrpc.GameTime time */ 3:
                    message.time = GameTime.internalBinaryRead(reader, reader.uint32(), options, message.time);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GameplayData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuGrpc.Team homeTeam = 1; */
        if (message.homeTeam)
            Team.internalBinaryWrite(message.homeTeam, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* VpuGrpc.Team awayTeam = 2; */
        if (message.awayTeam)
            Team.internalBinaryWrite(message.awayTeam, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* VpuGrpc.GameTime time = 3; */
        if (message.time)
            GameTime.internalBinaryWrite(message.time, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.GameplayData
 */
export const GameplayData = new GameplayData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Team$Type extends MessageType<Team> {
    constructor() {
        super("VpuGrpc.Team", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "score", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<Team>): Team {
        const message = { name: "", score: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Team>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Team): Team {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* int32 score */ 2:
                    message.score = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Team, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* int32 score = 2; */
        if (message.score !== 0)
            writer.tag(2, WireType.Varint).int32(message.score);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.Team
 */
export const Team = new Team$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GameTime$Type extends MessageType<GameTime> {
    constructor() {
        super("VpuGrpc.GameTime", [
            { no: 1, name: "clock", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GameTime>): GameTime {
        const message = { clock: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GameTime>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GameTime): GameTime {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string clock */ 1:
                    message.clock = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GameTime, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string clock = 1; */
        if (message.clock !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.clock);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.GameTime
 */
export const GameTime = new GameTime$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CamerasInfoMessage$Type extends MessageType<CamerasInfoMessage> {
    constructor() {
        super("VpuGrpc.CamerasInfoMessage", [
            { no: 1, name: "camerasNum", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "headCameraInfo", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => HeadCameraInfoMessage },
            { no: 3, name: "peripheralCameraInfo", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => PeripheralCameraInfoMessage }
        ]);
    }
    create(value?: PartialMessage<CamerasInfoMessage>): CamerasInfoMessage {
        const message = { camerasNum: 0, headCameraInfo: [], peripheralCameraInfo: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CamerasInfoMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CamerasInfoMessage): CamerasInfoMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 camerasNum */ 1:
                    message.camerasNum = reader.uint32();
                    break;
                case /* repeated VpuGrpc.HeadCameraInfoMessage headCameraInfo */ 2:
                    message.headCameraInfo.push(HeadCameraInfoMessage.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated VpuGrpc.PeripheralCameraInfoMessage peripheralCameraInfo */ 3:
                    message.peripheralCameraInfo.push(PeripheralCameraInfoMessage.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CamerasInfoMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 camerasNum = 1; */
        if (message.camerasNum !== 0)
            writer.tag(1, WireType.Varint).uint32(message.camerasNum);
        /* repeated VpuGrpc.HeadCameraInfoMessage headCameraInfo = 2; */
        for (let i = 0; i < message.headCameraInfo.length; i++)
            HeadCameraInfoMessage.internalBinaryWrite(message.headCameraInfo[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated VpuGrpc.PeripheralCameraInfoMessage peripheralCameraInfo = 3; */
        for (let i = 0; i < message.peripheralCameraInfo.length; i++)
            PeripheralCameraInfoMessage.internalBinaryWrite(message.peripheralCameraInfo[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.CamerasInfoMessage
 */
export const CamerasInfoMessage = new CamerasInfoMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HeadCameraInfoMessage$Type extends MessageType<HeadCameraInfoMessage> {
    constructor() {
        super("VpuGrpc.HeadCameraInfoMessage", [
            { no: 1, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "firmware", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "tvSystemMode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "macAddress", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "revision", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "cameraModel", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<HeadCameraInfoMessage>): HeadCameraInfoMessage {
        const message = { type: "", uid: "", firmware: "", version: "", tvSystemMode: "", macAddress: "", revision: "", cameraModel: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<HeadCameraInfoMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HeadCameraInfoMessage): HeadCameraInfoMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string type */ 1:
                    message.type = reader.string();
                    break;
                case /* string uid */ 2:
                    message.uid = reader.string();
                    break;
                case /* string firmware */ 3:
                    message.firmware = reader.string();
                    break;
                case /* string version */ 4:
                    message.version = reader.string();
                    break;
                case /* string tvSystemMode */ 5:
                    message.tvSystemMode = reader.string();
                    break;
                case /* string macAddress */ 6:
                    message.macAddress = reader.string();
                    break;
                case /* string revision */ 7:
                    message.revision = reader.string();
                    break;
                case /* string cameraModel */ 8:
                    message.cameraModel = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HeadCameraInfoMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string type = 1; */
        if (message.type !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.type);
        /* string uid = 2; */
        if (message.uid !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.uid);
        /* string firmware = 3; */
        if (message.firmware !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.firmware);
        /* string version = 4; */
        if (message.version !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.version);
        /* string tvSystemMode = 5; */
        if (message.tvSystemMode !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.tvSystemMode);
        /* string macAddress = 6; */
        if (message.macAddress !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.macAddress);
        /* string revision = 7; */
        if (message.revision !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.revision);
        /* string cameraModel = 8; */
        if (message.cameraModel !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.cameraModel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.HeadCameraInfoMessage
 */
export const HeadCameraInfoMessage = new HeadCameraInfoMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PeripheralCameraInfoMessage$Type extends MessageType<PeripheralCameraInfoMessage> {
    constructor() {
        super("VpuGrpc.PeripheralCameraInfoMessage", [
            { no: 1, name: "uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "firmware", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "macAddress", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "modelName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PeripheralCameraInfoMessage>): PeripheralCameraInfoMessage {
        const message = { uid: "", firmware: "", macAddress: "", modelName: "", type: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PeripheralCameraInfoMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PeripheralCameraInfoMessage): PeripheralCameraInfoMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string uid */ 1:
                    message.uid = reader.string();
                    break;
                case /* string firmware */ 2:
                    message.firmware = reader.string();
                    break;
                case /* string macAddress */ 3:
                    message.macAddress = reader.string();
                    break;
                case /* string modelName */ 4:
                    message.modelName = reader.string();
                    break;
                case /* string type */ 5:
                    message.type = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PeripheralCameraInfoMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string uid = 1; */
        if (message.uid !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.uid);
        /* string firmware = 2; */
        if (message.firmware !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.firmware);
        /* string macAddress = 3; */
        if (message.macAddress !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.macAddress);
        /* string modelName = 4; */
        if (message.modelName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.modelName);
        /* string type = 5; */
        if (message.type !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.PeripheralCameraInfoMessage
 */
export const PeripheralCameraInfoMessage = new PeripheralCameraInfoMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraFramesRequestData$Type extends MessageType<CameraFramesRequestData> {
    constructor() {
        super("VpuGrpc.CameraFramesRequestData", [
            { no: 1, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "frameType", kind: "enum", T: () => ["VpuGrpc.FrameTypeInternal", FrameTypeInternal] },
            { no: 3, name: "replyType", kind: "enum", T: () => ["VpuGrpc.CaptureFramesReplyTypeInternal", CaptureFramesReplyTypeInternal] },
            { no: 4, name: "rotateFrames", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CameraFramesRequestData>): CameraFramesRequestData {
        const message = { requestId: "", frameType: 0, replyType: 0, rotateFrames: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CameraFramesRequestData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CameraFramesRequestData): CameraFramesRequestData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string requestId */ 1:
                    message.requestId = reader.string();
                    break;
                case /* VpuGrpc.FrameTypeInternal frameType */ 2:
                    message.frameType = reader.int32();
                    break;
                case /* VpuGrpc.CaptureFramesReplyTypeInternal replyType */ 3:
                    message.replyType = reader.int32();
                    break;
                case /* bool rotateFrames */ 4:
                    message.rotateFrames = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CameraFramesRequestData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string requestId = 1; */
        if (message.requestId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.requestId);
        /* VpuGrpc.FrameTypeInternal frameType = 2; */
        if (message.frameType !== 0)
            writer.tag(2, WireType.Varint).int32(message.frameType);
        /* VpuGrpc.CaptureFramesReplyTypeInternal replyType = 3; */
        if (message.replyType !== 0)
            writer.tag(3, WireType.Varint).int32(message.replyType);
        /* bool rotateFrames = 4; */
        if (message.rotateFrames !== false)
            writer.tag(4, WireType.Varint).bool(message.rotateFrames);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.CameraFramesRequestData
 */
export const CameraFramesRequestData = new CameraFramesRequestData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OcrModeMessage$Type extends MessageType<OcrModeMessage> {
    constructor() {
        super("VpuGrpc.OcrModeMessage", [
            { no: 1, name: "enhancedPip", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "fullPip", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "ocr", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<OcrModeMessage>): OcrModeMessage {
        const message = { enhancedPip: false, fullPip: false, ocr: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OcrModeMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OcrModeMessage): OcrModeMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enhancedPip */ 1:
                    message.enhancedPip = reader.bool();
                    break;
                case /* bool fullPip */ 2:
                    message.fullPip = reader.bool();
                    break;
                case /* bool ocr */ 3:
                    message.ocr = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OcrModeMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enhancedPip = 1; */
        if (message.enhancedPip !== false)
            writer.tag(1, WireType.Varint).bool(message.enhancedPip);
        /* bool fullPip = 2; */
        if (message.fullPip !== false)
            writer.tag(2, WireType.Varint).bool(message.fullPip);
        /* bool ocr = 3; */
        if (message.ocr !== false)
            writer.tag(3, WireType.Varint).bool(message.ocr);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.OcrModeMessage
 */
export const OcrModeMessage = new OcrModeMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GraphicsTypeOverrideMessage$Type extends MessageType<GraphicsTypeOverrideMessage> {
    constructor() {
        super("VpuGrpc.GraphicsTypeOverrideMessage", [
            { no: 1, name: "graphicsType", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GraphicsTypeOverrideMessage>): GraphicsTypeOverrideMessage {
        const message = { graphicsType: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GraphicsTypeOverrideMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GraphicsTypeOverrideMessage): GraphicsTypeOverrideMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string graphicsType */ 1:
                    message.graphicsType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GraphicsTypeOverrideMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string graphicsType = 1; */
        if (message.graphicsType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.graphicsType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.GraphicsTypeOverrideMessage
 */
export const GraphicsTypeOverrideMessage = new GraphicsTypeOverrideMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PipModeMessage$Type extends MessageType<PipModeMessage> {
    constructor() {
        super("VpuGrpc.PipModeMessage", [
            { no: 1, name: "mode", kind: "enum", T: () => ["VpuGrpc.PipModeMessage.PipMode", PipModeMessage_PipMode] }
        ]);
    }
    create(value?: PartialMessage<PipModeMessage>): PipModeMessage {
        const message = { mode: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PipModeMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PipModeMessage): PipModeMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuGrpc.PipModeMessage.PipMode mode */ 1:
                    message.mode = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PipModeMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuGrpc.PipModeMessage.PipMode mode = 1; */
        if (message.mode !== 0)
            writer.tag(1, WireType.Varint).int32(message.mode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.PipModeMessage
 */
export const PipModeMessage = new PipModeMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SystemNameResponse$Type extends MessageType<SystemNameResponse> {
    constructor() {
        super("VpuGrpc.SystemNameResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SystemNameResponse>): SystemNameResponse {
        const message = { success: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SystemNameResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SystemNameResponse): SystemNameResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SystemNameResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.SystemNameResponse
 */
export const SystemNameResponse = new SystemNameResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OcrCalibrationUpdate$Type extends MessageType<OcrCalibrationUpdate> {
    constructor() {
        super("VpuGrpc.OcrCalibrationUpdate", [
            { no: 1, name: "metadata", kind: "message", T: () => OcrCalibrationMetaData },
            { no: 2, name: "fields", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OcrCalibrationUpdate>): OcrCalibrationUpdate {
        const message = { fields: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OcrCalibrationUpdate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OcrCalibrationUpdate): OcrCalibrationUpdate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuGrpc.OcrCalibrationMetaData metadata */ 1:
                    message.metadata = OcrCalibrationMetaData.internalBinaryRead(reader, reader.uint32(), options, message.metadata);
                    break;
                case /* repeated string fields */ 2:
                    message.fields.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OcrCalibrationUpdate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuGrpc.OcrCalibrationMetaData metadata = 1; */
        if (message.metadata)
            OcrCalibrationMetaData.internalBinaryWrite(message.metadata, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string fields = 2; */
        for (let i = 0; i < message.fields.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.fields[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.OcrCalibrationUpdate
 */
export const OcrCalibrationUpdate = new OcrCalibrationUpdate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OcrCalibrationMetaData$Type extends MessageType<OcrCalibrationMetaData> {
    constructor() {
        super("VpuGrpc.OcrCalibrationMetaData", [
            { no: 1, name: "sportType", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "approvedDate", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "source", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OcrCalibrationMetaData>): OcrCalibrationMetaData {
        const message = { sportType: "", approvedDate: "", source: "", version: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<OcrCalibrationMetaData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OcrCalibrationMetaData): OcrCalibrationMetaData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sportType */ 1:
                    message.sportType = reader.string();
                    break;
                case /* string approvedDate */ 2:
                    message.approvedDate = reader.string();
                    break;
                case /* string source */ 3:
                    message.source = reader.string();
                    break;
                case /* string version */ 4:
                    message.version = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OcrCalibrationMetaData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sportType = 1; */
        if (message.sportType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sportType);
        /* string approvedDate = 2; */
        if (message.approvedDate !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.approvedDate);
        /* string source = 3; */
        if (message.source !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.source);
        /* string version = 4; */
        if (message.version !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.version);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.OcrCalibrationMetaData
 */
export const OcrCalibrationMetaData = new OcrCalibrationMetaData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RtspLinksCameraInfo$Type extends MessageType<RtspLinksCameraInfo> {
    constructor() {
        super("VpuGrpc.RtspLinksCameraInfo", [
            { no: 1, name: "liveRtspLinks", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => RtspLinkInfo }
        ]);
    }
    create(value?: PartialMessage<RtspLinksCameraInfo>): RtspLinksCameraInfo {
        const message = { liveRtspLinks: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RtspLinksCameraInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RtspLinksCameraInfo): RtspLinksCameraInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated CommonUsedMessages.RtspLinkInfo liveRtspLinks */ 1:
                    message.liveRtspLinks.push(RtspLinkInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RtspLinksCameraInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated CommonUsedMessages.RtspLinkInfo liveRtspLinks = 1; */
        for (let i = 0; i < message.liveRtspLinks.length; i++)
            RtspLinkInfo.internalBinaryWrite(message.liveRtspLinks[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.RtspLinksCameraInfo
 */
export const RtspLinksCameraInfo = new RtspLinksCameraInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VenueCalibrationDataInfo$Type extends MessageType<VenueCalibrationDataInfo> {
    constructor() {
        super("VpuGrpc.VenueCalibrationDataInfo", [
            { no: 1, name: "venueDataCalibration", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => VenueCalibrationData }
        ]);
    }
    create(value?: PartialMessage<VenueCalibrationDataInfo>): VenueCalibrationDataInfo {
        const message = { venueDataCalibration: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VenueCalibrationDataInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VenueCalibrationDataInfo): VenueCalibrationDataInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated CommonUsedMessages.VenueCalibrationData venueDataCalibration */ 1:
                    message.venueDataCalibration.push(VenueCalibrationData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VenueCalibrationDataInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated CommonUsedMessages.VenueCalibrationData venueDataCalibration = 1; */
        for (let i = 0; i < message.venueDataCalibration.length; i++)
            VenueCalibrationData.internalBinaryWrite(message.venueDataCalibration[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.VenueCalibrationDataInfo
 */
export const VenueCalibrationDataInfo = new VenueCalibrationDataInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetVenueLogsByDurationRequest$Type extends MessageType<GetVenueLogsByDurationRequest> {
    constructor() {
        super("VpuGrpc.GetVenueLogsByDurationRequest", [
            { no: 1, name: "offsetDurationType", kind: "enum", T: () => ["VpuGrpc.GetVenueLogsByDurationRequest.DurationType", GetVenueLogsByDurationRequest_DurationType] },
            { no: 2, name: "offsetDurationUnits", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<GetVenueLogsByDurationRequest>): GetVenueLogsByDurationRequest {
        const message = { offsetDurationType: 0, offsetDurationUnits: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetVenueLogsByDurationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetVenueLogsByDurationRequest): GetVenueLogsByDurationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuGrpc.GetVenueLogsByDurationRequest.DurationType offsetDurationType */ 1:
                    message.offsetDurationType = reader.int32();
                    break;
                case /* int64 offsetDurationUnits */ 2:
                    message.offsetDurationUnits = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetVenueLogsByDurationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuGrpc.GetVenueLogsByDurationRequest.DurationType offsetDurationType = 1; */
        if (message.offsetDurationType !== 0)
            writer.tag(1, WireType.Varint).int32(message.offsetDurationType);
        /* int64 offsetDurationUnits = 2; */
        if (message.offsetDurationUnits !== 0n)
            writer.tag(2, WireType.Varint).int64(message.offsetDurationUnits);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.GetVenueLogsByDurationRequest
 */
export const GetVenueLogsByDurationRequest = new GetVenueLogsByDurationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetVenueLogsByDurationResponse$Type extends MessageType<GetVenueLogsByDurationResponse> {
    constructor() {
        super("VpuGrpc.GetVenueLogsByDurationResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "zipFileBytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetVenueLogsByDurationResponse>): GetVenueLogsByDurationResponse {
        const message = { success: false, zipFileBytes: new Uint8Array(0) };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetVenueLogsByDurationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetVenueLogsByDurationResponse): GetVenueLogsByDurationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* bytes zipFileBytes */ 2:
                    message.zipFileBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetVenueLogsByDurationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* bytes zipFileBytes = 2; */
        if (message.zipFileBytes.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.zipFileBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.GetVenueLogsByDurationResponse
 */
export const GetVenueLogsByDurationResponse = new GetVenueLogsByDurationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetVenueLogsReplyMessage$Type extends MessageType<GetVenueLogsReplyMessage> {
    constructor() {
        super("VpuGrpc.GetVenueLogsReplyMessage", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "userMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "dataChunk", kind: "message", T: () => DataChunkMessage },
            { no: 4, name: "archiveName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetVenueLogsReplyMessage>): GetVenueLogsReplyMessage {
        const message = { success: false, userMessage: "", archiveName: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetVenueLogsReplyMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetVenueLogsReplyMessage): GetVenueLogsReplyMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string userMessage */ 2:
                    message.userMessage = reader.string();
                    break;
                case /* CommonUsedMessages.DataChunkMessage dataChunk */ 3:
                    message.dataChunk = DataChunkMessage.internalBinaryRead(reader, reader.uint32(), options, message.dataChunk);
                    break;
                case /* string archiveName */ 4:
                    message.archiveName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetVenueLogsReplyMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string userMessage = 2; */
        if (message.userMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userMessage);
        /* CommonUsedMessages.DataChunkMessage dataChunk = 3; */
        if (message.dataChunk)
            DataChunkMessage.internalBinaryWrite(message.dataChunk, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string archiveName = 4; */
        if (message.archiveName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.archiveName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.GetVenueLogsReplyMessage
 */
export const GetVenueLogsReplyMessage = new GetVenueLogsReplyMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetVenueLogsByDateRequest$Type extends MessageType<GetVenueLogsByDateRequest> {
    constructor() {
        super("VpuGrpc.GetVenueLogsByDateRequest", [
            { no: 1, name: "timestamp", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<GetVenueLogsByDateRequest>): GetVenueLogsByDateRequest {
        const message = { timestamp: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetVenueLogsByDateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetVenueLogsByDateRequest): GetVenueLogsByDateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 timestamp */ 1:
                    message.timestamp = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetVenueLogsByDateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint64 timestamp = 1; */
        if (message.timestamp !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.timestamp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.GetVenueLogsByDateRequest
 */
export const GetVenueLogsByDateRequest = new GetVenueLogsByDateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetVenueLogsByDateResponse$Type extends MessageType<GetVenueLogsByDateResponse> {
    constructor() {
        super("VpuGrpc.GetVenueLogsByDateResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "zipFileBytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 3, name: "archiveName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetVenueLogsByDateResponse>): GetVenueLogsByDateResponse {
        const message = { success: false, zipFileBytes: new Uint8Array(0), archiveName: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetVenueLogsByDateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetVenueLogsByDateResponse): GetVenueLogsByDateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* bytes zipFileBytes */ 2:
                    message.zipFileBytes = reader.bytes();
                    break;
                case /* string archiveName */ 3:
                    message.archiveName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetVenueLogsByDateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* bytes zipFileBytes = 2; */
        if (message.zipFileBytes.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.zipFileBytes);
        /* string archiveName = 3; */
        if (message.archiveName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.archiveName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.GetVenueLogsByDateResponse
 */
export const GetVenueLogsByDateResponse = new GetVenueLogsByDateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetHeaterDataRequest$Type extends MessageType<GetHeaterDataRequest> {
    constructor() {
        super("VpuGrpc.GetHeaterDataRequest", [
            { no: 1, name: "heaterNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetHeaterDataRequest>): GetHeaterDataRequest {
        const message = { heaterNumber: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetHeaterDataRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetHeaterDataRequest): GetHeaterDataRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 heaterNumber */ 1:
                    message.heaterNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetHeaterDataRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 heaterNumber = 1; */
        if (message.heaterNumber !== 0)
            writer.tag(1, WireType.Varint).int32(message.heaterNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.GetHeaterDataRequest
 */
export const GetHeaterDataRequest = new GetHeaterDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetHeaterModeRequest$Type extends MessageType<SetHeaterModeRequest> {
    constructor() {
        super("VpuGrpc.SetHeaterModeRequest", [
            { no: 1, name: "mode", kind: "enum", T: () => ["VpuGrpc.HeaterModes", HeaterModes] }
        ]);
    }
    create(value?: PartialMessage<SetHeaterModeRequest>): SetHeaterModeRequest {
        const message = { mode: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SetHeaterModeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetHeaterModeRequest): SetHeaterModeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuGrpc.HeaterModes mode */ 1:
                    message.mode = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetHeaterModeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuGrpc.HeaterModes mode = 1; */
        if (message.mode !== 0)
            writer.tag(1, WireType.Varint).int32(message.mode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.SetHeaterModeRequest
 */
export const SetHeaterModeRequest = new SetHeaterModeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAudioEqualizerModeRequest$Type extends MessageType<SetAudioEqualizerModeRequest> {
    constructor() {
        super("VpuGrpc.SetAudioEqualizerModeRequest", [
            { no: 1, name: "mode", kind: "enum", T: () => ["VpuGrpc.AudioEqualizerModes", AudioEqualizerModes] }
        ]);
    }
    create(value?: PartialMessage<SetAudioEqualizerModeRequest>): SetAudioEqualizerModeRequest {
        const message = { mode: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SetAudioEqualizerModeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetAudioEqualizerModeRequest): SetAudioEqualizerModeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* VpuGrpc.AudioEqualizerModes mode */ 1:
                    message.mode = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetAudioEqualizerModeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* VpuGrpc.AudioEqualizerModes mode = 1; */
        if (message.mode !== 0)
            writer.tag(1, WireType.Varint).int32(message.mode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.SetAudioEqualizerModeRequest
 */
export const SetAudioEqualizerModeRequest = new SetAudioEqualizerModeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetHeaterDataResponse$Type extends MessageType<GetHeaterDataResponse> {
    constructor() {
        super("VpuGrpc.GetHeaterDataResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "heaterTemperature", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "mode", kind: "enum", T: () => ["VpuGrpc.HeaterModes", HeaterModes] },
            { no: 5, name: "heaterOn", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetHeaterDataResponse>): GetHeaterDataResponse {
        const message = { success: false, errorMessage: "", heaterTemperature: 0, mode: 0, heaterOn: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetHeaterDataResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetHeaterDataResponse): GetHeaterDataResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* float heaterTemperature */ 3:
                    message.heaterTemperature = reader.float();
                    break;
                case /* VpuGrpc.HeaterModes mode */ 4:
                    message.mode = reader.int32();
                    break;
                case /* bool heaterOn */ 5:
                    message.heaterOn = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetHeaterDataResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* float heaterTemperature = 3; */
        if (message.heaterTemperature !== 0)
            writer.tag(3, WireType.Bit32).float(message.heaterTemperature);
        /* VpuGrpc.HeaterModes mode = 4; */
        if (message.mode !== 0)
            writer.tag(4, WireType.Varint).int32(message.mode);
        /* bool heaterOn = 5; */
        if (message.heaterOn !== false)
            writer.tag(5, WireType.Varint).bool(message.heaterOn);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.GetHeaterDataResponse
 */
export const GetHeaterDataResponse = new GetHeaterDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetHeaterDataStartRequest$Type extends MessageType<GetHeaterDataStartRequest> {
    constructor() {
        super("VpuGrpc.GetHeaterDataStartRequest", []);
    }
    create(value?: PartialMessage<GetHeaterDataStartRequest>): GetHeaterDataStartRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetHeaterDataStartRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetHeaterDataStartRequest): GetHeaterDataStartRequest {
        return target ?? this.create();
    }
    internalBinaryWrite(message: GetHeaterDataStartRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.GetHeaterDataStartRequest
 */
export const GetHeaterDataStartRequest = new GetHeaterDataStartRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetHeaterDataStopRequest$Type extends MessageType<GetHeaterDataStopRequest> {
    constructor() {
        super("VpuGrpc.GetHeaterDataStopRequest", []);
    }
    create(value?: PartialMessage<GetHeaterDataStopRequest>): GetHeaterDataStopRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetHeaterDataStopRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetHeaterDataStopRequest): GetHeaterDataStopRequest {
        return target ?? this.create();
    }
    internalBinaryWrite(message: GetHeaterDataStopRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.GetHeaterDataStopRequest
 */
export const GetHeaterDataStopRequest = new GetHeaterDataStopRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LoginToAbeRequest$Type extends MessageType<LoginToAbeRequest> {
    constructor() {
        super("VpuGrpc.LoginToAbeRequest", [
            { no: 1, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "password", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "systemName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<LoginToAbeRequest>): LoginToAbeRequest {
        const message = { username: "", password: "", systemName: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<LoginToAbeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LoginToAbeRequest): LoginToAbeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string username */ 1:
                    message.username = reader.string();
                    break;
                case /* string password */ 2:
                    message.password = reader.string();
                    break;
                case /* string systemName */ 3:
                    message.systemName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LoginToAbeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string username = 1; */
        if (message.username !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.username);
        /* string password = 2; */
        if (message.password !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.password);
        /* string systemName = 3; */
        if (message.systemName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.systemName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.LoginToAbeRequest
 */
export const LoginToAbeRequest = new LoginToAbeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LoginToAbeResponse$Type extends MessageType<LoginToAbeResponse> {
    constructor() {
        super("VpuGrpc.LoginToAbeResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "tenants", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<LoginToAbeResponse>): LoginToAbeResponse {
        const message = { success: false, errorMessage: "", token: "", tenants: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<LoginToAbeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LoginToAbeResponse): LoginToAbeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* string token */ 3:
                    message.token = reader.string();
                    break;
                case /* repeated string tenants */ 4:
                    message.tenants.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LoginToAbeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* string token = 3; */
        if (message.token !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.token);
        /* repeated string tenants = 4; */
        for (let i = 0; i < message.tenants.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.tenants[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.LoginToAbeResponse
 */
export const LoginToAbeResponse = new LoginToAbeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivateSystemOnAbeRequest$Type extends MessageType<ActivateSystemOnAbeRequest> {
    constructor() {
        super("VpuGrpc.ActivateSystemOnAbeRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "systemName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ActivateSystemOnAbeRequest>): ActivateSystemOnAbeRequest {
        const message = { token: "", systemName: "", tenant: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ActivateSystemOnAbeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActivateSystemOnAbeRequest): ActivateSystemOnAbeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string systemName */ 2:
                    message.systemName = reader.string();
                    break;
                case /* string tenant */ 3:
                    message.tenant = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActivateSystemOnAbeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string systemName = 2; */
        if (message.systemName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.systemName);
        /* string tenant = 3; */
        if (message.tenant !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.tenant);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.ActivateSystemOnAbeRequest
 */
export const ActivateSystemOnAbeRequest = new ActivateSystemOnAbeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivateSystemOnAbeResponse$Type extends MessageType<ActivateSystemOnAbeResponse> {
    constructor() {
        super("VpuGrpc.ActivateSystemOnAbeResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "systemName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ActivateSystemOnAbeResponse>): ActivateSystemOnAbeResponse {
        const message = { success: false, errorMessage: "", systemName: "", tenant: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ActivateSystemOnAbeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActivateSystemOnAbeResponse): ActivateSystemOnAbeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* string systemName */ 3:
                    message.systemName = reader.string();
                    break;
                case /* string tenant */ 4:
                    message.tenant = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActivateSystemOnAbeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* string systemName = 3; */
        if (message.systemName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.systemName);
        /* string tenant = 4; */
        if (message.tenant !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.tenant);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.ActivateSystemOnAbeResponse
 */
export const ActivateSystemOnAbeResponse = new ActivateSystemOnAbeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventArchitectureMessage$Type extends MessageType<EventArchitectureMessage> {
    constructor() {
        super("VpuGrpc.EventArchitectureMessage", [
            { no: 1, name: "architecture", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EventArchitectureMessage>): EventArchitectureMessage {
        const message = { architecture: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<EventArchitectureMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EventArchitectureMessage): EventArchitectureMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string architecture */ 1:
                    message.architecture = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EventArchitectureMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string architecture = 1; */
        if (message.architecture !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.architecture);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.EventArchitectureMessage
 */
export const EventArchitectureMessage = new EventArchitectureMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartMetadataWritingRequest$Type extends MessageType<StartMetadataWritingRequest> {
    constructor() {
        super("VpuGrpc.StartMetadataWritingRequest", [
            { no: 1, name: "eventId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "metadataFolderPath", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<StartMetadataWritingRequest>): StartMetadataWritingRequest {
        const message = { eventId: "", metadataFolderPath: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StartMetadataWritingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StartMetadataWritingRequest): StartMetadataWritingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string eventId */ 1:
                    message.eventId = reader.string();
                    break;
                case /* string metadataFolderPath */ 2:
                    message.metadataFolderPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StartMetadataWritingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string eventId = 1; */
        if (message.eventId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.eventId);
        /* string metadataFolderPath = 2; */
        if (message.metadataFolderPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.metadataFolderPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.StartMetadataWritingRequest
 */
export const StartMetadataWritingRequest = new StartMetadataWritingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopMetadataWritingRequest$Type extends MessageType<StopMetadataWritingRequest> {
    constructor() {
        super("VpuGrpc.StopMetadataWritingRequest", [
            { no: 1, name: "eventId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<StopMetadataWritingRequest>): StopMetadataWritingRequest {
        const message = { eventId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StopMetadataWritingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StopMetadataWritingRequest): StopMetadataWritingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string eventId */ 1:
                    message.eventId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StopMetadataWritingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string eventId = 1; */
        if (message.eventId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.eventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.StopMetadataWritingRequest
 */
export const StopMetadataWritingRequest = new StopMetadataWritingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnableOcrAiForPipResponse$Type extends MessageType<EnableOcrAiForPipResponse> {
    constructor() {
        super("VpuGrpc.EnableOcrAiForPipResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "errorMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EnableOcrAiForPipResponse>): EnableOcrAiForPipResponse {
        const message = { success: false, errorMessage: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<EnableOcrAiForPipResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EnableOcrAiForPipResponse): EnableOcrAiForPipResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string errorMessage */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EnableOcrAiForPipResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string errorMessage = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VpuGrpc.EnableOcrAiForPipResponse
 */
export const EnableOcrAiForPipResponse = new EnableOcrAiForPipResponse$Type();
/**
 * @generated ServiceType for protobuf service VpuGrpc.VPUControl
 */
export const VPUControl = new ServiceType("VpuGrpc.VPUControl", [
    { name: "SetStreamConfig", options: {}, I: StreamConfig, O: VPUStatus },
    { name: "GetStreams", options: {}, I: Empty, O: Streams },
    { name: "CloseUnit", options: {}, I: Agent2VpuReason, O: VPUStatus },
    { name: "SetAudioEnabled", options: {}, I: AudioEnabledMessage, O: VPUStatus },
    { name: "AgentUi2VpuCommand", options: {}, I: AgentUi2VpuCommandMessage, O: VPUStatus },
    { name: "AgentUi2VpuGetGeneralInfo", options: {}, I: IsAdvancedFlag, O: Vpu2AgentUiGeneralInfo },
    { name: "AgentUi2VpuGetCommandList", options: {}, I: Empty, O: Vpu2AgentUiCommandListMessage },
    { name: "CheckHeartBeat", options: {}, I: Empty, O: VPUStatus },
    { name: "GetHealth", options: {}, I: Empty, O: Vpu2AgentHealth },
    { name: "AddStream", options: {}, I: AddStreamMessage, O: VPUStatus },
    { name: "GetCurrentDoublePlayApChosenCamera", options: {}, I: Empty, O: ChosenDoublePlayAPCameraMessage },
    { name: "RemoveStream", options: {}, I: RemoveStreamMessage, O: VPUStatus },
    { name: "SendGraphicsInfo", options: {}, I: GraphicsInfoMessage, O: GraphicsInfoMessage },
    { name: "SetAutoProductionEnabled", options: {}, I: AutoProductionEnabledMessage, O: VPUStatus },
    { name: "SetAutoLightControlMode", options: {}, I: AutoLightControlModeMessage, O: VPUStatus },
    { name: "CaptureCameraImages", options: {}, I: AgentToVPUGenericCommandDetails, O: VPUCCUDataMessage },
    { name: "UpdateCCUDataAndGetPanorama", options: {}, I: VPUCCUDataMessage, O: VPUCCUDataMessage },
    { name: "UpdateScoreboardStatus", options: {}, I: ScoreboardStatusMessage, O: VPUStatus },
    { name: "SendCueOut", options: {}, I: CueOutMessage, O: VPUStatus },
    { name: "SendCueIn", options: {}, I: CueInMessage, O: VPUStatus },
    { name: "SendGameplayData", options: {}, I: GameplayData, O: VPUStatus },
    { name: "UpdateMetadataFolder", options: {}, I: Empty, O: VPUStatus },
    { name: "StartMetadataWriting", options: {}, I: StartMetadataWritingRequest, O: VPUStatus },
    { name: "StopMetadataWriting", options: {}, I: StopMetadataWritingRequest, O: VPUStatus },
    { name: "GetCameraDeviceVersion", options: {}, I: Empty, O: Vpu2AgentCameraVersion },
    { name: "StartInstantHighlights", options: {}, I: InstantHighlightsMessage, O: VPUStatus },
    { name: "StopInstantHighlights", options: {}, I: Empty, O: VPUStatus },
    { name: "GetFieldOfView", options: {}, I: Empty, O: MinMaxValues },
    { name: "GetCamerasParameters", options: {}, I: Empty, O: CamerasParametersMessage },
    { name: "SetCameraParameters", options: {}, I: SetCameraParametersMessage, O: VPUStatus },
    { name: "SetCameraParameter", options: {}, I: SetCameraSingleParameterMessage, O: VPUStatus },
    { name: "SetCamerasOrder", options: {}, I: SetCamerasOrderMessage, O: SetCamerasOrderResponseMessage },
    { name: "GetListOfCameraDetails", options: {}, I: Empty, O: CameraDetailsListReplyMessage },
    { name: "FlipCamera", options: {}, I: FlipCameraMessage, O: VPUStatus },
    { name: "SetAudioVolume", options: {}, I: AudioValueMessage, O: VPUStatus },
    { name: "SetAudioGain", options: {}, I: AudioValueMessage, O: VPUStatus },
    { name: "GetHeaterData", options: {}, I: GetHeaterDataRequest, O: GetHeaterDataResponse },
    { name: "SetHeaterMode", options: {}, I: SetHeaterModeRequest, O: VPUStatus },
    { name: "SetAudioEqualizerMode", options: {}, I: SetAudioEqualizerModeRequest, O: VPUStatus },
    { name: "ReloadVirtualGraphics", options: {}, I: Empty, O: VPUStatus }
]);
/**
 * @generated ServiceType for protobuf service VpuGrpc.VpuSignals
 */
export const VpuSignals = new ServiceType("VpuGrpc.VpuSignals", [
    { name: "ReportReady", options: {}, I: Empty, O: VPUStatus },
    { name: "ReportExit", options: {}, I: Empty, O: VPUStatus }
]);
/**
 * @generated ServiceType for protobuf service VpuGrpc.CalibrationSignals
 */
export const CalibrationSignals = new ServiceType("VpuGrpc.CalibrationSignals", [
    { name: "ReportApproved", options: {}, I: Empty, O: VPUStatus }
]);
/**
 * @generated ServiceType for protobuf service VpuGrpc.StitcherRtControl
 */
export const StitcherRtControl = new ServiceType("VpuGrpc.StitcherRtControl", [
    { name: "CloseUnit", options: {}, I: Agent2VpuReason, O: VPUStatus },
    { name: "AgentUi2VpuGetGeneralInfo", options: {}, I: IsAdvancedFlag, O: Vpu2AgentUiGeneralInfo }
]);
/**
 * @generated ServiceType for protobuf service VpuGrpc.AgentServiceInterface
 */
export const AgentServiceInterface = new ServiceType("VpuGrpc.AgentServiceInterface", [
    { name: "AgentGui2AgentServiceCommand", options: {}, I: AgentGui2AgentServiceCommandMessage, O: VPUStatus },
    { name: "UpdateAdditionalAngles", options: {}, I: CoachingAdditionalAngleListMessage, O: VPUStatus },
    { name: "UpdateCCUData", options: {}, I: VPUCCUDataMessage, O: VPUStatus },
    { name: "HandleCameraFramesRequest", options: {}, I: CameraFramesRequestData, O: VPUStatus },
    { name: "UpdateGraphicsInfo", options: {}, I: GraphicsInfoMessage, O: VPUStatus },
    { name: "UpdateOcrCalibration", options: {}, I: OcrCalibrationUpdate, O: VPUStatus },
    { name: "SendCamerasInfo", options: {}, I: CamerasInfoMessage, O: VPUStatus },
    { name: "GetLiveRtspLinks", options: {}, I: Empty, O: RtspLinksCameraInfo },
    { name: "GetVenueCalibrationData", options: {}, I: Empty, O: VenueCalibrationDataInfo },
    { name: "IsServiceRunning", options: {}, I: ServiceName, O: VPUStatus },
    { name: "IsServiceExists", options: {}, I: ServiceName, O: VPUStatus },
    { name: "StartService", options: {}, I: ServiceName, O: Empty },
    { name: "StopService", options: {}, I: ServiceName, O: Empty },
    { name: "GetVenueLogsByDuration", options: {}, I: GetVenueLogsByDurationRequest, O: GetVenueLogsByDurationResponse },
    { name: "GetVenueLogsByDate", options: {}, I: GetVenueLogsByDateRequest, O: GetVenueLogsByDateResponse },
    { name: "LoginToAbe", options: {}, I: LoginToAbeRequest, O: LoginToAbeResponse },
    { name: "ActivateSystemOnAbe", options: {}, I: ActivateSystemOnAbeRequest, O: ActivateSystemOnAbeResponse },
    { name: "UpdateEventArchitecture", options: {}, I: EventArchitectureMessage, O: VPUStatus },
    { name: "PauseOcrProcessing", options: {}, I: Empty, O: CommonStatus },
    { name: "ResumeOcrProcessing", options: {}, I: Empty, O: CommonStatus },
    { name: "EnableOcrAiForPip", options: {}, I: Empty, O: EnableOcrAiForPipResponse },
    { name: "DisableOcrAiForPip", options: {}, I: Empty, O: CommonStatus }
]);
/**
 * @generated ServiceType for protobuf service VpuGrpc.AgentGuiInterface
 */
export const AgentGuiInterface = new ServiceType("VpuGrpc.AgentGuiInterface", [
    { name: "AgentService2AgentGuiInfo", options: {}, I: AgentService2AgentGuiInfoMessage, O: VPUStatus },
    { name: "ExecuteFirstRegistration", options: {}, I: Empty, O: Empty },
    { name: "SetRMAStatus", options: {}, I: Empty, O: Empty },
    { name: "AgentService2AgentGuiEventRecord", options: {}, I: AgentService2AgentGuiEventRecordMessage, O: VPUStatus },
    { name: "Agent2CoordinatorGeneralInfo", options: {}, I: Vpu2AgentUiGeneralInfo, O: VPUStatus },
    { name: "Agent2CoordinatorAdditionalAngleInfo", options: {}, I: CoachingAdditionalAngleListMessage, O: VPUStatus },
    { name: "Agent2CoordinatorCCUInfo", options: {}, I: VPUCCUDataMessage, O: VPUStatus },
    { name: "StartVpu", options: {}, I: Empty, O: VPUStatus },
    { name: "StopVpu", options: {}, I: Empty, O: VPUStatus },
    { name: "GetVenueId", options: {}, I: Empty, O: VPUStatus },
    { name: "GetVenueDashboardUrl", options: {}, I: Empty, O: VPUStatus },
    { name: "GetIsFirstRelease", options: {}, I: Empty, O: VPUStatus },
    { name: "SetIsFirstRelease", options: {}, I: SetIsFirstReleaseRequest, O: VPUStatus },
    { name: "Agent2CoordinatorSystemRenameResponse", options: {}, I: SystemNameResponse, O: VPUStatus },
    { name: "Agent2CoordinatorGetCamerasInfo", options: {}, I: VPUStatus, O: VPUStatus },
    { name: "Agent2CoordinatorSetCHUUpdateProgress", options: {}, I: CHUProgressUpdate, O: Empty },
    { name: "Agent2CoordinatorResetWifiHotspot", options: {}, I: WifiHotspotDetails, O: Empty },
    { name: "Agent2CoordinatorTriggerPairing", options: {}, I: CameraPartNumber, O: Empty },
    { name: "Agent2CoordinatorDeleteEventClipperJobs", options: {}, I: EventId, O: Empty },
    { name: "CheckHardwareDevices", options: {}, I: Empty, O: VPUStatus },
    { name: "ChangeSystemLifeCycleStatus", options: {}, I: SystemLifeCycleStatus, O: Empty },
    { name: "RunSystemTest", options: {}, I: Empty, O: Empty },
    { name: "RestartNetworkManager", options: {}, I: Empty, O: VPUStatus }
]);
/**
 * @generated ServiceType for protobuf service VpuGrpc.LicenseReporterInterface
 */
export const LicenseReporterInterface = new ServiceType("VpuGrpc.LicenseReporterInterface", [
    { name: "LicenseRequest", options: {}, I: Empty, O: LocalLicenseInfoMessage }
]);
/**
 * @generated ServiceType for protobuf service VpuGrpc.GraphicsInterface
 */
export const GraphicsInterface = new ServiceType("VpuGrpc.GraphicsInterface", [
    { name: "GraphicsInfo", options: {}, I: GraphicsInfoMessage, O: GraphicsInfoMessage },
    { name: "PingPip", options: {}, I: Empty, O: CommonStatus },
    { name: "RequestFrame", options: {}, I: Empty, O: PipFrameResponse },
    { name: "RequestFrameByTimestamp", options: {}, I: FrameTimestampRequest, O: PipFrameResponse },
    { name: "MarkAndSaveOcrCalibration", options: {}, I: CoordinatesType, O: PipMarkAndSaveOcrCalibrationResponse },
    { name: "EnableOcrAlc", options: {}, I: Empty, O: CommonStatus },
    { name: "DisableOcrAlc", options: {}, I: Empty, O: CommonStatus },
    { name: "PauseOcrProcessing", options: {}, I: Empty, O: CommonStatus },
    { name: "ResumeOcrProcessing", options: {}, I: Empty, O: CommonStatus },
    { name: "CalibrateScoreboard", options: {}, I: OcrAiCalibrateRequest, O: OcrAiCalibrateResponse },
    { name: "SetSportType", options: {}, I: OcrAiSetSportTypeRequest, O: OcrAiSetSportTypeResponse },
    { name: "SetOcrAiSwapHomeAway", options: {}, I: OcrAiSetSwapHomeAwayRequest, O: OcrAiSetSwapHomeAwayResponse },
    { name: "SetScoreboardMode", options: {}, I: PipScoreboardModeMessage, O: VPUStatus },
    { name: "GetChuOcrFrame", options: {}, I: Empty, O: ChuOcrFrameResponse },
    { name: "ReloadChuCalibration", options: {}, I: Empty, O: CommonStatus },
    { name: "LockFeedSource", options: {}, I: FeedSourceLockRequest, O: CommonStatus }
]);
/**
 * @generated ServiceType for protobuf service VpuGrpc.VPU2CoordinatorInterface
 */
export const VPU2CoordinatorInterface = new ServiceType("VpuGrpc.VPU2CoordinatorInterface", [
    { name: "PhasesReporter", options: {}, I: PhaseInfoMessage, O: VPUStatus }
]);
/**
 * @generated ServiceType for protobuf service VpuGrpc.WombatFirmwareInterface
 */
export const WombatFirmwareInterface = new ServiceType("VpuGrpc.WombatFirmwareInterface", [
    { name: "UpdateChuUpgradeStatus", options: {}, I: ChuUpgradeStatusMessage, O: VPUStatus },
    { name: "GetCurrentChuStatus", options: {}, I: Empty, O: ChuUpgradeStatusMessage }
]);
